webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(72)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone)
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = new Date(timestamp + time).getTimezoneOffset()
      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
    }

    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(201);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(58)('wks');
var uid = __webpack_require__(42);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(6);
var ctx = __webpack_require__(27);
var hide = __webpack_require__(15);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(109);
var toPrimitive = __webpack_require__(61);
var dP = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(21)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(10);
var createDesc = __webpack_require__(30);
module.exports = __webpack_require__(13) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var startOfISOWeek = __webpack_require__(19)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(47)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(209), __esModule: true };

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(110);
var defined = __webpack_require__(52);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);


/* harmony default export */ __webpack_exports__["a"] = (function (number) {
    return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(number).format("0,0");
});

/***/ }),
/* 26 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(37);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(117);
var enumBugKeys = __webpack_require__(54);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(17)
var startOfISOWeek = __webpack_require__(19)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(10).f;
var has = __webpack_require__(14);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(52);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var getDaysInMonth = __webpack_require__(70)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(18)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(31),
  addHours: __webpack_require__(127),
  addISOYears: __webpack_require__(128),
  addMilliseconds: __webpack_require__(32),
  addMinutes: __webpack_require__(129),
  addMonths: __webpack_require__(43),
  addQuarters: __webpack_require__(130),
  addSeconds: __webpack_require__(131),
  addWeeks: __webpack_require__(65),
  addYears: __webpack_require__(132),
  areRangesOverlapping: __webpack_require__(247),
  closestIndexTo: __webpack_require__(248),
  closestTo: __webpack_require__(249),
  compareAsc: __webpack_require__(33),
  compareDesc: __webpack_require__(66),
  differenceInCalendarDays: __webpack_require__(44),
  differenceInCalendarISOWeeks: __webpack_require__(250),
  differenceInCalendarISOYears: __webpack_require__(133),
  differenceInCalendarMonths: __webpack_require__(134),
  differenceInCalendarQuarters: __webpack_require__(251),
  differenceInCalendarWeeks: __webpack_require__(252),
  differenceInCalendarYears: __webpack_require__(135),
  differenceInDays: __webpack_require__(136),
  differenceInHours: __webpack_require__(253),
  differenceInISOYears: __webpack_require__(254),
  differenceInMilliseconds: __webpack_require__(45),
  differenceInMinutes: __webpack_require__(255),
  differenceInMonths: __webpack_require__(67),
  differenceInQuarters: __webpack_require__(256),
  differenceInSeconds: __webpack_require__(68),
  differenceInWeeks: __webpack_require__(257),
  differenceInYears: __webpack_require__(258),
  distanceInWords: __webpack_require__(137),
  distanceInWordsStrict: __webpack_require__(259),
  distanceInWordsToNow: __webpack_require__(260),
  eachDay: __webpack_require__(261),
  endOfDay: __webpack_require__(69),
  endOfHour: __webpack_require__(262),
  endOfISOWeek: __webpack_require__(263),
  endOfISOYear: __webpack_require__(264),
  endOfMinute: __webpack_require__(265),
  endOfMonth: __webpack_require__(138),
  endOfQuarter: __webpack_require__(266),
  endOfSecond: __webpack_require__(267),
  endOfToday: __webpack_require__(268),
  endOfTomorrow: __webpack_require__(269),
  endOfWeek: __webpack_require__(139),
  endOfYear: __webpack_require__(270),
  endOfYesterday: __webpack_require__(271),
  format: __webpack_require__(272),
  getDate: __webpack_require__(273),
  getDay: __webpack_require__(274),
  getDayOfYear: __webpack_require__(140),
  getDaysInMonth: __webpack_require__(70),
  getDaysInYear: __webpack_require__(275),
  getHours: __webpack_require__(276),
  getISODay: __webpack_require__(141),
  getISOWeek: __webpack_require__(71),
  getISOWeeksInYear: __webpack_require__(277),
  getISOYear: __webpack_require__(17),
  getMilliseconds: __webpack_require__(278),
  getMinutes: __webpack_require__(279),
  getMonth: __webpack_require__(280),
  getOverlappingDaysInRanges: __webpack_require__(281),
  getQuarter: __webpack_require__(142),
  getSeconds: __webpack_require__(282),
  getTime: __webpack_require__(283),
  getYear: __webpack_require__(284),
  isAfter: __webpack_require__(285),
  isBefore: __webpack_require__(286),
  isDate: __webpack_require__(72),
  isEqual: __webpack_require__(287),
  isFirstDayOfMonth: __webpack_require__(288),
  isFriday: __webpack_require__(289),
  isFuture: __webpack_require__(290),
  isLastDayOfMonth: __webpack_require__(291),
  isLeapYear: __webpack_require__(143),
  isMonday: __webpack_require__(292),
  isPast: __webpack_require__(293),
  isSameDay: __webpack_require__(294),
  isSameHour: __webpack_require__(144),
  isSameISOWeek: __webpack_require__(145),
  isSameISOYear: __webpack_require__(146),
  isSameMinute: __webpack_require__(147),
  isSameMonth: __webpack_require__(148),
  isSameQuarter: __webpack_require__(149),
  isSameSecond: __webpack_require__(150),
  isSameWeek: __webpack_require__(73),
  isSameYear: __webpack_require__(151),
  isSaturday: __webpack_require__(295),
  isSunday: __webpack_require__(296),
  isThisHour: __webpack_require__(297),
  isThisISOWeek: __webpack_require__(298),
  isThisISOYear: __webpack_require__(299),
  isThisMinute: __webpack_require__(300),
  isThisMonth: __webpack_require__(301),
  isThisQuarter: __webpack_require__(302),
  isThisSecond: __webpack_require__(303),
  isThisWeek: __webpack_require__(304),
  isThisYear: __webpack_require__(305),
  isThursday: __webpack_require__(306),
  isToday: __webpack_require__(307),
  isTomorrow: __webpack_require__(308),
  isTuesday: __webpack_require__(309),
  isValid: __webpack_require__(152),
  isWednesday: __webpack_require__(310),
  isWeekend: __webpack_require__(311),
  isWithinRange: __webpack_require__(312),
  isYesterday: __webpack_require__(313),
  lastDayOfISOWeek: __webpack_require__(314),
  lastDayOfISOYear: __webpack_require__(315),
  lastDayOfMonth: __webpack_require__(316),
  lastDayOfQuarter: __webpack_require__(317),
  lastDayOfWeek: __webpack_require__(153),
  lastDayOfYear: __webpack_require__(318),
  max: __webpack_require__(322),
  min: __webpack_require__(323),
  parse: __webpack_require__(0),
  setDate: __webpack_require__(324),
  setDay: __webpack_require__(325),
  setDayOfYear: __webpack_require__(326),
  setHours: __webpack_require__(327),
  setISODay: __webpack_require__(328),
  setISOWeek: __webpack_require__(329),
  setISOYear: __webpack_require__(154),
  setMilliseconds: __webpack_require__(330),
  setMinutes: __webpack_require__(331),
  setMonth: __webpack_require__(155),
  setQuarter: __webpack_require__(332),
  setSeconds: __webpack_require__(333),
  setYear: __webpack_require__(334),
  startOfDay: __webpack_require__(18),
  startOfHour: __webpack_require__(156),
  startOfISOWeek: __webpack_require__(19),
  startOfISOYear: __webpack_require__(34),
  startOfMinute: __webpack_require__(157),
  startOfMonth: __webpack_require__(335),
  startOfQuarter: __webpack_require__(158),
  startOfSecond: __webpack_require__(159),
  startOfToday: __webpack_require__(336),
  startOfTomorrow: __webpack_require__(337),
  startOfWeek: __webpack_require__(47),
  startOfYear: __webpack_require__(160),
  startOfYesterday: __webpack_require__(338),
  subDays: __webpack_require__(339),
  subHours: __webpack_require__(340),
  subISOYears: __webpack_require__(161),
  subMilliseconds: __webpack_require__(341),
  subMinutes: __webpack_require__(342),
  subMonths: __webpack_require__(343),
  subQuarters: __webpack_require__(344),
  subSeconds: __webpack_require__(345),
  subWeeks: __webpack_require__(346),
  subYears: __webpack_require__(347)
}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (number) {
    var percent = void 0;

    if (number == null) {
        percent = "N/A";
    } else {
        percent = (number * 100).toFixed(1) + "%";
    }

    return percent;
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (change) {
    if (change > 0) {
        return "#icon-arrow-up";
    } else {
        return "#icon-arrow-down";
    }
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(208), __esModule: true };

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(37);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(58)('keys');
var uid = __webpack_require__(42);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(59);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(16);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(6);
var LIBRARY = __webpack_require__(38);
var wksExt = __webpack_require__(63);
var defineProperty = __webpack_require__(10).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(232)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(113)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(31)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var differenceInCalendarMonths = __webpack_require__(134)
var compareAsc = __webpack_require__(33)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(45)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var startOfISOWeek = __webpack_require__(19)
var startOfISOYear = __webpack_require__(34)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(47)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(320)
var buildFormatLocale = __webpack_require__(321)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

module.exports = {"infinite":true,"slidesToShow":4,"slidesToScroll":4,"prevArrow":"<button class=\"plain-button z-20 p-0 absolute pin-l slick-prev\"><svg class=\"mg-icon mg-icon--large\"><use href=\"#icon-angle-left\" xlink:href=\"#icon-angle-left\" /></svg></button>","nextArrow":"<button class=\"plain-button z-20 p-0 absolute pin-r slick-next\"><svg class=\"mg-icon mg-icon--large\"><use href=\"#icon-angle-right\" xlink:href=\"#icon-angle-right\" /></svg></button>","responsive":[{"breakpoint":1040,"settings":{"slidesToShow":3,"slidesToScroll":3}},{"breakpoint":790,"settings":{"slidesToShow":2,"slidesToScroll":2}},{"breakpoint":576,"settings":{"slidesToShow":1,"slidesToScroll":1}}]}

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_components_slick__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_components_taxonomy_select__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_components_photo_gallery__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_components_card_feed__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_components_card_feed_reset__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_components_member_filter__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vue_components_member_list__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vue_components_market_data_tabs__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vue_components_market_data_chart__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vue_components_market_data_worldwide__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__vue_components_fob_price_comparison__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vue_components_data_download_button__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vue_components_ml_card_feed__ = __webpack_require__(377);
























__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__["a" /* default */], { preLoad: 1.5 });

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: "#page",
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    components: {
        slick: __WEBPACK_IMPORTED_MODULE_6__vue_components_slick__["a" /* default */],
        "photo-gallery": __WEBPACK_IMPORTED_MODULE_8__vue_components_photo_gallery__["a" /* default */],
        "taxonomy-select": __WEBPACK_IMPORTED_MODULE_7__vue_components_taxonomy_select__["a" /* default */],
        "card-feed": __WEBPACK_IMPORTED_MODULE_9__vue_components_card_feed__["a" /* default */],
        "card-feed-reset": __WEBPACK_IMPORTED_MODULE_10__vue_components_card_feed_reset__["a" /* default */],
        "member-filter": __WEBPACK_IMPORTED_MODULE_11__vue_components_member_filter__["a" /* default */],
        "member-list": __WEBPACK_IMPORTED_MODULE_12__vue_components_member_list__["a" /* default */],
        "market-data-tabs": __WEBPACK_IMPORTED_MODULE_13__vue_components_market_data_tabs__["a" /* default */],
        "market-data-chart": __WEBPACK_IMPORTED_MODULE_14__vue_components_market_data_chart__["a" /* default */],
        "market-data-worldwide": __WEBPACK_IMPORTED_MODULE_15__vue_components_market_data_worldwide__["a" /* default */],
        "fob-price-comparison": __WEBPACK_IMPORTED_MODULE_16__vue_components_fob_price_comparison__["a" /* default */],
        "data-download-button": __WEBPACK_IMPORTED_MODULE_17__vue_components_data_download_button__["a" /* default */],
        "ml-card-feed": __WEBPACK_IMPORTED_MODULE_18__vue_components_ml_card_feed__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapState"])(["marketDataIsLoading", "marketDataSettings", "isDesktop", "urlHashFilter"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapGetters"])(["topTenMarkets"])),
    watch: {
        urlHashFilter: function urlHashFilter() {
            var _this = this;

            var hashItems = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.urlHashFilter).map(function (key, index) {
                var filterParam = _this.urlHashFilter[key];
                if (filterParam) {
                    hashItems.push(key + "=" + filterParam);
                }
            });

            if (hashItems.length) {
                window.location.hash = hashItems.join("&");
            } else {
                // clear hash
                // the '#/' prevents the page from jumping back to the top
                window.location.hash = "/";
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapMutations"])(["updateIsDesktop"]), {
        checkViewport: function checkViewport() {
            // 1200px is the 'desktop' breakpoint used in our tailwind.js config.
            if (window.matchMedia && window.matchMedia("(min-width: 1200px)").matches) {
                this.updateIsDesktop(true);
            } else {
                this.updateIsDesktop(false);
            }
        }
    }),
    created: function created() {
        this.checkViewport();

        window.addEventListener("resize", this.checkViewport);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("resize", this.checkViewport);
    }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["type"],
    name: "card-feed-reset",
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["resetNewsFilter"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(["getNewsroomFeed"]), {
        reset: function reset() {
            if (this.type == "newsroom") {
                this.resetNewsFilter();
                this.getNewsroomFeed();
            }
        }
    })
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card__ = __webpack_require__(366);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "card-feed",
    components: {
        card: __WEBPACK_IMPORTED_MODULE_2__card__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["newsItems", "totalItemsFound"]), {
        moreToLoad: function moreToLoad() {
            if (this.totalItemsFound === null) {
                return false;
            } else {
                return !(parseInt(this.totalItemsFound) === this.newsItems.length);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(["getNewsroomFeed"]), {
        loadMoreArticles: function loadMoreArticles() {
            //Check for prop, then if it's the desired post type, use the endpoint.
            this.getNewsroomFeed(true);
        }
    }),
    created: function created() {
        //Check for prop, then if it's the desired post type, use the endpoint.
        this.getNewsroomFeed();
    }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card',
  props: ['post'],
  data: function data() {
    return {
      summary: '',
      news_type: '',
      display_date: ''
    };
  },

  computed: {
    title: function title() {
      return this.post.post_title || this.post.title.rendered;
    }
  },
  methods: {
    setNewsType: function setNewsType() {
      var postType = this.post.post_type;

      if (postType !== 'post') {
        this.news_type = this.post.mg_type_name;
      } else if (postType == 'post' && this.post.mg_category) {
        this.news_type = this.post.mg_category[0]['name'];
      }
    },
    makeSummary: function makeSummary() {
      if (this.post.post_excerpt) {
        this.summary = this.post.post_excerpt;
      } else {
        var $htmlHolder = $('<div />');

        var contentPreview = this.post.post_content.split(' ').splice(0, 24).join(' ') + '...';

        $htmlHolder.html(contentPreview);

        this.summary = $htmlHolder.text();
      }
    },
    addDisplayDate: function addDisplayDate() {
      this.display_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.post.post_date, 'MMM D, YYYY');
    },
    updateMeta: function updateMeta() {
      this.setNewsType();
      this.addDisplayDate();
      this.makeSummary();
    }
  },
  updated: function updated() {
    this.updateMeta();
  },
  created: function created() {
    this.updateMeta();
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["data-for"],
    name: "data-download-button",
    data: function data() {
        return {
            paramString: ""
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["activeMarket", "selectedMarket", "marketDataMode", "top_exports_selected", "export_totals"]), {
        endpoint: function endpoint() {
            if (this.dataFor == "GIAF-chart") {
                if (this.isWorldTotal) {
                    return "/wp-content/mu-plugins/plugin-exportAllData/index.php";
                } else {
                    return "/wp-content/mu-plugins/plugin-exportCountryData/index.php";
                }
            } else if (this.dataFor == "top-exports-chart") {
                return "/wp-content/mu-plugins/plugin-exportCommodityData/index.php";
            }
        },
        url: function url() {
            return this.endpoint + this.paramString;
        },
        isWorldTotal: function isWorldTotal() {
            return this.selectedMarket === "World Total";
        }
    }),
    watch: {
        activeMarket: function activeMarket() {
            this.makeParamString();
        },
        marketDataMode: function marketDataMode() {
            this.makeParamString();
        },
        top_exports_selected: function top_exports_selected() {
            this.makeParamString();
        }
    },
    methods: {
        makeParamString: function makeParamString() {
            var params = [];

            if (this.dataFor == "GIAF-chart") {
                if (!this.activeMarket) return;

                if (!this.isWorldTotal) {
                    params.push("countryCode=" + this.activeMarket.market_code);
                }

                if (this.marketDataMode == "USDA-data") {
                    params.push("USDA=1");
                } else {
                    params.push("USDA=0");
                }
            } else if (this.dataFor == "top-exports-chart") {
                var commodityCode = this.top_exports_selected;

                if (this.top_exports_selected != "all" && this.export_totals) {
                    commodityCode = this.export_totals[this.top_exports_selected]["code"];
                }

                params.push("commodity_code=" + commodityCode.toUpperCase());
            }

            if (params.length) {
                this.paramString = "?" + params.join("&");
            }
        }
    },
    created: function created() {
        this.makeParamString();
    }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "fob-price-comparison",
    data: function data() {
        return {
            isLoading: false,
            dataUrl: "/wp-json/mg/v1/fob-price-comparison/",
            yearOption: 2,
            comparison: "gulfDDGS_gulfCorn",
            dataToCompare: [],
            dataForChart: {},
            rangeOptions: [{
                text: "Past Year",
                value: 2
            }, {
                text: "Past 2 Years",
                value: 3
            }],
            compareOptions: [{
                value: "gulfDDGS_gulfCorn",
                text: "Gulf DDGS vs Gulf Corn"
            }, {
                value: "gulfCorn_texasSorghum",
                text: "Gulf Corn vs Texas Sorghum"
            }, {
                value: "gulfCorn_nolaSorghum",
                text: "Gulf Corn vs NOLA Sorghum"
            }, {
                value: "texasSorghum_nolaSorghum",
                text: "Texas Sorghum vs NOLA Sorghum"
            }],
            config: {
                type: "line",
                data: {
                    labels: [],
                    datasets: []
                },
                options: {
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            padding: 15
                        }
                    },
                    responsive: true,
                    title: {
                        display: false,
                        text: "Chart.js Line Chart"
                    },
                    tooltips: {
                        mode: "index",
                        intersect: false,
                        titleFontColor: "#402f15",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        xPadding: 8,
                        yPadding: 8,
                        cornerRadius: 0,
                        borderColor: "#ccc",
                        borderWidth: 1,
                        callbacks: {
                            labelTextColor: function labelTextColor(tooltipItem, chart) {
                                return "#402f15";
                            },
                            label: function label(tooltipItem, data) {
                                return data.datasets[tooltipItem.datasetIndex].label + ": " + __WEBPACK_IMPORTED_MODULE_6_numeral___default()(tooltipItem.yLabel).format("0,0.0");
                            }
                        }
                    },
                    hover: {
                        mode: "nearest",
                        intersect: true
                    },
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: false,
                                labelString: "Date"
                            }
                        }],
                        yAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: "Dollars Per Metric Ton"
                            },
                            ticks: {
                                callback: function callback(value) {
                                    return __WEBPACK_IMPORTED_MODULE_6_numeral___default()(value).format("0a").toUpperCase();
                                }
                            }
                        }]
                    }
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])(["colors"]), {
        comparisonitems: function comparisonitems() {
            return this.comparison.split("_");
        }
    }),
    methods: {
        getData: function getData() {
            var _this = this;

            var params = {};

            params.year = new Date().getFullYear() - this.yearOption;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this.isLoading = true;
                __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.start();
                $.ajax({
                    url: _this.dataUrl,
                    data: params
                }).then(function (response) {
                    _this.dataToCompare = response;
                    resolve();
                }, function (error) {
                    console.log("There was an error trying to get FOB price comparison items");
                    reject();
                }).always(function () {
                    _this.isLoading = false;
                    __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.done();
                });
            });
        },
        addLabels: function addLabels() {
            var labels = [];

            this.dataToCompare.forEach(function (item) {
                var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(item.date, "M/D/YYYY");
                labels.push(date);
            });

            this.config.data.labels = labels;
        },
        updateDatasets: function updateDatasets() {
            var _this2 = this;

            if (!this.comparison) return;

            this.config.data.datasets = [];

            this.dataForChart = {};

            this.comparisonitems.forEach(function (commodity) {
                _this2.dataForChart[commodity] = {
                    label: "",
                    values: []
                };
            });

            this.dataToCompare.forEach(function (item) {
                _this2.comparisonitems.forEach(function (commodity) {
                    if (item.commodities[commodity]) {
                        _this2.dataForChart[commodity]["label"] = item.commodities[commodity]["label"];
                        _this2.dataForChart[commodity]["values"].push(item.commodities[commodity]["value"]);
                    }
                });
            });

            this.setSpread();

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.dataForChart).forEach(function (key, index) {
                var color = _this2.colors[_this2.config.data.datasets.length % _this2.colors.length];

                var dataset = {
                    label: _this2.dataForChart[key]["label"],
                    data: _this2.dataForChart[key]["values"],
                    backgroundColor: color,
                    borderColor: color,
                    fill: false
                };

                var blue = "#0165a0";
                var red = "#A20021";
                var gold = "#d18316";

                if (index == 0) {
                    dataset.backgroundColor = blue;
                    dataset.borderColor = blue;
                } else if (index == 1) {
                    dataset.backgroundColor = red;
                    dataset.borderColor = red;
                } else if (index == 2) {
                    dataset.backgroundColor = gold;
                    dataset.borderColor = gold;
                }

                _this2.config.data.datasets.push(dataset);
            });

            window.mgFobChart.update();
        },
        setSpread: function setSpread() {
            var _this3 = this;

            // 'spread' is the 1st item in `this.comparisonitems`
            // minus the second item.
            if (this.comparisonitems.length <= 1) return;

            var firstCompareItem = this.comparisonitems[0];
            var secondCompareItem = this.comparisonitems[1];

            if (this.dataForChart[firstCompareItem]["values"].length != this.dataForChart[secondCompareItem]["values"].length) {
                console.log(firstCompareItem + " does not have the same amount of data entries as " + secondCompareItem);
                return;
            }

            var spread = {
                label: "Spread",
                values: []
            };

            this.dataForChart[firstCompareItem]["values"].forEach(function (value, index) {
                var otherValue = _this3.dataForChart[secondCompareItem]["values"][index];
                spread.values.push(value - otherValue);
            });

            this.dataForChart.spread = spread;
        },
        chartDataSetup: function chartDataSetup() {
            var _this4 = this;

            this.getData().then(function () {
                _this4.addLabels();
                _this4.updateDatasets();
            });
        },
        chartInit: function chartInit() {
            var chart = document.querySelector("#fob-price-compare-chart");

            if (!chart) return;

            var ctx = chart.getContext("2d");
            window.mgFobChart = new Chart(ctx, this.config);

            this.chartDataSetup();
        }
    },
    mounted: function mounted() {
        this.chartInit();
    }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_format_number__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_get_query_param__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__market_data_select__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__market_data_commodities__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__market_data_partners__ = __webpack_require__(371);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["type"],
    name: "market-data-chart",
    components: {
        "market-data-select": __WEBPACK_IMPORTED_MODULE_5__market_data_select__["a" /* default */],
        "market-data-commodities": __WEBPACK_IMPORTED_MODULE_6__market_data_commodities__["a" /* default */],
        "market-data-partners": __WEBPACK_IMPORTED_MODULE_7__market_data_partners__["a" /* default */]
    },
    data: function data() {
        return {
            config: {
                type: "line",
                data: {
                    labels: [],
                    datasets: []
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    title: {
                        display: false,
                        text: "Chart.js Line Chart"
                    },
                    tooltips: {
                        mode: "index",
                        intersect: false,
                        titleFontColor: "#402f15",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        xPadding: 8,
                        yPadding: 8,
                        cornerRadius: 0,
                        borderColor: "#ccc",
                        borderWidth: 1,
                        callbacks: {
                            labelTextColor: function labelTextColor(tooltipItem, chart) {
                                return "#402f15";
                            },
                            label: function label(tooltipItem, data) {
                                return data.datasets[tooltipItem.datasetIndex].label + ": " + __WEBPACK_IMPORTED_MODULE_4_numeral___default()(tooltipItem.yLabel).format("0,0");
                            }
                        }
                    },
                    hover: {
                        mode: "nearest",
                        intersect: true
                    },
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: false,
                                labelString: "Year"
                            }
                        }],
                        yAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: "Quantity"
                            },
                            ticks: {
                                callback: function callback(value) {
                                    if (parseInt(value) && parseInt(value).toString().length > 3) {
                                        return __WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format("0.00a").toUpperCase();
                                    } else {
                                        return __WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format("0a").toUpperCase();
                                    }
                                }
                            }
                        }]
                    }
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["colors", "showQty", "showDollars", "activeUnit", "marketDataMode", "marketDataYears", "marketDataSettings", "market_data", "activeMarket", "commodities", "activeCommodities", "top_exports_selected", "selectedMarket", "export_totals", "activePartners"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(["getCommodityProperty", "topTenMarkets"]), {
        qtyOption: {
            get: function get() {
                return this.showQty;
            },
            set: function set(value) {
                this.updateQtyOption(value);
            }
        },
        dollarsOption: {
            get: function get() {
                return this.showDollars;
            },
            set: function set(value) {
                this.updateDollarsOption(value);
            }
        },
        activeChartItems: function activeChartItems() {
            if (this.type == "commodities") {
                return this.activeCommodities.sort();
            } else {
                return this.activePartners;
            }
        },
        marketYear: function marketYear() {
            return this.marketDataSettings.current_market_year;
        }
    }),
    watch: {
        marketDataSettings: function marketDataSettings() {
            this.addChartLabels();
        },
        showQty: function showQty() {
            this.updateChartData();
        },
        topTenMarkets: function topTenMarkets() {
            this.updateChartData();
        },
        top_exports_selected: function top_exports_selected() {
            this.updateChartData();
        },
        activeMarket: function activeMarket() {
            this.updateChartData();
        },
        activeChartItems: function activeChartItems() {
            this.updateChartData();
        },
        marketDataMode: function marketDataMode() {
            this.updateChartData();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["setMarketDataView", "updateQtyOption", "setSelectedMarket", "updateDollarsOption"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(["handleActiveUnit"]), {
        formatNumber: __WEBPACK_IMPORTED_MODULE_2__utilities_format_number__["a" /* default */],
        legendItemColor: function legendItemColor(item) {
            if (this.type == "commodities") {
                return this.getCommodityProperty({
                    key: item,
                    property: "color"
                });
            } else {
                if (item == "World Total") {
                    return this.colors[0];
                } else {
                    for (var index = 0; index < this.topTenMarkets.length; index++) {
                        var partner = this.topTenMarkets[index];
                        if (item == partner.market_name) {
                            return this.colors[index + 1];
                        }
                    }
                }
            }
        },
        updateChartData: function updateChartData() {
            this.handleActiveUnit();

            if (this.type == "commodities") {
                this.updateCommoditiesDatasets();
            } else if (this.type == "top-export-partners") {
                this.updatePartnersDatasets();
            }
        },
        updatePartnersDatasets: function updatePartnersDatasets() {
            var _this = this;

            if (this.topTenMarkets.length == 0 || !this.export_totals) {
                return;
            }

            var exportTotalProp = this.export_totals[this.top_exports_selected];

            this.config.data.datasets = [];

            this.activeChartItems.forEach(function (item, index) {
                if (item == "World Total") {
                    var dataset = {
                        label: item,
                        backgroundColor: _this.colors[0],
                        borderColor: _this.colors[0],
                        data: [],
                        fill: false
                    };
                    for (var year = 1; year <= _this.marketDataYears; year++) {
                        if (_this.showQty) {
                            dataset.data.push(exportTotalProp["year_" + year + "_quantity"]);
                        } else {
                            dataset.data.push(exportTotalProp["year_" + year + "_value"]);
                        }
                    }

                    _this.config.data.datasets.push(dataset);
                } else {
                    for (var partnerIndex = 0; partnerIndex < _this.topTenMarkets.length; partnerIndex++) {
                        var partner = _this.topTenMarkets[partnerIndex];
                        if (partner.market_name == item) {
                            var _dataset = {
                                label: item,
                                backgroundColor: _this.colors[partnerIndex + 1],
                                borderColor: _this.colors[partnerIndex + 1],
                                data: [],
                                fill: false
                            };

                            for (var year = 1; year <= _this.marketDataYears; year++) {
                                if (_this.showQty) {
                                    _dataset.data.push(partner[_this.top_exports_selected]["year_" + year + "_quantity"]);
                                } else {
                                    _dataset.data.push(partner[_this.top_exports_selected]["year_" + year + "_value"]);
                                }
                            }

                            _this.config.data.datasets.push(_dataset);

                            break;
                        }
                    }
                }
            });

            var yAxesLabel = window.mgChart.options.scales.yAxes[0];

            if (this.showQty) {
                yAxesLabel.scaleLabel.labelString = "Quantity (" + this.activeUnit + ")";
            } else {
                yAxesLabel.scaleLabel.labelString = "Value";
            }

            window.mgChart.update();
        },
        updateCommoditiesDatasets: function updateCommoditiesDatasets() {
            var _this2 = this;

            if (!this.activeMarket) return;

            this.config.data.datasets = [];

            this.activeChartItems.forEach(function (item) {
                var activeItem = _this2.activeMarket[item];

                if (activeItem) {
                    var dataset = {
                        label: _this2.getCommodityProperty({
                            key: item,
                            property: "text"
                        }).replace("&amp;", "&"),
                        backgroundColor: _this2.getCommodityProperty({
                            key: item,
                            property: "color"
                        }),
                        borderColor: _this2.getCommodityProperty({
                            key: item,
                            property: "color"
                        }),
                        data: [],
                        fill: false
                    };

                    for (var year = 1; year <= _this2.marketDataYears; year++) {
                        if (_this2.showQty) {
                            dataset.data.push(activeItem["year_" + year + "_quantity"]);
                        } else {
                            dataset.data.push(activeItem["year_" + year + "_value"]);
                        }
                    }

                    _this2.config.data.datasets.push(dataset);
                }
            });

            var yAxesLabel = window.mgChart.options.scales.yAxes[0];

            if (this.showQty) {
                if (this.marketDataMode == "GIAF-eq") {
                    yAxesLabel.scaleLabel.labelString = "Qty or Corn Equivalent (MT)";
                } else {
                    yAxesLabel.scaleLabel.labelString = "Quantity (" + this.activeUnit + ")";
                }
            } else {
                yAxesLabel.scaleLabel.labelString = "Value";
            }

            window.mgChart.update();
        },
        addChartLabels: function addChartLabels() {
            if (!this.marketYear) return;
            var labels = [this.marketYear - 6 + "/" + (this.marketYear - 5), this.marketYear - 5 + "/" + (this.marketYear - 4), this.marketYear - 4 + "/" + (this.marketYear - 3), this.marketYear - 3 + "/" + (this.marketYear - 2), this.marketYear - 2 + "/" + (this.marketYear - 1)];
            this.config.data.labels = labels;
        },
        checkLocationParam: function checkLocationParam() {
            var locationParam = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_get_query_param__["a" /* default */])("location");
            if (this.type == "commodities" && locationParam) {
                this.setSelectedMarket(locationParam);
            }
        },
        chartInit: function chartInit() {
            var chart = document.querySelector("#market-data-chart");

            if (!chart) return;

            var ctx = chart.getContext("2d");
            window.mgChart = new Chart(ctx, this.config);
        }
    }),
    created: function created() {
        this.setMarketDataView(this.type);
        this.checkLocationParam();
    },
    mounted: function mounted() {
        this.chartInit();
    }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_format_number__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_get_svg_arrow_name__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_get_percent__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["data"],
    name: "market-data-commodities",
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["isDesktop", "showQty", "marketDataMode", "commodities", "activeCommodities", "activeMarket", "marketDataSettings"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(["getCommodityProperty", "isCommodity", "sortedData"]), {
        sortedMarketInfo: function sortedMarketInfo() {
            return this.sortedData(this.data);
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["addActiveCommodity", "removeActiveCommodity", "deactivateAllCommodities"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(["activateSingleCommodity"]), {
        formatNumber: __WEBPACK_IMPORTED_MODULE_2__utilities_format_number__["a" /* default */],
        getArrowName: __WEBPACK_IMPORTED_MODULE_3__utilities_get_svg_arrow_name__["a" /* default */],
        getPercent: __WEBPACK_IMPORTED_MODULE_4__utilities_get_percent__["a" /* default */],
        displayRow: function displayRow(key) {
            if (!this.isDesktop && this.activeCommodities.indexOf(key) == -1) {
                return false;
            } else {
                return true;
            }
        },
        isUsdaAllRow: function isUsdaAllRow(key) {
            return key === "all" && this.marketDataMode == "USDA-data";
        },
        trigger: function trigger(key) {
            if (this.showQty && this.marketDataMode == "USDA-data") {
                this.activateSingleCommodity(key);
            } else {
                var keyActiveIndex = this.activeCommodities.indexOf(key);
                if (keyActiveIndex > -1) {
                    this.removeActiveCommodity(keyActiveIndex);
                } else {
                    this.addActiveCommodity(key);
                }
            }
        }
    })
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_get_country_code__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_format_number__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_get_svg_arrow_name__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_get_percent__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: "market-data-partners",
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["isDesktop", "showQty", "showDollars", "activePartners", "top_exports_selected", "colors", "export_totals", "marketDataSettings"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(["topTenMarkets"])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["removeActivePartner", "addActivePartner"]), {
        formatNumber: __WEBPACK_IMPORTED_MODULE_4__utilities_format_number__["a" /* default */],
        getArrowName: __WEBPACK_IMPORTED_MODULE_5__utilities_get_svg_arrow_name__["a" /* default */],
        getPercent: __WEBPACK_IMPORTED_MODULE_6__utilities_get_percent__["a" /* default */],
        displayRow: function displayRow(key) {
            if (!this.isDesktop && this.activePartners.indexOf(key) == -1) {
                return false;
            } else {
                return true;
            }
        },
        trigger: function trigger(key) {
            var keyActiveIndex = this.activePartners.indexOf(key);
            if (keyActiveIndex > -1) {
                this.removeActivePartner(keyActiveIndex);
            } else {
                this.addActivePartner(key);
            }
        },
        handleCountryCode: function handleCountryCode(countryCode) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_get_country_code__["a" /* default */])(countryCode);
        }
    }),
    created: function created() {
        this.addActivePartner("World Total");
    }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_sort_by_subprop_int__ = __webpack_require__(198);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["type"],
    name: "market-data-select",
    data: function data() {
        return {
            selectedCommodity: "all",
            selectedPartner: "World Total"
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])(["isDesktop", "marketDataMode", "showQty", "commodities", "markets", "market_data", "top_exports_selected", "selectedMarket", "activeMarket", "activeCommodities", "activePartners"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(["getCommodityProperty", "isCommodity", "sortedData", "topTenMarkets"]), {
        selected: {
            get: function get() {
                if (this.type == "commodities") {
                    return this.selectedMarket;
                } else if (this.type == "top-export-partners") {
                    return this.top_exports_selected;
                }
            },
            set: function set(value) {
                if (this.type == "commodities") {
                    this.setSelectedMarket(value);
                } else if (this.type == "top-export-partners") {
                    this.setTopExportsSelected(value);
                }
            }
        },
        label: function label() {
            if (this.type == "commodities") {
                return "Filter by country";
            } else if (this.type == "top-export-partners") {
                return "Filter by commodity";
            } else {
                return "Select";
            }
        },
        options: function options() {
            if (this.type == "commodities") {
                return this.markets;
            } else if (this.type == "top-export-partners") {
                return this.commodities;
            } else {
                return [];
            }
        },
        sortedMarketInfo: function sortedMarketInfo() {
            if (this.activeMarket) {
                return this.sortedData(this.activeMarket);
            } else {
                return {};
            }
        }
    }),
    watch: {
        showQty: function showQty() {
            if (this.showQty && this.marketDataMode == "USDA-data") {
                this.enableAllOption();
            }
        },
        isDesktop: function isDesktop() {
            // `selectedCommodity` is for the mobile/tablet commodity select
            if (!this.isDesktop) {
                if (this.activeCommodities.length == 1) {
                    this.selectedCommodity = this.activeCommodities[0];
                } else {
                    this.selectedCommodity = "";
                }

                if (this.activePartners.length == 1) {
                    this.selectedPartner = this.activePartners[0];
                } else {
                    this.selectedPartner = "";
                }
            }
        },
        activeMarket: function activeMarket() {
            if (this.type == "commodities") {
                this.checkMissingCommodities();
            }
        },
        topTenMarkets: function topTenMarkets() {
            if (this.type == "top-export-partners") {
                this.checkMissingPartners();
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapMutations"])(["setMarketData", "setTopExportsSelected", "setSelectedMarket", "addActiveCommodity", "deactivateAllCommodities", "addActiveCommodity", "addActivePartner"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(["getMarketDataSettings", "getMarketData", "getMarketDataFeedGrain", "getExportTotals", "getExportTotalsFeedGrain", "selectMarket", "activateAllCommodities", "activateSingleCommodity", "activateSinglePartner"]), {
        checkMissingCommodities: function checkMissingCommodities() {
            var _this = this;

            var missingCommoditiesCount = 0;
            this.activeCommodities.forEach(function (commodity) {
                if (!_this.activeMarket[commodity]) {
                    missingCommoditiesCount++;
                }
            });

            if (missingCommoditiesCount == this.activeCommodities.length) {
                if (this.showQty && this.marketDataMode == "USDA-data") {
                    this.enableAllOption();
                } else {
                    this.selectedCommodity = "all";
                    this.addActiveCommodity("all");
                }
            }
        },
        checkMissingPartners: function checkMissingPartners() {
            var _this2 = this;

            var partnersFound = 0;
            this.activePartners.forEach(function (partner) {
                for (var index = 0; index < _this2.topTenMarkets.length; index++) {
                    var market = _this2.topTenMarkets[index];
                    if (partner == market.market_name) {
                        partnersFound++;
                        break;
                    }
                }
            });

            if (partnersFound == 0 && this.activePartners.indexOf("World Total") == -1) {
                this.selectedPartner = "World Total";

                if (this.isDesktop) {
                    this.addActivePartner(this.selectedPartner);
                } else {
                    this.activateSinglePartner(this.selectedPartner);
                }
            }
        },
        sortMarketData: function sortMarketData() {
            var marketData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_sort_by_subprop_int__["a" /* default */])(this.market_data, {
                property: this.top_exports_selected,
                sub_property: "current_market_year_quantity"
            });
            this.setMarketData(marketData);
        },
        enableAllOption: function enableAllOption() {
            this.deactivateAllCommodities();
            this.selectedCommodity = "all";
            this.addActiveCommodity("all");
        },
        handleActiveData: function handleActiveData() {
            if (this.type == "commodities") {
                this.selectMarket();
            } else if (this.type == "top-export-partners") {
                this.sortMarketData();
            }
        },
        afterInitalDataLoad: function afterInitalDataLoad() {
            this.handleActiveData();

            if (this.type == "commodities") {
                if (this.showQty) {
                    this.enableAllOption();
                } else {
                    this.activateAllCommodities();
                }
            }
        },
        init: function init() {
            var _this3 = this;

            this.getMarketDataSettings().then(function () {
                if (_this3.type == "commodities" && _this3.marketDataMode == "GIAF-eq") {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this3.getExportTotalsFeedGrain(), _this3.getMarketDataFeedGrain()]);
                } else {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this3.getExportTotals(), _this3.getMarketData()]);
                }
            }).then(function () {
                _this3.afterInitalDataLoad();
            });
        }
    }),
    created: function created() {
        this.init();
    }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip__ = __webpack_require__(383);


//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "market-data-tabs",
    components: {
        tooltip: __WEBPACK_IMPORTED_MODULE_3__tooltip__["a" /* default */]
    },
    data: function data() {
        return {
            tabs: [{
                name: "USDA-data",
                label: "USDA Export Data",
                info: false
            }, {
                name: "GIAF-eq",
                label: "Feed Grains In All Forms Equivalents",
                info: "USDA export data converted to Feed Grain Equivalents"
            }],
            selected: 0
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])(["marketDataMode", "showQty", "marketDataIsLoading"])),
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapMutations"])(["setMarketDataMode", "updateQtyOption"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(["activeCommodities", "activateSingleCommodity", "getMarketData", "getMarketDataFeedGrain", "getExportTotals", "getExportTotalsFeedGrain", "selectMarket", "handleActiveUnit"]), {
        tabClick: function tabClick(index) {
            var _this = this;

            if (this.selected == index) return;

            this.selected = index;

            this.setDataMode();

            if (this.marketDataMode == "GIAF-eq") {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.getExportTotalsFeedGrain(), this.getMarketDataFeedGrain()]).then(function () {
                    _this.handleActiveUnit();
                    _this.selectMarket();
                    _this.updateQtyOption(true);
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.getExportTotals(), this.getMarketData()]).then(function () {
                    _this.handleActiveUnit();
                    _this.selectMarket();
                    _this.updateQtyOption(true);

                    if (_this.showQty && _this.activeCommodities.length) {
                        _this.activateSingleCommodity("all");
                    }
                });
            }
        },
        setDataMode: function setDataMode() {
            var tabInfo = this.tabs[this.selected];
            this.setMarketDataMode(tabInfo.name);
        }
    }),
    created: function created() {
        if (this.marketDataMode == "GIAF-eq") {
            this.selected = 1;
        }
        this.setDataMode();
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_format_number__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_get_svg_arrow_name__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_get_percent__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: "market-data-worldwide",
    data: function data() {
        return {
            enabled: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["showDollars", "market_data", "top_exports_selected", "export_totals", "marketDataSettings"]), {
        dollarsOption: {
            get: function get() {
                return this.showDollars;
            },
            set: function set(value) {
                this.updateDollarsOption(value);
            }
        },
        units: function units() {
            return this.top_exports_selected == "ethanol-(non-bev.)" ? "GAL" : "MT";
        },
        buttonVerb: function buttonVerb() {
            return this.enabled ? "Hide" : "Show";
        },
        buttonIcon: function buttonIcon() {
            var iconName = this.enabled ? "#icon-angle-up" : "#icon-angle-down";
            return "<span class=\"flex mx-4 mg-icon--medium round mg-banded-screen-lightest text-center items-center justify-center\">\n                <svg class=\"mg-icon mg-icon--medium\">\n                    <use href=\"" + iconName + "\" xlink:href=\"" + iconName + "\" />\n                </svg>\n            </span>";
        },
        marketYear: function marketYear() {
            return this.marketDataSettings.current_market_year;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["updateDollarsOption"]), {
        formatNumber: __WEBPACK_IMPORTED_MODULE_3__utilities_format_number__["a" /* default */],
        getArrowName: __WEBPACK_IMPORTED_MODULE_4__utilities_get_svg_arrow_name__["a" /* default */],
        getPercent: __WEBPACK_IMPORTED_MODULE_5__utilities_get_percent__["a" /* default */],
        toggle: function toggle() {
            this.enabled = !this.enabled;
        }
    })
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__taxonomy_select__ = __webpack_require__(172);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "member-filter",
    components: {
        "taxonomy-select": __WEBPACK_IMPORTED_MODULE_3__taxonomy_select__["a" /* default */]
    },
    computed: {
        keyword: {
            get: function get() {
                return this.$store.state.memberFilter.search;
            },
            set: function set(value) {
                this.$store.commit("updateMemberSearch", value);
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapMutations"])(["resetMemberFilter"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(["getMembers"]), {
        reset: function reset() {
            this.resetMemberFilter();
            this.getMembers(true);
        }
    })
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination__ = __webpack_require__(380);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "member-list",
    components: {
        pagination: __WEBPACK_IMPORTED_MODULE_2__pagination__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["members", "totalItemsFound", "membersPaginated"])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["updateMembersPaginationFlag"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(["getMembers"]), {
        paginationToggle: function paginationToggle() {
            this.updateMembersPaginationFlag(!this.membersPaginated);
            this.getMembers();
        },
        checkSiteValue: function checkSiteValue(url) {
            if (url.substring(0, 4) !== "http") {
                return "http://" + url;
            }

            return url;
        }
    })
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ml_card__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ml_news_item__ = __webpack_require__(379);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var apiBase = "/wp-json/";
var wpApi = apiBase + "wp/v2/";




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        postType: {
            // the post type slug
            type: String,
            default: 'posts'
        },
        regionFilter: {
            type: Number
        },
        countryFilter: {
            type: Number
        },
        loadMoreText: {
            type: String,
            default: 'Load More'
        },
        feedType: {
            type: String,
            default: 'cards'
        }
    },
    name: "ml-card-feed",
    components: {
        card: __WEBPACK_IMPORTED_MODULE_0__ml_card__["a" /* default */],
        'news-item': __WEBPACK_IMPORTED_MODULE_1__ml_news_item__["a" /* default */]
    },
    data: function data() {
        return {
            newsItems: [],
            totalItemsFound: 0,
            currentPage: 1,
            perPage: 3
        };
    },

    computed: {
        moreToLoad: function moreToLoad() {
            if (this.totalItemsFound === null) {
                return false;
            } else {
                return !(parseInt(this.totalItemsFound) === this.newsItems.length);
            }
        },
        apiUrl: function apiUrl() {
            var baseUrl = "" + wpApi + this.postType;

            var args = ["per_page=" + this.perPage, "page=" + this.currentPage];

            if (this.regionFilter && this.regionFilter != 0) {
                args.push("region=" + this.regionFilter);
            }

            if (this.countryFilter && this.countryFilter != 0) {
                args.push("country=" + this.countryFilter);
            }

            return baseUrl + "?" + args.join('&');
        }
    },
    methods: {
        getNewsroomFeed: function getNewsroomFeed() {
            var _this = this;

            var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (loadMore) {
                this.currentPage += 1;
            }

            $.ajax({
                url: this.apiUrl
            }).then(function (response) {
                console.log(response);

                response.forEach(function (post) {
                    return _this.newsItems.push(post);
                });
                // let payload = {
                //     posts: response.posts,
                //     loadMore: loadMore
                // };

                // commit("setNewsItems", payload);
                // commit("setTotalFound", response.number_of_posts);                    
            }, function (error) {
                console.log("There was an error getting the newsroom feed");
            });
        },
        loadMoreArticles: function loadMoreArticles() {
            //Check for prop, then if it's the desired post type, use the endpoint.
            this.getNewsroomFeed(true);
        }
    },
    created: function created() {
        //Check for prop, then if it's the desired post type, use the endpoint.
        this.getNewsroomFeed();
    }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ml-card',
  props: ['post'],
  data: function data() {
    return {
      summary: '',
      display_date: ''
    };
  },

  computed: {
    title: function title() {
      return this.post.post_title || this.post.title.rendered;
    }
  },
  methods: {
    makeSummary: function makeSummary() {
      var excerptSource = this.post.excerpt && this.post.excerpt.rendered ? this.post.excerpt.rendered : this.post.content.rendered;

      var $htmlHolder = $('<div />');

      var contentPreview = excerptSource.split(' ').splice(0, 15).join(' ') + '...';

      $htmlHolder.html(contentPreview);

      this.summary = $htmlHolder.text();
    },
    addDisplayDate: function addDisplayDate() {
      this.display_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.post.date, 'MMM D, YYYY');
    },
    updateMeta: function updateMeta() {
      this.addDisplayDate();
      this.makeSummary();
    }
  },
  updated: function updated() {
    this.updateMeta();
  },
  created: function created() {
    this.updateMeta();
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ml-news-item',
  props: ['post'],
  data: function data() {
    return {
      summary: '',
      display_date: ''
    };
  },

  computed: {
    title: function title() {
      return this.post.post_title || this.post.title.rendered;
    }
  },
  methods: {
    makeSummary: function makeSummary() {
      var excerptSource = this.post.excerpt && this.post.excerpt.rendered ? this.post.excerpt.rendered : this.post.content.rendered;

      var $htmlHolder = $('<div />');

      var contentPreview = excerptSource.split(' ').splice(0, 15).join(' ') + '...';

      $htmlHolder.html(contentPreview);

      this.summary = $htmlHolder.text();
    },
    addDisplayDate: function addDisplayDate() {
      this.display_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(this.post.date, 'MMM D, YYYY');
    },
    updateMeta: function updateMeta() {
      this.addDisplayDate();
      this.makeSummary();
    }
  },
  updated: function updated() {
    this.updateMeta();
  },
  created: function created() {
    this.updateMeta();
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "pagination",
    data: function data() {
        return {
            parent: this.$parent.$options.name,
            paginationNumbers: []
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])(["totalItemsFound", "per_page", "current_page"]), {
        totalPages: function totalPages() {
            return Math.ceil(this.totalItemsFound / this.per_page);
        }
    }),
    watch: {
        totalItemsFound: function totalItemsFound() {
            this.getPaginationNumbers();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["setCurrentPage"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(["getMembers"]), {
        getData: function getData() {
            var _this = this;

            if (this.parent == "member-list") {
                this.getMembers().then(function () {
                    _this.getPaginationNumbers();
                });
            }
        },

        paginationClick: function paginationClick(pageNumber) {
            this.setCurrentPage(pageNumber);
            this.getData();
        },
        getPaginationNumbers: function getPaginationNumbers() {
            this.paginationNumbers = [];

            for (var pageNumber = 1; pageNumber <= this.totalPages; pageNumber++) {
                if (Math.abs(pageNumber - this.current_page) < 3 || pageNumber == this.totalPages || pageNumber == 1) {
                    this.paginationNumbers.push(pageNumber);
                }
            }
        }
    }),
    created: function created() {
        this.getData();
    }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);


//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "photo-gallery",
    data: function data() {
        return {
            flickrApi: "https://api.flickr.com/services/rest/",
            flickrApiParams: {
                api_key: "4b8c06edab112d89565c36a6f5e4dda4",
                format: "json",
                nojsoncallback: 1
            },
            options: __webpack_require__(80),
            imagesInformation: {}
        };
    },

    methods: {
        flickrGetInfo: function flickrGetInfo(imgId) {
            var apiParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                method: "flickr.photos.getInfo",
                photo_id: imgId
            }, this.flickrApiParams);

            return $.ajax({
                url: this.flickrApi,
                data: apiParams
            });
        },
        flickrGetSizes: function flickrGetSizes(imgId) {
            var apiParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                method: "flickr.photos.getSizes",
                photo_id: imgId
            }, this.flickrApiParams);

            return $.ajax({
                url: this.flickrApi,
                data: apiParams
            });
        },
        updateGalleryItem: function updateGalleryItem(element) {
            var _this = this;

            var BBCode = $(element).data("bbcode");
            var imgUrl = BBCode.split("[img]")[1].split("[/img]")[0];
            var imgId = imgUrl.split("/").pop().split("_")[0];

            $(element).css("background-image", "url(" + imgUrl + ")");

            __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.start();
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.flickrGetInfo(imgId), this.flickrGetSizes(imgId)]).then(function (response) {
                _this.addImageInfo(response[0], element, imgId);
                _this.addDownloadLinkToImg(response[1], element, imgId);

                __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done();
            }, function (error) {
                console.log("There was an error trying to get flickr data for image: " + imgId);

                __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done();
            });
        },
        addImageInfo: function addImageInfo(data, element, imgId) {
            var photoDescription = data.photo.description._content;
            if (!photoDescription) {
                photoDescription = data.photo.title._content;
            }
            this.imagesInformation[imgId] = {
                description: photoDescription
            };
            $(element).attr("aria-label", photoDescription);
        },
        addDownloadLinkToImg: function addDownloadLinkToImg(data, element, imgId) {
            var downloadLink = data.sizes.size.pop().source;
            var imageDescription = this.imagesInformation[imgId] ? " - " + this.imagesInformation[imgId]["description"] : "";
            var downloadButton = "<a title=\"Download Image" + imageDescription + "\" download href=\"" + downloadLink + "\" class=\"block pin-r pin-b absolute py-4 px-6 mg-filter mg-filter--medium text-white hover:text-white plain-link text-right\"><svg class=\"mg-icon mg-icon--medium relative z-10\"><use href=\"#icon-download\" xlink:href=\"#icon-download\"/></svg></a>";
            $(element).html(downloadButton);
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        $(this.$el).find("[data-bbcode]").map(function (index, element) {
            _this2.updateGalleryItem(element);
        });

        this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.options, {
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: []
        });

        if ($.fn.slick) {
            $(this.$el).slick(this.options);
        }
    }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["is-single"],
    data: function data() {
        return {
            options: __webpack_require__(80)
        };
    },
    mounted: function mounted() {
        this.create();
    },
    beforeDestroy: function beforeDestroy() {
        if ($.fn.slick) {
            $(this.$el).slick("unslick");
        }
    },


    methods: {
        create: function create() {
            var $slick = $(this.$el);

            $slick.on("afterChange", this.onAfterChange);
            $slick.on("beforeChange", this.onBeforeChange);
            $slick.on("breakpoint", this.onBreakpoint);
            $slick.on("destroy", this.onDestroy);
            $slick.on("edge", this.onEdge);
            $slick.on("init", this.onInit);
            $slick.on("reInit", this.onReInit);
            $slick.on("setPosition", this.onSetPosition);
            $slick.on("swipe", this.onSwipe);
            $slick.on("lazyLoaded", this.onLazyLoaded);
            $slick.on("lazyLoadError", this.onLazyLoadError);

            if (this.isSingle) {
                this.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.options, {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: []
                });
            }

            if ($.fn.slick) {
                $slick.slick(this.options);
            }
        },
        updateFirstItem: function updateFirstItem(slick) {
            if (!slick) return;

            var $firstActive = $(".slick-active", slick.$slider).eq(0);
            var $Slides = $(".slick-slide", slick.$slider);

            $Slides.removeClass("sm:border-transparent");
            $firstActive.addClass("sm:border-transparent");
        },
        destroy: function destroy() {
            $(this.$el).slick("unslick");
        },
        reSlick: function reSlick() {
            this.destroy();
            this.create();
        },
        next: function next() {
            $(this.$el).slick("slickNext");
        },
        prev: function prev() {
            $(this.$el).slick("slickPrev");
        },
        pause: function pause() {
            $(this.$el).slick("slickPause");
        },
        play: function play() {
            $(this.$el).slick("slickPlay");
        },
        goTo: function goTo(index, dontAnimate) {
            $(this.$el).slick("slickGoTo", index, dontAnimate);
        },
        currentSlide: function currentSlide() {
            return $(this.$el).slick("slickCurrentSlide");
        },
        add: function add(element, index, addBefore) {
            $(this.$el).slick("slickAdd", element, index, addBefore);
        },
        remove: function remove(index, removeBefore) {
            $(this.$el).slick("slickRemove", index, removeBefore);
        },
        filter: function filter(filterData) {
            $(this.$el).slick("slickFilter", filterData);
        },
        unfilter: function unfilter() {
            $(this.$el).slick("slickUnfilter");
        },
        getOption: function getOption(option) {
            $(this.$el).slick("slickGetOption", option);
        },
        setOption: function setOption(option, value, refresh) {
            $(this.$el).slick("slickSetOption", option, value, refresh);
        },
        setPosition: function setPosition() {
            $(this.$el).slick("setPosition");
        },


        // Events
        onAfterChange: function onAfterChange(event, slick, currentSlide) {
            this.updateFirstItem(slick);
            this.$emit("afterChange", event, slick, currentSlide);
        },
        onBeforeChange: function onBeforeChange(event, slick, currentSlide, nextSlide) {
            this.$emit("beforeChange", event, slick, currentSlide, nextSlide);
        },
        onBreakpoint: function onBreakpoint(event, slick, breakpoint) {
            this.$emit("breakpoint", event, slick, breakpoint);
        },
        onDestroy: function onDestroy(event, slick) {
            this.$emit("destroy", event, slick);
        },
        onEdge: function onEdge(event, slick, direction) {
            this.$emit("edge", event, slick, direction);
        },
        onInit: function onInit(event, slick) {
            this.updateFirstItem(slick);
            this.$emit("init", event, slick);
        },
        onReInit: function onReInit(event, slick) {
            this.$emit("reInit", event, slick);
        },
        onSetPosition: function onSetPosition(event, slick) {
            if (event.target.slick && event.target.slick.slideCount) {
                if (event.target.slick.slideCount > 4) {
                    $(this.$el).addClass("flex items-center");
                }
            }
            this.$emit("setPosition", event, slick);
        },
        onSwipe: function onSwipe(event, slick, direction) {
            this.$emit("swipe", event, slick, direction);
        },
        onLazyLoaded: function onLazyLoaded(event, slick, image, imageSource) {
            this.$emit("lazyLoaded", event, slick, image, imageSource);
        },
        onLazyLoadError: function onLazyLoadError(event, slick, image, imageSource) {
            this.$emit("lazyLoadError", event, slick, image, imageSource);
        }
    }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_get_query_param__ = __webpack_require__(104);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["taxonomy", "label"],
    name: "taxonomy-select",
    data: function data() {
        return {
            parentName: this.$parent.$options.name,
            selected: ""
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
        taxonomyItems: function taxonomyItems(state) {
            if (this.taxonomy == "commodity") {
                return state.tax_commodities;
            } else if (this.taxonomy == "region") {
                return state.regions;
            } else if (this.taxonomy == "topic") {
                return state.topics;
            } else if (this.taxonomy == "country") {
                return state.tax_countries;
            } else if (this.taxonomy == "categories") {
                return state.categories;
            } else if (this.taxonomy == "member_type") {
                return state.member_type;
            } else if (this.taxonomy == "member_area_of_business") {
                return state.member_area_of_business;
            } else if (this.taxonomy == "year") {
                return this.getYearsArray();
            } else if (this.taxonomy == "alphabet") {
                return this.getAlphabetArray();
            }
        }
    })),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(["updateUrlHashFilter"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(["getTaxonomy", "getNewsroomFeed", "handleFilters"]), {
        selectChange: function selectChange() {
            var payload = {
                type: this.parentName,
                taxonomy: this.taxonomy,
                selected: this.selected
            };

            this.handleFilters(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload));

            var h = {};
            h[this.taxonomy] = this.selected;
            this.updateUrlHashFilter(h);

            if (this.parentName != "member-filter") {
                this.getNewsroomFeed();
            }
        },
        getYearsArray: function getYearsArray() {
            // 2010 has the oldest content
            var startYear = 2010;

            var yearCount = new Date().getFullYear(),
                years = [];

            while (yearCount >= startYear) {
                var obj = {
                    id: yearCount,
                    name: yearCount
                };
                years.push(obj);
                yearCount--;
            }

            return years;
        },
        getAlphabetArray: function getAlphabetArray() {
            var alphabet = [];

            "abcdefghijklmnopqrstuvwxyz".split("").forEach(function (letter) {
                var obj = {
                    id: letter,
                    name: letter.toUpperCase()
                };

                alphabet.push(obj);
            });

            return alphabet;
        },
        resetSelected: function resetSelected() {
            this.selected = "";
        },
        checkPredefinedFilter: function checkPredefinedFilter() {
            var urlFilter = location.hash.substring(1);

            if (!urlFilter) return;

            urlFilter = "?" + urlFilter;
            var filterValue = parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_get_query_param__["a" /* default */])(this.taxonomy, urlFilter));

            if (filterValue) {
                var payload = {
                    type: this.parentName,
                    taxonomy: this.taxonomy,
                    selected: filterValue
                };

                this.handleFilters(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload));

                this.selected = filterValue;
            }
        }
    }),
    created: function created() {
        this.checkPredefinedFilter();

        if (this.taxonomy != "year") {
            this.getTaxonomy(this.taxonomy);
        }

        __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$on("form-reset", this.resetSelected);
    },

    // It's good to clean up event listeners before
    // a component is destroyed.
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$off("form-reset", this.resetSelected);
    }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["text"],
    name: "tooltip",
    data: function data() {
        return {
            disabled: true
        };
    },

    methods: {
        toggle: function toggle() {
            this.disabled = !this.disabled;
        }
    }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (paramName, queryString) {
    paramName = paramName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + paramName + "=([^&#]*)"),
        results = regex.exec(queryString ? queryString : window.location.href);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resizeGridItem */
/* harmony export (immutable) */ __webpack_exports__["a"] = resizeAllGridItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkGridAfterImagesLoaded;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);


function resizeGridItem(item) {
    var grid = $(item).closest(".mg-grid")[0];

    if (!grid) return;

    var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-auto-rows"));
    var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-row-gap"));
    var rowSpan = Math.ceil((item.querySelector(".hentry").getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
    item.style.msGridRowSpan = rowSpan;
    item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllGridItems() {
    var allItems = document.getElementsByClassName("mg-grid__item");
    for (var x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
}

function resizeInstance(instance) {
    var item = instance.elements[0];
    resizeGridItem(item);
}

function checkGridAfterImagesLoaded() {
    var grid = document.querySelector(".mg-grid");
    if (grid) {
        __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
        imagesLoaded(grid, __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done);
    }

    var allItems = document.getElementsByClassName("mg-grid__item");
    for (var x = 0; x < allItems.length; x++) {
        imagesLoaded(allItems[x], resizeInstance);
    }
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    resizeGridItem: resizeGridItem,
    resizeAllGridItems: resizeAllGridItems,
    checkGridAfterImagesLoaded: checkGridAfterImagesLoaded
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (country) {
    var stringsToRemove = ["(*)", ", not elsewhere specified", ", The"];

    stringsToRemove.forEach(function (string) {
        country = country.replace(string, "");
    });

    return country;
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(26);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(21)(function () {
  return Object.defineProperty(__webpack_require__(53)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(26);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(28);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(38);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(120);
var hide = __webpack_require__(15);
var has = __webpack_require__(14);
var Iterators = __webpack_require__(28);
var $iterCreate = __webpack_require__(220);
var setToStringTag = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(228);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(225);
var enumBugKeys = __webpack_require__(54);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(53)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(108).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(117);
var hiddenKeys = __webpack_require__(54).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(14);
var toIObject = __webpack_require__(22);
var arrayIndexOf = __webpack_require__(214)(false);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(16);
var newPromiseCapability = __webpack_require__(55);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(15);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(37);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(27);
var invoke = __webpack_require__(218);
var html = __webpack_require__(108);
var cel = __webpack_require__(53);
var global = __webpack_require__(4);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(26)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(107);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(28);
module.exports = __webpack_require__(6).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {



/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235);
var global = __webpack_require__(4);
var hide = __webpack_require__(15);
var Iterators = __webpack_require__(28);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(32)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(17)
var setISOYear = __webpack_require__(154)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(32)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(43)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(32)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(43)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(17)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var differenceInCalendarDays = __webpack_require__(44)
var compareAsc = __webpack_require__(33)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(66)
var parse = __webpack_require__(0)
var differenceInSeconds = __webpack_require__(68)
var differenceInMonths = __webpack_require__(67)
var enLocale = __webpack_require__(74)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var startOfYear = __webpack_require__(160)
var differenceInCalendarDays = __webpack_require__(44)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__(156)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(73)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(34)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__(157)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(158)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__(159)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(72)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var startOfISOYear = __webpack_require__(34)
var differenceInCalendarDays = __webpack_require__(44)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var getDaysInMonth = __webpack_require__(70)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__(128)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taxonomy_select_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c53e3dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taxonomy_select_vue__ = __webpack_require__(391);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taxonomy_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c53e3dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taxonomy_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(407)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 174 */,
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_navigation__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_content__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_hero_fade__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_format_hero_tagline__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_search__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_controls__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_map__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_related_items__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_side_nav__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_offices_map__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_video__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__partials_googlemaps__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__partials_more_news__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__partials_reports_feed__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__partials_home_modal_video__ = __webpack_require__(184);
// Only load app.vue if not on the homepage or on the search results page or a gform page

if (window.location.pathname !== "/ltamex/") {
	if (!document.querySelector(".gform_wrapper") && !document.querySelector(".page-template-template-search-results-php")) {
		__webpack_require__(363);
	}
}
/*
 * Add JavaScript modules below
 */

















__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__partials_navigation__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__partials_content__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__partials_hero_fade__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__partials_format_hero_tagline__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__partials_search__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__partials_controls__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__partials_map__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__partials_related_items__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__partials_side_nav__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__partials_offices_map__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__partials_video__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__partials_googlemaps__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__partials_more_news__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__partials_home_modal_video__["a" /* default */])();
//reports();

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {"Andorra":{"code":"AD","lat":42.546245,"long":1.601554,"name":"Andorra"},"United Arab Emirates":{"code":"AE","lat":23.424076,"long":53.847818,"name":"United Arab Emirates"},"Afghanistan":{"code":"AF","lat":33.93911,"long":67.709953,"name":"Afghanistan"},"Antigua and Barbuda":{"code":"AG","lat":17.060816,"long":-61.796428,"name":"Antigua and Barbuda"},"Anguilla":{"code":"AI","lat":18.220554,"long":-63.068615,"name":"Anguilla"},"Albania":{"code":"AL","lat":41.153332,"long":20.168331,"name":"Albania"},"Armenia":{"code":"AM","lat":40.069099,"long":45.038189,"name":"Armenia"},"Netherlands Antilles":{"code":"AN","lat":12.226079,"long":-69.060087,"name":"Netherlands Antilles"},"Angola":{"code":"AO","lat":-11.202692,"long":17.873887,"name":"Angola"},"Antarctica":{"code":"AQ","lat":-75.250973,"long":-0.071389,"name":"Antarctica"},"Argentina":{"code":"AR","lat":-38.416097,"long":-63.616672,"name":"Argentina"},"American Samoa":{"code":"AS","lat":-14.270972,"long":-170.132217,"name":"American Samoa"},"Austria":{"code":"AT","lat":47.516231,"long":14.550072,"name":"Austria"},"Australia":{"code":"AU","lat":-25.274398,"long":133.775136,"name":"Australia"},"Aruba":{"code":"AW","lat":12.52111,"long":-69.968338,"name":"Aruba"},"Azerbaijan":{"code":"AZ","lat":40.143105,"long":47.576927,"name":"Azerbaijan"},"Bosnia and Herzegovina":{"code":"BA","lat":43.915886,"long":17.679076,"name":"Bosnia and Herzegovina"},"Barbados":{"code":"BB","lat":13.193887,"long":-59.543198,"name":"Barbados"},"Bangladesh":{"code":"BD","lat":23.684994,"long":90.356331,"name":"Bangladesh"},"Belgium":{"code":"BE","lat":50.503887,"long":4.469936,"name":"Belgium"},"Burkina Faso":{"code":"BF","lat":12.238333,"long":-1.561593,"name":"Burkina Faso"},"Bulgaria":{"code":"BG","lat":42.733883,"long":25.48583,"name":"Bulgaria"},"Bahrain":{"code":"BH","lat":25.930414,"long":50.637772,"name":"Bahrain"},"Burundi":{"code":"BI","lat":-3.373056,"long":29.918886,"name":"Burundi"},"Benin":{"code":"BJ","lat":9.30769,"long":2.315834,"name":"Benin"},"Bermuda":{"code":"BM","lat":32.321384,"long":-64.75737,"name":"Bermuda"},"Brunei":{"code":"BN","lat":4.535277,"long":114.727669,"name":"Brunei"},"Bolivia":{"code":"BO","lat":-16.290154,"long":-63.588653,"name":"Bolivia"},"Brazil":{"code":"BR","lat":-14.235004,"long":-51.92528,"name":"Brazil"},"Bahamas":{"code":"BS","lat":25.03428,"long":-77.39628,"name":"Bahamas"},"Bhutan":{"code":"BT","lat":27.514162,"long":90.433601,"name":"Bhutan"},"Bouvet Island":{"code":"BV","lat":-54.423199,"long":3.413194,"name":"Bouvet Island"},"Botswana":{"code":"BW","lat":-22.328474,"long":24.684866,"name":"Botswana"},"Belarus":{"code":"BY","lat":53.709807,"long":27.953389,"name":"Belarus"},"Belize":{"code":"BZ","lat":17.189877,"long":-88.49765,"name":"Belize"},"Canada":{"code":"CA","lat":56.130366,"long":-106.346771,"name":"Canada"},"Cocos Islands":{"code":"CC","lat":-12.164165,"long":96.870956,"name":"Cocos Islands"},"Congo":{"code":"CG","lat":-0.228021,"long":15.827659,"name":"Congo"},"Central African Republic":{"code":"CF","lat":6.611111,"long":20.939444,"name":"Central African Republic"},"Switzerland":{"code":"CH","lat":46.818188,"long":8.227512,"name":"Switzerland"},"Cote d'Ivoire":{"code":"CI","lat":7.539989,"long":-5.54708,"name":"Cote d'Ivoire"},"Cook Islands":{"code":"CK","lat":-21.236736,"long":-159.777671,"name":"Cook Islands"},"Chile":{"code":"CL","lat":-35.675147,"long":-71.542969,"name":"Chile"},"Cameroon":{"code":"CM","lat":7.369722,"long":12.354722,"name":"Cameroon"},"China":{"code":"CN","lat":35.86166,"long":104.195397,"name":"China"},"Colombia":{"code":"CO","lat":4.570868,"long":-74.297333,"name":"Colombia"},"Costa Rica":{"code":"CR","lat":9.748917,"long":-83.753428,"name":"Costa Rica"},"Cuba":{"code":"CU","lat":21.521757,"long":-77.781167,"name":"Cuba"},"Cape Verde":{"code":"CV","lat":16.002082,"long":-24.013197,"name":"Cape Verde"},"Christmas Island":{"code":"CX","lat":-10.447525,"long":105.690449,"name":"Christmas Island"},"Cyprus":{"code":"CY","lat":35.126413,"long":33.429859,"name":"Cyprus"},"Czech Republic":{"code":"CZ","lat":49.817492,"long":15.472962,"name":"Czech Republic"},"Germany":{"code":"DE","lat":51.165691,"long":10.451526,"name":"Germany"},"Djibouti":{"code":"DJ","lat":11.825138,"long":42.590275,"name":"Djibouti"},"Denmark":{"code":"DK","lat":56.26392,"long":9.501785,"name":"Denmark"},"Dominica":{"code":"DM","lat":15.414999,"long":-61.370976,"name":"Dominica"},"Dominican Republic":{"code":"DO","lat":18.735693,"long":-70.162651,"name":"Dominican Republic"},"Algeria":{"code":"DZ","lat":28.033886,"long":1.659626,"name":"Algeria"},"Ecuador":{"code":"EC","lat":-1.831239,"long":-78.183406,"name":"Ecuador"},"Estonia":{"code":"EE","lat":58.595272,"long":25.013607,"name":"Estonia"},"Egypt":{"code":"EG","lat":26.820553,"long":30.802498,"name":"Egypt"},"Western Sahara":{"code":"EH","lat":24.215527,"long":-12.885834,"name":"Western Sahara"},"Eritrea":{"code":"ER","lat":15.179384,"long":39.782334,"name":"Eritrea"},"Spain":{"code":"ES","lat":40.463667,"long":-3.74922,"name":"Spain"},"Ethiopia":{"code":"ET","lat":9.145,"long":40.489673,"name":"Ethiopia"},"Finland":{"code":"FI","lat":61.92411,"long":25.748151,"name":"Finland"},"Fiji":{"code":"FJ","lat":-16.578193,"long":179.414413,"name":"Fiji"},"Falkland Islands (Islas Malvinas)":{"code":"FK","lat":-51.796253,"long":-59.523613,"name":"Falkland Islands (Islas Malvinas)"},"Micronesia":{"code":"FM","lat":7.425554,"long":150.550812,"name":"Micronesia"},"Faroe Islands":{"code":"FO","lat":61.892635,"long":-6.911806,"name":"Faroe Islands"},"France":{"code":"FR","lat":46.227638,"long":2.213749,"name":"France"},"Gabon":{"code":"GA","lat":-0.803689,"long":11.609444,"name":"Gabon"},"United Kingdom":{"code":"GB","lat":55.378051,"long":-3.435973,"name":"United Kingdom"},"Grenada":{"code":"GD","lat":12.262776,"long":-61.604171,"name":"Grenada"},"Georgia":{"code":"GE","lat":42.315407,"long":43.356892,"name":"Georgia"},"French Guiana":{"code":"GF","lat":3.933889,"long":-53.125782,"name":"French Guiana"},"Guernsey":{"code":"GG","lat":49.465691,"long":-2.585278,"name":"Guernsey"},"Ghana":{"code":"GH","lat":7.946527,"long":-1.023194,"name":"Ghana"},"Gibraltar":{"code":"GI","lat":36.137741,"long":-5.345374,"name":"Gibraltar"},"Greenland":{"code":"GL","lat":71.706936,"long":-42.604303,"name":"Greenland"},"Gambia":{"code":"GM","lat":13.443182,"long":-15.310139,"name":"Gambia"},"Guinea":{"code":"GN","lat":9.945587,"long":-9.696645,"name":"Guinea"},"Guadeloupe":{"code":"GP","lat":16.995971,"long":-62.067641,"name":"Guadeloupe"},"Equatorial Guinea":{"code":"GQ","lat":1.650801,"long":10.267895,"name":"Equatorial Guinea"},"Greece":{"code":"GR","lat":39.074208,"long":21.824312,"name":"Greece"},"South Georgia and the South Sandwich Islands":{"code":"GS","lat":-54.429579,"long":-36.587909,"name":"South Georgia and the South Sandwich Islands"},"Guatemala":{"code":"GT","lat":15.783471,"long":-90.230759,"name":"Guatemala"},"Guam":{"code":"GU","lat":13.444304,"long":144.793731,"name":"Guam"},"Guinea-Bissau":{"code":"GW","lat":11.803749,"long":-15.180413,"name":"Guinea-Bissau"},"Guyana":{"code":"GY","lat":4.860416,"long":-58.93018,"name":"Guyana"},"Gaza Strip":{"code":"GZ","lat":31.354676,"long":34.308825,"name":"Gaza Strip"},"Hong Kong":{"code":"HK","lat":22.396428,"long":114.109497,"name":"Hong Kong"},"Heard Island and McDonald Islands":{"code":"HM","lat":-53.08181,"long":73.504158,"name":"Heard Island and McDonald Islands"},"Honduras":{"code":"HN","lat":15.199999,"long":-86.241905,"name":"Honduras"},"Croatia":{"code":"HR","lat":45.1,"long":15.2,"name":"Croatia"},"Haiti":{"code":"HT","lat":18.971187,"long":-72.285215,"name":"Haiti"},"Hungary":{"code":"HU","lat":47.162494,"long":19.503304,"name":"Hungary"},"Indonesia":{"code":"ID","lat":-0.789275,"long":113.921327,"name":"Indonesia"},"Ireland":{"code":"IE","lat":53.41291,"long":-8.24389,"name":"Ireland"},"Israel":{"code":"IL","lat":31.046051,"long":34.851612,"name":"Israel"},"Isle of Man":{"code":"IM","lat":54.236107,"long":-4.548056,"name":"Isle of Man"},"India":{"code":"IN","lat":20.593684,"long":78.96288,"name":"India"},"British Indian Ocean Territory":{"code":"IO","lat":-6.343194,"long":71.876519,"name":"British Indian Ocean Territory"},"Iraq":{"code":"IQ","lat":33.223191,"long":43.679291,"name":"Iraq"},"Iran":{"code":"IR","lat":32.427908,"long":53.688046,"name":"Iran"},"Iceland":{"code":"IS","lat":64.963051,"long":-19.020835,"name":"Iceland"},"Italy":{"code":"IT","lat":41.87194,"long":12.56738,"name":"Italy"},"Jersey":{"code":"JE","lat":49.214439,"long":-2.13125,"name":"Jersey"},"Jamaica":{"code":"JM","lat":18.109581,"long":-77.297508,"name":"Jamaica"},"Jordan":{"code":"JO","lat":30.585164,"long":36.238414,"name":"Jordan"},"Japan":{"code":"JP","lat":36.204824,"long":138.252924,"name":"Japan"},"Kenya":{"code":"KE","lat":-0.023559,"long":37.906193,"name":"Kenya"},"Kyrgyzstan":{"code":"KG","lat":41.20438,"long":74.766098,"name":"Kyrgyzstan"},"Cambodia":{"code":"KH","lat":12.565679,"long":104.990963,"name":"Cambodia"},"Kiribati":{"code":"KI","lat":-3.370417,"long":-168.734039,"name":"Kiribati"},"Comoros":{"code":"KM","lat":-11.875001,"long":43.872219,"name":"Comoros"},"Saint Kitts and Nevis":{"code":"KN","lat":17.357822,"long":-62.782998,"name":"Saint Kitts and Nevis"},"North Korea":{"code":"KP","lat":40.339852,"long":127.510093,"name":"North Korea"},"South Korea":{"code":"KR","lat":35.907757,"long":127.766922,"name":"South Korea"},"Kuwait":{"code":"KW","lat":29.31166,"long":47.481766,"name":"Kuwait"},"Cayman Islands":{"code":"KY","lat":19.513469,"long":-80.566956,"name":"Cayman Islands"},"Kazakhstan":{"code":"KZ","lat":48.019573,"long":66.923684,"name":"Kazakhstan"},"Laos":{"code":"LA","lat":19.85627,"long":102.495496,"name":"Laos"},"Lebanon":{"code":"LB","lat":33.854721,"long":35.862285,"name":"Lebanon"},"Saint Lucia":{"code":"LC","lat":13.909444,"long":-60.978893,"name":"Saint Lucia"},"Liechtenstein":{"code":"LI","lat":47.166,"long":9.555373,"name":"Liechtenstein"},"Sri Lanka":{"code":"LK","lat":7.873054,"long":80.771797,"name":"Sri Lanka"},"Liberia":{"code":"LR","lat":6.428055,"long":-9.429499,"name":"Liberia"},"Lesotho":{"code":"LS","lat":-29.609988,"long":28.233608,"name":"Lesotho"},"Lithuania":{"code":"LT","lat":55.169438,"long":23.881275,"name":"Lithuania"},"Luxembourg":{"code":"LU","lat":49.815273,"long":6.129583,"name":"Luxembourg"},"Latvia":{"code":"LV","lat":56.879635,"long":24.603189,"name":"Latvia"},"Libya":{"code":"LY","lat":26.3351,"long":17.228331,"name":"Libya"},"Morocco":{"code":"MA","lat":31.791702,"long":-7.09262,"name":"Morocco"},"Monaco":{"code":"MC","lat":43.750298,"long":7.412841,"name":"Monaco"},"Moldova":{"code":"MD","lat":47.411631,"long":28.369885,"name":"Moldova"},"Montenegro":{"code":"ME","lat":42.708678,"long":19.37439,"name":"Montenegro"},"Madagascar":{"code":"MG","lat":-18.766947,"long":46.869107,"name":"Madagascar"},"Marshall Islands":{"code":"MH","lat":7.131474,"long":171.184478,"name":"Marshall Islands"},"Macedonia":{"code":"MK","lat":41.608635,"long":21.745275,"name":"Macedonia"},"Mali":{"code":"ML","lat":17.570692,"long":-3.996166,"name":"Mali"},"Myanmar":{"code":"MM","lat":21.913965,"long":95.956223,"name":"Myanmar"},"Mongolia":{"code":"MN","lat":46.862496,"long":103.846656,"name":"Mongolia"},"Macau":{"code":"MO","lat":22.198745,"long":113.543873,"name":"Macau"},"Northern Mariana Islands":{"code":"MP","lat":17.33083,"long":145.38469,"name":"Northern Mariana Islands"},"Martinique":{"code":"MQ","lat":14.641528,"long":-61.024174,"name":"Martinique"},"Mauritania":{"code":"MR","lat":21.00789,"long":-10.940835,"name":"Mauritania"},"Montserrat":{"code":"MS","lat":16.742498,"long":-62.187366,"name":"Montserrat"},"Malta":{"code":"MT","lat":35.937496,"long":14.375416,"name":"Malta"},"Mauritius":{"code":"MU","lat":-20.348404,"long":57.552152,"name":"Mauritius"},"Maldives":{"code":"MV","lat":3.202778,"long":73.22068,"name":"Maldives"},"Malawi":{"code":"MW","lat":-13.254308,"long":34.301525,"name":"Malawi"},"Mexico":{"code":"MX","lat":23.634501,"long":-102.552784,"name":"Mexico"},"Malaysia":{"code":"MY","lat":4.210484,"long":101.975766,"name":"Malaysia"},"Mozambique":{"code":"MZ","lat":-18.665695,"long":35.529562,"name":"Mozambique"},"Namibia":{"code":"NA","lat":-22.95764,"long":18.49041,"name":"Namibia"},"New Caledonia":{"code":"NC","lat":-20.904305,"long":165.618042,"name":"New Caledonia"},"Niger":{"code":"NE","lat":17.607789,"long":8.081666,"name":"Niger"},"Norfolk Island":{"code":"NF","lat":-29.040835,"long":167.954712,"name":"Norfolk Island"},"Nigeria":{"code":"NG","lat":9.081999,"long":8.675277,"name":"Nigeria"},"Nicaragua":{"code":"NI","lat":12.865416,"long":-85.207229,"name":"Nicaragua"},"Netherlands":{"code":"NL","lat":52.132633,"long":5.291266,"name":"Netherlands"},"Norway":{"code":"NO","lat":60.472024,"long":8.468946,"name":"Norway"},"Nepal":{"code":"NP","lat":28.394857,"long":84.124008,"name":"Nepal"},"Nauru":{"code":"NR","lat":-0.522778,"long":166.931503,"name":"Nauru"},"Niue":{"code":"NU","lat":-19.054445,"long":-169.867233,"name":"Niue"},"New Zealand":{"code":"NZ","lat":-40.900557,"long":174.885971,"name":"New Zealand"},"Oman":{"code":"OM","lat":21.512583,"long":55.923255,"name":"Oman"},"Panama":{"code":"PA","lat":8.537981,"long":-80.782127,"name":"Panama"},"Peru":{"code":"PE","lat":-9.189967,"long":-75.015152,"name":"Peru"},"French Polynesia":{"code":"PF","lat":-17.679742,"long":-149.406843,"name":"French Polynesia"},"Papua New Guinea":{"code":"PG","lat":-6.314993,"long":143.95555,"name":"Papua New Guinea"},"Philippines":{"code":"PH","lat":12.879721,"long":121.774017,"name":"Philippines"},"Pakistan":{"code":"PK","lat":30.375321,"long":69.345116,"name":"Pakistan"},"Poland":{"code":"PL","lat":51.919438,"long":19.145136,"name":"Poland"},"Saint Pierre and Miquelon":{"code":"PM","lat":46.941936,"long":-56.27111,"name":"Saint Pierre and Miquelon"},"Pitcairn Islands":{"code":"PN","lat":-24.703615,"long":-127.439308,"name":"Pitcairn Islands"},"Puerto Rico":{"code":"PR","lat":18.220833,"long":-66.590149,"name":"Puerto Rico"},"Palestinian Territories":{"code":"PS","lat":31.952162,"long":35.233154,"name":"Palestinian Territories"},"Portugal":{"code":"PT","lat":39.399872,"long":-8.224454,"name":"Portugal"},"Palau":{"code":"PW","lat":7.51498,"long":134.58252,"name":"Palau"},"Paraguay":{"code":"PY","lat":-23.442503,"long":-58.443832,"name":"Paraguay"},"Qatar":{"code":"QA","lat":25.354826,"long":51.183884,"name":"Qatar"},"Réunion":{"code":"RE","lat":-21.115141,"long":55.536384,"name":"Réunion"},"Romania":{"code":"RO","lat":45.943161,"long":24.96676,"name":"Romania"},"Serbia":{"code":"RS","lat":44.016521,"long":21.005859,"name":"Serbia"},"Russia":{"code":"RU","lat":61.52401,"long":105.318756,"name":"Russia"},"Rwanda":{"code":"RW","lat":-1.940278,"long":29.873888,"name":"Rwanda"},"Saudi Arabia":{"code":"SA","lat":23.885942,"long":45.079162,"name":"Saudi Arabia"},"Solomon Islands":{"code":"SB","lat":-9.64571,"long":160.156194,"name":"Solomon Islands"},"Seychelles":{"code":"SC","lat":-4.679574,"long":55.491977,"name":"Seychelles"},"Sudan":{"code":"SD","lat":12.862807,"long":30.217636,"name":"Sudan"},"Sweden":{"code":"SE","lat":60.128161,"long":18.643501,"name":"Sweden"},"Singapore":{"code":"SG","lat":1.352083,"long":103.819836,"name":"Singapore"},"Saint Helena":{"code":"SH","lat":-24.143474,"long":-10.030696,"name":"Saint Helena"},"Slovenia":{"code":"SI","lat":46.151241,"long":14.995463,"name":"Slovenia"},"Svalbard and Jan Mayen":{"code":"SJ","lat":77.553604,"long":23.670272,"name":"Svalbard and Jan Mayen"},"Slovakia":{"code":"SK","lat":48.669026,"long":19.699024,"name":"Slovakia"},"Sierra Leone":{"code":"SL","lat":8.460555,"long":-11.779889,"name":"Sierra Leone"},"San Marino":{"code":"SM","lat":43.94236,"long":12.457777,"name":"San Marino"},"Senegal":{"code":"SN","lat":14.497401,"long":-14.452362,"name":"Senegal"},"Somalia":{"code":"SO","lat":5.152149,"long":46.199616,"name":"Somalia"},"Suriname":{"code":"SR","lat":3.919305,"long":-56.027783,"name":"Suriname"},"São Tomé and Príncipe":{"code":"ST","lat":0.18636,"long":6.613081,"name":"São Tomé and Príncipe"},"El Salvador":{"code":"SV","lat":13.794185,"long":-88.89653,"name":"El Salvador"},"Syria":{"code":"SY","lat":34.802075,"long":38.996815,"name":"Syria"},"Swaziland":{"code":"SZ","lat":-26.522503,"long":31.465866,"name":"Swaziland"},"Turks and Caicos Islands":{"code":"TC","lat":21.694025,"long":-71.797928,"name":"Turks and Caicos Islands"},"Chad":{"code":"TD","lat":15.454166,"long":18.732207,"name":"Chad"},"French Southern Territories":{"code":"TF","lat":-49.280366,"long":69.348557,"name":"French Southern Territories"},"Togo":{"code":"TG","lat":8.619543,"long":0.824782,"name":"Togo"},"Thailand":{"code":"TH","lat":15.870032,"long":100.992541,"name":"Thailand"},"Tajikistan":{"code":"TJ","lat":38.861034,"long":71.276093,"name":"Tajikistan"},"Tokelau":{"code":"TK","lat":-8.967363,"long":-171.855881,"name":"Tokelau"},"Timor-Leste":{"code":"TL","lat":-8.874217,"long":125.727539,"name":"Timor-Leste"},"Turkmenistan":{"code":"TM","lat":38.969719,"long":59.556278,"name":"Turkmenistan"},"Tunisia":{"code":"TN","lat":33.886917,"long":9.537499,"name":"Tunisia"},"Tonga":{"code":"TO","lat":-21.178986,"long":-175.198242,"name":"Tonga"},"Turkey":{"code":"TR","lat":38.963745,"long":35.243322,"name":"Turkey"},"Trinidad and Tobago":{"code":"TT","lat":10.691803,"long":-61.222503,"name":"Trinidad and Tobago"},"Tuvalu":{"code":"TV","lat":-7.109535,"long":177.64933,"name":"Tuvalu"},"Taiwan":{"code":"TW","lat":23.69781,"long":120.960515,"name":"Taiwan"},"Tanzania":{"code":"TZ","lat":-6.369028,"long":34.888822,"name":"Tanzania"},"Ukraine":{"code":"UA","lat":48.379433,"long":31.16558,"name":"Ukraine"},"Uganda":{"code":"UG","lat":1.373333,"long":32.290275,"name":"Uganda"},"U.S. Minor Outlying Islands":{"code":"UM","lat":null,"long":null,"name":"U.S. Minor Outlying Islands"},"United States":{"code":"US","lat":37.09024,"long":-95.712891,"name":"United States"},"Uruguay":{"code":"UY","lat":-32.522779,"long":-55.765835,"name":"Uruguay"},"Uzbekistan":{"code":"UZ","lat":41.377491,"long":64.585262,"name":"Uzbekistan"},"Vatican City":{"code":"VA","lat":41.902916,"long":12.453389,"name":"Vatican City"},"Saint Vincent and the Grenadines":{"code":"VC","lat":12.984305,"long":-61.287228,"name":"Saint Vincent and the Grenadines"},"Venezuela":{"code":"VE","lat":6.42375,"long":-66.58973,"name":"Venezuela"},"British Virgin Islands":{"code":"VG","lat":18.420695,"long":-64.639968,"name":"British Virgin Islands"},"U.S. Virgin Islands":{"code":"VI","lat":18.335765,"long":-64.896335,"name":"U.S. Virgin Islands"},"Vietnam":{"code":"VN","lat":14.058324,"long":108.277199,"name":"Vietnam"},"Vanuatu":{"code":"VU","lat":-15.376706,"long":166.959158,"name":"Vanuatu"},"Wallis and Futuna":{"code":"WF","lat":-13.768752,"long":-177.156097,"name":"Wallis and Futuna"},"Samoa":{"code":"WS","lat":-13.759029,"long":-172.104629,"name":"Samoa"},"Kosovo":{"code":"XK","lat":42.602636,"long":20.902977,"name":"Kosovo"},"Yemen":{"code":"YE","lat":15.552727,"long":48.516388,"name":"Yemen"},"Mayotte":{"code":"YT","lat":-12.8275,"long":45.166244,"name":"Mayotte"},"South Africa":{"code":"ZA","lat":-30.559482,"long":22.937506,"name":"South Africa"},"Zambia":{"code":"ZM","lat":-13.133897,"long":27.849332,"name":"Zambia"},"Zimbabwe":{"code":"ZW","lat":-19.015438,"long":29.154857,"name":"Zimbabwe"},"World Total":{"code":"ROO","lat":34.644972,"long":9.602791,"name":"World Total"}}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_grid_utilities__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lazy_images__ = __webpack_require__(185);





/* harmony default export */ __webpack_exports__["a"] = (function () {
    (function ($) {
        $(function () {
            $(".js-content").removeClass("hidden");

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lazy_images__["a" /* default */])();

            $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap('<div class="video-embed" />');

            // Grids
            window.onload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_grid_utilities__["a" /* resizeAllGridItems */])();
            window.addEventListener("resize", __WEBPACK_IMPORTED_MODULE_1__utilities_grid_utilities__["a" /* resizeAllGridItems */]);

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_grid_utilities__["b" /* checkGridAfterImagesLoaded */])();
        });
    })(jQuery);
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function frontEndControls() {
    (function ($) {
        $(function () {
            var body = document.querySelector("body");
            var siteContent = document.querySelector(".site-content");
            var $backToTop = $(".mg-back-to-top");

            /**
             * Escape from full screen UI
             */
            body.onkeydown = function (e) {
                if (e.keyCode != 27) return;

                if ($(body).hasClass("fullscreen-menu")) {
                    // menu toggle button has logic
                    // to handle both the fullscreen & mobile menus
                    $(".menu-toggle").click();
                }

                if ($(".search-wrap").hasClass("animated")) {
                    $(".search-wrap").addClass("fadeOutDownBig");
                }
            };

            /**
             * Back to top
             */
            $backToTop.on("click", function (e) {
                e.preventDefault();
                $("html, body").animate({ scrollTop: 0 });
            });

            $(window).on("scroll", function () {
                var scrollFromTop = $(this).scrollTop();
                if (scrollFromTop > this.innerHeight) {
                    $backToTop.removeClass("hidden");
                } else {
                    $backToTop.addClass("hidden");
                }
            });
        });
    })(jQuery);
}

/* harmony default export */ __webpack_exports__["a"] = (frontEndControls);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

function formatHeroTagline() {
    (function ($) {
        $(function () {
            var $tagline = $(".mg-hero__tagline");
            var taglineParts = $.trim($tagline.text()).split(".");
            console.log(typeof taglineParts === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(taglineParts));
            if (taglineParts.length == 0) return;

            taglineParts.forEach(function (item, index) {
                item = $.trim(item);
                if (item) {
                    taglineParts[index] = "" + item;
                } else {
                    taglineParts.splice(index, 1);
                }
            });

            taglineParts[0] = "<div>" + taglineParts[0] + "</div>";
            $tagline.html(taglineParts.join(" "));
        });
    })(jQuery);
}

/* harmony default export */ __webpack_exports__["a"] = (formatHeroTagline);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function officeMap() {
    (function ($) {
        /*
        *  new_map
        *
        *  This function will render a Google Map onto the selected jQuery element
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	$el (jQuery element)
        *  @return	n/a
        */

        function new_map($el) {

            // var
            var $markers = $el.find('.marker');

            // vars
            var args = {
                zoom: 16,
                center: new google.maps.LatLng(0, 0),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            // create map	        	
            var map = new google.maps.Map($el[0], args);

            // add a markers reference
            map.markers = [];

            // add markers
            $markers.each(function () {

                add_marker($(this), map);
            });

            // center map
            center_map(map);

            // return
            return map;
        }

        /*
        *  add_marker
        *
        *  This function will add a marker to the selected Google Map
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	$marker (jQuery element)
        *  @param	map (Google Map object)
        *  @return	n/a
        */

        function add_marker($marker, map) {

            // var
            var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
            // create marker
            var marker = new google.maps.Marker({
                position: latlng,
                map: map
            });

            // add to array
            map.markers.push(marker);

            // if marker contains HTML, add it to an infoWindow
            if ($marker.html()) {
                // create info window
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html()
                });

                // show info window when marker is clicked
                google.maps.event.addListener(marker, 'click', function () {

                    infowindow.open(map, marker);
                });
            }
        }

        /*
        *  center_map
        *
        *  This function will center the map, showing all markers attached to this map
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	4.3.0
        *
        *  @param	map (Google Map object)
        *  @return	n/a
        */

        function center_map(map) {

            // vars
            var bounds = new google.maps.LatLngBounds();

            // loop through all markers and create bounds
            $.each(map.markers, function (i, marker) {

                var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

                bounds.extend(latlng);
            });

            // only 1 marker?
            if (map.markers.length == 1) {
                // set center of map
                map.setCenter(bounds.getCenter());
                map.setZoom(16);
            } else {
                // fit to bounds
                map.fitBounds(bounds);
            }
        }

        /*
        *  document ready
        *
        *  This function will render each map when the document is ready (page has loaded)
        *
        *  @type	function
        *  @date	8/11/2013
        *  @since	5.0.0
        *
        *  @param	n/a
        *  @return	n/a
        */
        // global var
        var map = null;

        $(document).ready(function () {

            $('.acf-map').each(function () {

                // create map
                map = new_map($(this));
            });
        });
    })(jQuery);
}

/* harmony default export */ __webpack_exports__["a"] = (officeMap);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function heroFade() {
    (function ($) {
        var $body = $("body");

        var mgHero = document.querySelector(".mg-hero");
        var heroGraphic = document.querySelector(".mg-hero__graphic");
        var siteHeader = document.querySelector(".site-header");
        var adminBar = document.querySelector("#wpadminbar");
        var heroOverlap = document.querySelector("#hero-overlap");

        var initHeroBottomDistance = void 0;
        var controlHeight = void 0;
        var diffHeroBottomControlHeight = void 0;
        var pageOffset = 0;
        var heroOverlapAmount = 0;

        function updateFadeVariables() {
            if (!mgHero) return;

            // extra offset to account for #wpadminbar
            if (adminBar) {
                pageOffset += adminBar.getBoundingClientRect().height;
            }

            if (window.getComputedStyle && window.matchMedia) {
                if (heroOverlap && window.matchMedia("(min-width: 576px)").matches) {
                    heroOverlapAmount = heroOverlap.getBoundingClientRect().height - parseInt(getComputedStyle(heroOverlap).marginBottom) * -1;
                } else {
                    heroOverlapAmount = 0;
                }
            }

            initHeroBottomDistance = mgHero.getBoundingClientRect().bottom;

            controlHeight = pageOffset + mgHero.getBoundingClientRect().height - heroOverlapAmount;

            if ($body.hasClass("home")) {
                controlHeight -= siteHeader.getBoundingClientRect().height;
            }

            // how much of the hero div has scrolled out from the viewport
            diffHeroBottomControlHeight = initHeroBottomDistance + $(window).scrollTop() - controlHeight;
        }

        function fade() {
            if (!mgHero && !heroGraphic) return;

            var heroBottomDistance = mgHero.getBoundingClientRect().bottom;
            var heroRemaining = (heroBottomDistance - diffHeroBottomControlHeight) / controlHeight;

            if (heroRemaining <= 0) {
                if (!$body.hasClass("mg-fix-header")) {
                    $(heroGraphic).css({ opacity: 0 });
                    $body.addClass("mg-fix-header");
                }
            } else {
                $(heroGraphic).css({ opacity: heroRemaining });

                if ($body.hasClass("mg-fix-header")) {
                    $body.removeClass("mg-fix-header");
                }
            }
        }

        $(function () {
            updateFadeVariables();
            fade();

            $(window).on("resize", function () {
                updateFadeVariables();
                fade();
            });

            $(window).scroll(function () {
                fade();
            });
        });
    })(jQuery);
}

/* harmony default export */ __webpack_exports__["a"] = (heroFade);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function homeModalVideo() {
  var closeButton = document.querySelector(".youtube-video-close");
  var overlayVideo = document.querySelector(".overlay-home-video");
  var videoContainer = document.querySelector(".youtube-video-container");
  var triggerButton = document.querySelector(".youtube-video-trigger");
  if (!triggerButton) {
    return; // Exit if the trigger button is not found
  }

  triggerButton.addEventListener("click", function () {
    videoContainer.classList.add("active");
    overlayVideo.classList.add("active");
    var iframe = videoContainer.querySelector("iframe");

    if (iframe) {
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
    }
  });

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      videoContainer.classList.remove("active");
      overlayVideo.classList.remove("active");
      var iframe = videoContainer.querySelector("iframe");
      if (iframe) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
      }
    });
  }
}
/* harmony default export */ __webpack_exports__["a"] = (homeModalVideo);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
    (function ($) {
        // lazy load images in image heavy sections (like multimedia page)
        $(".mg-lazy-images img[data-src]").each(function (item) {
            var src = $(this).data("src");
            if (src) {
                this.src = src;
                $(this).removeClass("hidden");
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
        $(".mg-lazy-images").imagesLoaded(function () {
            __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
        });
    })(jQuery);
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mapbox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_pip__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_pip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet_pip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_sanitize_country_name__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_format_number__ = __webpack_require__(25);

/**
 * Not using `mapbox-gl` becuase we need to support IE9
 */








var countryGeoCodes = __webpack_require__(178);

function usgcMap() {
    if (!document.querySelector("#usgc-countries")) return;

    L.mapbox.accessToken = "pk.eyJ1IjoidXNnYyIsImEiOiJjamNncDR2bGcxdHh2MndtdGZqNjU5dGw4In0.Izbw1rDP8mqblnqcuUom0Q";

    var mgApi = "/wp-json/mg/v1/",
        southWest = L.latLng(-70.875404, -157.848693),
        northEast = L.latLng(84.555321, 158.512757),
        bounds = L.latLngBounds(southWest, northEast);

    //color schemes
    var defaultScheme = {
        color: "#7ed0e0",
        fillColor: "#003e7e",
        fillOpacity: 1,
        opacity: 1,
        weight: 1
    },
        hoverAndActive = {
        color: "#d18316",
        fillColor: "#d18316",
        fillOpacity: 1,
        opacity: 1,
        weight: 1
    };

    var map = L.mapbox.map("usgc-countries", null, {
        maxBounds: bounds,
        maxZoom: 5,
        minZoom: 1
    }).setView([30.90222470517144, -9.492187500000002], 2);

    var worldLayer = void 0,
        countryMarkers = [],
        worldExportData = [];

    /**
     * If adding a layer use this format:
     *
     * { name: "Layer Name", layer: THE_FEATURE_LAYER }
     *
     */
    var mapLayers = [];

    /**
     * Disable map zoom when using scroll
     */
    map.scrollWheelZoom.disable();

    function clickMarker(e) {
        var props = e.layer.feature.properties;
        console.log(props);

        location.href = "/markets-tools-data/tools/feed-grains-in-all-forms-portal/?location=" + props.title;
    }

    function getMarketData() {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            $.ajax({
                url: mgApi + "market-data"
            }).then(function (response) {
                response.forEach(function (item) {
                    var cleanCountryName = item.market_name;

                    cleanCountryName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utilities_sanitize_country_name__["a" /* default */])(cleanCountryName);

                    var currentYearQuantity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utilities_format_number__["a" /* default */])(item.all.current_market_year_quantity),
                        currentYearValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utilities_format_number__["a" /* default */])(item.all.current_market_year_value),
                        obj = {
                        name: cleanCountryName,
                        longitude: null,
                        latitude: null,
                        id: item.id,
                        stat: "Qty: " + currentYearQuantity + "<br> Value: $" + currentYearValue
                    };

                    if (countryGeoCodes[cleanCountryName]) {
                        obj.longitude = countryGeoCodes[cleanCountryName]["long"];
                        obj.latitude = countryGeoCodes[cleanCountryName]["lat"];

                        worldExportData.push(obj);
                    }
                });

                resolve();
            }, function (error) {
                console.log("There was a problem retrieving Market Data");
                reject();
            });
        });
    }

    function MapMarkers(worldExportData) {
        if (!worldExportData) return;

        var markerLayer = L.mapbox.featureLayer().addTo(map);

        $.each(worldExportData, function (index, item) {
            /**
             * https://www.mapbox.com/help/markers-js/#add-markers-with-geojson-in-mapboxjs
             */
            var marker = {
                type: "Feature",
                geometry: {
                    type: "Point",
                    // coordinates here are in longitude, latitude order because
                    // x, y is the standard for GeoJSON and many formats
                    coordinates: [item.longitude, item.latitude]
                },
                properties: {
                    title: item.name,
                    description: item.stat,
                    id: item.id,
                    icon: {
                        className: "mg-map-pin", // class name to style
                        html: "<svg class=\"mg-icon mg-icon--medium filter-shadow-sm\"><use href=\"#icon-location\" xlink:href=\"#icon-location\"/></svg>", // add content inside the marker
                        iconSize: [32, 32]
                    }
                }
            };

            countryMarkers.push(marker);
        });

        markerLayer.on("layeradd", function (e) {
            var marker = e.layer,
                feature = marker.feature;
            marker.setIcon(L.divIcon(feature.properties.icon));
        }).on("click", clickMarker).on("mouseover", function (e) {
            e.layer.openPopup();
        }).on("mouseout", function (e) {
            e.layer.closePopup();
        }).on("mouseover", function (e) {
            e.layer.openPopup();
        });

        markerLayer.setGeoJSON(countryMarkers);
    } //MapMarkers

    function styleCountries() {
        var layersObj = worldLayer._layers,
            layersArray = $.map(layersObj, function (value, index) {
            return [value];
        });

        $.each(layersArray, function (i) {
            layersArray[i].setStyle(defaultScheme);
        });
    }

    function countryClick(e) {
        // look through each layer in order and see if the clicked point,
        // e.latlng, overlaps with one of the shapes in it.
        for (var i = 0; i < mapLayers.length; i++) {
            var match = __WEBPACK_IMPORTED_MODULE_2_leaflet_pip___default.a.pointInLayer(
            // the clicked point
            e.latlng,
            // this layer
            mapLayers[i].layer,
            // whether to stop at first match
            true);

            if (match.length) {
                var matchProps = match[0].feature.properties;
                console.log(matchProps);
            }
        }
    }

    function loadWorld() {
        worldLayer = L.mapbox.featureLayer().loadURL("/wp-content/themes/usgc/data-assets/geojson/countries.js").on("ready", styleCountries).on("click", countryClick).addTo(map);

        mapLayers.push({ name: "Countries", layer: worldLayer });
    }

    function init() {
        loadWorld();
        getMarketData().then(function () {
            MapMarkers(worldExportData);
        });
    }

    init();
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
    $(function () {
        usgcMap();
    });
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    (function ($) {
        $(function () {
            var news_page_count = 2;
            $('.more-news-local').click(function () {
                $('.more-news-local').text("Loading...");
                $.get("/wp-json/wp/v2/news/?&per_page=3&page=" + news_page_count, function (data) {
                    if (data.length) {
                        var resultsHtml = [];
                        data.forEach(function (dataItem) {
                            var img;
                            var img;
                            var d = new Date(dataItem.date);
                            console.log(d.toLocaleDateString('en'));
                            var newDate = d.toString().split(" ").slice(1, 4).join(" ");
                            //console.log(newDate.toLocaleString('en'));
                            if (dataItem.acf.has_main_image == true) {
                                img = dataItem.acf.main_image.url;
                            } else {
                                $.get("/wp-json/wp/v2/pages/94", function (data) {
                                    img = data.acf.hero_image.link;
                                });
                            }
                            var str = dataItem.content.rendered.split(" ");
                            var excerpt = [];
                            for (var i = 0; i < 15; i++) {
                                excerpt.push(str[i]);
                            }
                            var entryHtml = '\n                                <div class="card-item">\n                                <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">\n                                        <img class=\'card-image\' src="' + img + '">\n                                        <p class="my-2">\n                                                <span\n                                                        class="my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter">\n                                                        ' + newDate + '\n                                                </span><br />\n                                                <br />\n                                                <a href="' + dataItem.link + '">' + dataItem.title.rendered + '</a>\n                                                <br />\n                                                <div> ' + excerpt.join(" ") + '... <a href=\'' + dataItem.link + '\'> Read More \xBB </a> </div>\n                        </div>';
                            resultsHtml.push(entryHtml);
                            $('.more-news-local').text("More News");
                            news_page_count++;
                        });
                        $('.news-list-local').hide().append(resultsHtml).fadeIn();
                    }
                }).fail(function () {
                    $('.more-news-local').text("No more to load");
                });
            });
        });
        $(function () {
            var news_page_count = 2;
            $('.more-news').click(function () {
                $('.more-news').text("Loading...");
                $.get("https://grains.org/wp-json/wp/v2/posts/?filter[category_name]=council-news&per_page=3&page=" + news_page_count, function (data) {
                    if (data.length) {
                        var resultsHtml = [];
                        data.forEach(function (dataItem) {
                            var img;
                            var d = new Date(dataItem.date);
                            var newDate = d.toString().split(" ").slice(1, 4).join(" ");
                            if (dataItem.acf.has_main_image == true) {
                                img = dataItem.acf.main_image.url;
                            } else {
                                $.get("/wp-json/wp/v2/pages/94", function (data) {
                                    img = data.acf.hero_image.link;
                                });
                            }
                            var str = dataItem.content.rendered.split(" ");
                            var excerpt = [];
                            for (var i = 0; i < 15; i++) {
                                excerpt.push(str[i]);
                            }
                            var entryHtml = '\n                            <div class="card-item">\n                            <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">\n                                    <img class=\'card-image\' src="' + img + '">\n                                    <p class="my-2">\n                                            <span\n                                                    class="my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter">\n                                                    ' + newDate + '\n                                            </span><br />\n                                            <br />\n                                            <a href="' + dataItem.link + '">' + dataItem.title.rendered + '</a>\n                                            <br />\n                                            <div> ' + excerpt.join(" ") + '... <a href=\'' + dataItem.link + '\'> Read More\xBB </a> </div>\n                    </div>';
                            resultsHtml.push(entryHtml);
                            $('.more-news').text("More News");
                            news_page_count++;
                        });
                        $('.news-list').hide().append(resultsHtml).fadeIn();
                    }
                }).fail(function () {
                    $('.more-news-local').text("No more to load");
                });;
            });
        });
        $(function () {
            var news_page_count = 2;
            $('.more-success').click(function () {
                $('.more-success').text("Loading...");
                $.get("https://grains.org/wp-json/wp/v2/success_story/?&per_page=3&page=" + news_page_count, function (data) {
                    if (data.length) {
                        var resultsHtml = [];
                        data.forEach(function (dataItem) {
                            var img;
                            var d = new Date(dataItem.date);
                            var newDate = d.toString().split(" ").slice(1, 4).join(" ");
                            if (dataItem.acf.has_main_image == true) {
                                img = dataItem.acf.main_image.url;
                            } else {
                                $.get("/wp-json/wp/v2/pages/94", function (data) {
                                    img = data.acf.hero_image.link;
                                });
                            }
                            var str = dataItem.content.rendered.split(" ");
                            var excerpt = [];
                            for (var i = 0; i < 15; i++) {
                                excerpt.push(str[i]);
                            }
                            var entryHtml = '\n                    <div class="card-item">\n                    <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">\n                            <img class=\'card-image\' src="' + img + '">\n                            <p class="my-2">\n                                    <span\n                                            class="my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter">\n                                            ' + newDate + '\n                                    </span><br />\n                                    <br />\n                                    <a href="' + dataItem.link + '">' + dataItem.title.rendered + '</a>\n                                    <br />\n                                    <div> ' + excerpt.join(" ") + '... <a href=\'' + dataItem.link + '\'> Read More \xBB </a> </div>\n            </div>';
                            resultsHtml.push(entryHtml);
                            $('.more-success').text("More Success Stories");
                            news_page_count++;
                        });
                        $('.success-list').hide().append(resultsHtml).fadeIn();
                    }
                }).fail(function () {
                    $('.more-news-local').text("No more to load");
                });;
            });
        });
    })(jQuery);
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function navigation() {
    (function ($) {
        $(function () {
            var body = document.querySelector("body");
            var $fullscreenNav = $(".menu-full-wrap");
            /*
            $(".main-menu--top, .main-menu--full").each(function() {
                const $labelLinks = $("> li > a", this);
                const $list = this.find("li");
                //console.log($labelLinks);
                console.log($list);
                // these top level links should not go anywhere
                // removing href to disable links
                $labelLinks.removeAttr("href");
            });
            */

            $fullscreenNav.on("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
                if ($(this).hasClass("fadeIn")) {
                    $(this).removeClass("fadeIn");
                }

                if ($(this).hasClass("fadeOutDownBig")) {
                    $(this).removeClass("fadeOutDownBig animated");
                }
            });

            $(".menu-toggle").on("click touch", function () {
                if ($(body).hasClass("fullscreen-menu")) {
                    $fullscreenNav.addClass("animated fadeOutDownBig");
                } else {
                    $fullscreenNav.addClass("animated fadeIn");
                }

                $(".menu-toggle__inner", this).toggleClass("animate");
                $(body).toggleClass("fullscreen-menu");
                $(".main-navigation--top").toggleClass("main-navigation--toggled-on");
            });

            $(".close-menu-full").on("click touch", function () {
                $(".menu-toggle").click();
            });
        });
    })(jQuery);
}

/* harmony default export */ __webpack_exports__["a"] = (navigation);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
    var mapElement = document.getElementById("offices-map");
    if (!mapElement) return;

    var officeMap = new google.maps.Map(mapElement, {
        zoom: 2,
        center: { lat: 19.767622405758452, lng: -1.1435000000000173 }
    });

    officeMap.setMapTypeId(google.maps.MapTypeId.SATELLITE);

    var pinYellow = "/wp-content/themes/USGBC/images/spotlight-poi-yellow.png";
    var pinBlue = "/wp-content/themes/USGBC/images/spotlight-poi-blue.png";
    var pinRed = "/wp-content/themes/USGBC/images/spotlight-poi.png";

    var markers = [];

    function addMarker(item) {
        var lat = item.acf.latitude,
            lng = item.acf.longitude,
            itemTitle = item.title.rendered,
            officeType = item.acf.office_type,
            itemLink = item.link;

        var message = "View representive info";
        var itemIcon = pinRed;

        if (officeType) {
            itemIcon = officeType === "regional" ? pinBlue : pinYellow;
            message = "View office info";
        }

        var contentString = "<div id=\"content\">\n                                <div class=\"text-lg mb-2\"><b>" + itemTitle + "</b></div>\n                                <a href=\"" + itemLink + "\">" + message + "</a>\n                            </div>";

        var infowindow = new google.maps.InfoWindow({
            content: contentString
        });

        var marker = new google.maps.Marker({
            title: itemTitle,
            position: {
                lat: parseInt(lat),
                lng: parseInt(lng)
            },
            map: officeMap,
            icon: itemIcon,
            infowindow: infowindow
        });

        markers.push(marker);

        google.maps.event.addListener(marker, "click", function () {
            hideAllInfoWindows();
            this.infowindow.open(officeMap, this);
        });
    }

    function hideAllInfoWindows() {
        markers.forEach(function (marker) {
            marker.infowindow.close(officeMap, marker);
        });
    }

    (function ($) {
        $(function () {
            __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
            $.ajax({
                url: "/wp-json/wp/v2/office",
                data: {
                    per_page: 100
                }
            }).then(function (response) {
                response.forEach(function (office) {
                    addMarker(office);
                });
            }).always(function () {
                __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
            });

            __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
            $.ajax({
                url: "/wp-json/wp/v2/consultant",
                data: {
                    per_page: 100
                }
            }).then(function (response) {
                response.forEach(function (consultant) {
                    addMarker(consultant);
                });
            }).always(function () {
                __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
            });
        });
    })(jQuery);
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function relatedItems() {
    $(function () {
        $(window).on("scroll", function () {
            var relatedItems = document.querySelector(".mg-related-items");
            var articleBody = document.querySelector(".entry-content__body");
            var footer = document.querySelector("#colophon");
            var footerDistanceOffScreen = footer.getBoundingClientRect().top - window.innerHeight;

            if (!relatedItems || !articleBody) return;

            var checkpoint = articleBody.getBoundingClientRect().bottom - window.innerHeight + 175;

            if (checkpoint <= 0 && footerDistanceOffScreen >= 0) {
                $(relatedItems).addClass("mg-related-items--active");
            } else {
                $(relatedItems).removeClass("mg-related-items--active");
            }
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = (relatedItems);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function () {
    (function ($) {
        console.log('test');
        $(function () {
            $.get('https://grains.org/wp-json/wp/v2' + window.location.pathname, function (data) {
                if (data.length) {
                    console.log(data);
                    data.forEach(function (dataItem) {
                        console.log(dataItem.title);
                        var entryHtml = '<article id="post-' + dataItem.id + '" class=\'post-' + dataItem.id + ' market_perspectives type-market_perspectives status-publish hentry\'>\n                        <header class="entry-title leading-tight mb-2">\n                            <h2> <a class="md:text-2xl plain-link" href="' + dataItem.link + '"> ' + dataItem.title.rendered + ' <svg class="mg-icon mg-color-accent-2"> </svg> </a> </h2>\n                           </header>\n                        </article>';
                        $('.content-area').append(entryHtml);
                    });
                }
            }).fail(function () {
                console.log('Could not load data');
            });
        });
        $(function () {});
    })(jQuery);
});

/*Option one: add pagination by diving the total results by the results per page, and for each of those, creating a link to pathname/page/${number}.
 Option two: add pagination by getting the current page number and creating a +1 and -1 link, as well as a link to page 1 and last page.
 Do this just for the first and the last, and then plus one and minus one. The left/right buttons have the same link as the left and right.
 */

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function search() {
    /**
     * https://developers.google.com/custom-search/docs/element#javascript
     *
     * Google Custom Search configured with `matrixwebmaster1999`
     */

    //console.log(window.searchUrl);
    $('.search-form').on('submit', function (e) {
        e.preventDefault();
        var searchPhrase = $(this).find('[name=q]').val();
        goToSearchResults(searchPhrase, "");
    });
    function goToSearchResults(searchPhrase, searchFilters) {
        var resultsUrl = window.searchUrl + '/search-results/#!/';
        console.log(resultsUrl);
        window.location.href = resultsUrl + encodeURIComponent(searchPhrase) + '/page=1/' + searchFilters;
    }
    (function ($) {
        function closeSearch() {
            $(".search-wrap").addClass("animated fadeOutDownBig");
        }

        $(function () {
            $(".search-wrap").on("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
                if ($(this).hasClass("fadeIn")) {
                    $(this).removeClass("fadeIn");
                }

                if ($(this).hasClass("fadeOutDownBig")) {
                    $(this).removeClass("fadeOutDownBig animated");
                }
            });

            $(".search-wrap__close").on("click touch", function () {
                closeSearch();
            });

            $(".search-trigger").on("click touch", function () {
                $(".search-wrap").addClass("animated fadeIn");
                $(".search-wrap .search-field").focus();
            });
        });
    })(jQuery);
}

/* harmony default export */ __webpack_exports__["a"] = (search);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    (function ($) {
        $(function () {
            var sideNavColumn = document.querySelector(".side-nav-column");
            var sideNav = document.querySelector(".side-nav");

            if (!sideNavColumn && !sideNav) return;

            var sideNavHeight = sideNav.getBoundingClientRect().height;
            var sideNavColumnHeight = sideNavColumn.getBoundingClientRect().height;
            var fixPoint = 140;

            if (sideNavHeight === sideNavColumnHeight) return;

            var sideNavColumnTop = sideNavColumn.getBoundingClientRect().top;
            var sideNavColumnBottom = sideNavColumn.getBoundingClientRect().bottom;

            function fixSideNav() {
                if (sideNavColumnTop <= fixPoint) {
                    if (fixPoint + sideNavHeight >= sideNavColumnBottom) {
                        $(sideNav).removeClass("lg:fixed");
                        $(sideNav).addClass("lg:absolute pin-b");
                    } else {
                        $(sideNav).removeClass("lg:absolute pin-b");
                        $(sideNav).addClass("lg:fixed");
                    }
                } else {
                    $(sideNav).removeClass("lg:fixed lg:absolue pin-b");
                }
            }

            fixSideNav();

            $(window).on("scroll", function () {
                sideNavColumnTop = sideNavColumn.getBoundingClientRect().top;
                sideNavColumnBottom = sideNavColumn.getBoundingClientRect().bottom;

                fixSideNav();
            });
        });
    })(jQuery);
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * HTML Video
 * https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
    (function ($) {
        $(function () {
            var bgVideos = document.querySelectorAll("video.mg-graphic-layer");

            bgVideos.forEach(function (video) {
                var promise = video.play();

                if (promise !== undefined) {
                    promise.catch(function (error) {
                        // Auto-play was prevented
                        // Show a UI element to let the user manually start playback
                    }).then(function () {
                        // Auto-play started
                    });
                }
            });
        });
    })(jQuery);
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_hub__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nprogress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_grid_utilities__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_sort_by_prop__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_sanitize_country_name__ = __webpack_require__(106);



/*
 * Gobal state management for Vue code.
 * 
 * Please read before making edits in this file:
 * https://vuex.vuejs.org/en/core-concepts.html
 * 
 */











__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["default"]);

// API endpoints
var apiBase = "/wp-json/";
var wpApi = apiBase + "wp/v2/";
var mgApi = apiBase + "mg/v1/";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["default"].Store({
    state: {
        marketDataView: "",
        marketDataIsLoading: false,
        marketDataMode: "USDA-data",
        showDollars: true,
        activeUnit: "",
        showQty: true,
        isDesktop: null,
        marketDataYears: 5,
        markets: [],
        activePartners: [],
        activeCommodities: [],
        marketDataSettings: {
            current_market_year: "",
            previous_market_year_label: "",
            current_market_year_label: ""
        },
        colors: ["#004b98", "#93d7e5", "#b4bc1a", "#402f15", "#d18316", "#f7e066", "#eca748", "#0175b9", "#888e0a", "#cdde31", "#7f7362"],
        commodities: [{
            icon: "icon-barn",
            color: "#004b98",
            value: "all",
            text: "All"
        }, {
            icon: "icon-corn",
            color: "#93d7e5",
            value: "corn",
            text: "Corn"
        }, {
            icon: "icon-barley",
            color: "#b4bc1a",
            value: "barley-barley-products",
            text: "Barley"
        }, {
            icon: "icon-beef",
            color: "#402f15",
            value: "beef-beef-products",
            text: "Beef &amp; Beef Products"
        }, {
            icon: "icon-feed_meal",
            color: "#d18316",
            value: "corn-gluten-feed&ml",
            text: "Corn Gluten Feed/Meal"
        }, {
            icon: "icon-grain",
            color: "#f7e066",
            value: "crs-grn-products",
            text: "Coarse Grain Products"
        }, {
            icon: "icon-ddgs",
            color: "#eca748",
            value: "distillers-grains",
            text: "DDGS"
        }, {
            icon: "icon-ethanol",
            color: "#0175b9",
            value: "ethanol-(non-bev.)",
            text: "Ethanol"
        }, {
            icon: "icon-sorghum",
            color: "#888e0a",
            value: "grain-sorghum",
            text: "Sorghum"
        }, {
            icon: "icon-pork",
            color: "#cdde31",
            value: "pork-pork-products",
            text: "Pork &amp; Pork Products"
        }, {
            icon: "icon-poultry",
            color: "#7f7362",
            value: "poultry-meat-prods.-(ex.-eggs)",
            text: "Poultry Meat &amp; Product"
        }],
        top_exports_selected: "all",
        export_totals: null,
        market_data: [],
        selectedMarket: "World Total",
        activeMarket: null,
        current_page: 1,
        per_page: 10,
        tax_commodities: [],
        regions: [],
        topics: [],
        tax_countries: [],
        categories: [],
        member_type: [],
        member_area_of_business: [],
        urlHashFilter: {},
        selectedLetter: "",
        newsYear: null,
        newsTaxFilter: {
            category: [],
            topic: [],
            country: [],
            region: [],
            commodity: [],
            posttype: []
        },
        membersPaginated: true,
        memberFilter: {
            member_type: null,
            commodity: null,
            search: null,
            member_area_of_business: null
        },
        newsItems: [],
        members: [],
        totalItemsFound: null
    },
    mutations: {
        updateDollarsOption: function updateDollarsOption(state, value) {
            state.showDollars = value;
        },
        setMarketDataView: function setMarketDataView(state, value) {
            state.marketDataView = value;
        },
        setMarketDataIsLoading: function setMarketDataIsLoading(state, value) {
            state.marketDataIsLoading = value;
        },
        updateQtyOption: function updateQtyOption(state, value) {
            state.showQty = value;
        },
        updateIsDesktop: function updateIsDesktop(state, value) {
            state.isDesktop = value;
        },
        setActiveUnit: function setActiveUnit(state, value) {
            state.activeUnit = value;
        },
        setMarketDataMode: function setMarketDataMode(state, value) {
            state.marketDataMode = value;
        },
        addActiveCommodity: function addActiveCommodity(state, key) {
            state.activeCommodities.push(key);
        },
        removeActiveCommodity: function removeActiveCommodity(state, activeIndex) {
            state.activeCommodities.splice(activeIndex, 1);
        },
        addActivePartner: function addActivePartner(state, key) {
            state.activePartners.push(key);
        },
        removeActivePartner: function removeActivePartner(state, activeIndex) {
            state.activePartners.splice(activeIndex, 1);
        },
        deactivateAllCommodities: function deactivateAllCommodities(state) {
            state.activeCommodities = [];
        },
        deactivateAllPartners: function deactivateAllPartners(state) {
            state.activePartners = [];
        },
        setExportTotals: function setExportTotals(state, obj) {
            state.export_totals = obj;
        },
        setMarkets: function setMarkets(state, items) {
            var the_markets = [];
            items.forEach(function (item) {
                var obj = {
                    value: item.market_name,
                    text: item.market_name
                };
                the_markets.push(obj);
            });

            the_markets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utilities_sort_by_prop__["a" /* default */])(the_markets, "value");
            the_markets.unshift({
                value: "World Total",
                text: "World Total"
            });
            state.markets = the_markets;
        },
        setMarketData: function setMarketData(state, items) {
            state.market_data = items;
        },
        setMarketDataSettings: function setMarketDataSettings(state, payload) {
            state.marketDataSettings = payload;
        },
        setMarket: function setMarket(state, market) {
            state.activeMarket = market;
        },
        setSelectedMarket: function setSelectedMarket(state, selection) {
            state.selectedMarket = selection;
        },
        setTopExportsSelected: function setTopExportsSelected(state, value) {
            state.top_exports_selected = value;
        },
        setCurrentPage: function setCurrentPage(state, page) {
            state.current_page = page;
        },
        incrementCurrentPage: function incrementCurrentPage(state) {
            state.current_page++;
        },
        setTaxCommodities: function setTaxCommodities(state, taxonomyitems) {
            state.tax_commodities = taxonomyitems;
        },
        setRegions: function setRegions(state, taxonomyitems) {
            state.regions = taxonomyitems;
        },
        setTopics: function setTopics(state, taxonomyitems) {
            state.topics = taxonomyitems;
        },
        setTaxCountries: function setTaxCountries(state, taxonomyitems) {
            state.tax_countries = taxonomyitems;
        },
        setCategories: function setCategories(state, taxonomyitems) {
            state.categories = taxonomyitems;
        },
        setMemberTypes: function setMemberTypes(state, taxonomyitems) {
            state.member_type = taxonomyitems;
        },
        setMemberAreaOfBusiness: function setMemberAreaOfBusiness(state, taxonomyitems) {
            state.member_area_of_business = taxonomyitems;
        },
        setNewsItems: function setNewsItems(state, payload) {
            if (payload.loadMore) {
                payload.posts.forEach(function (item) {
                    state.newsItems.push(item);
                });
            } else {
                state.newsItems = payload.posts;
            }
        },
        updateUrlHashFilter: function updateUrlHashFilter(state, paylod) {
            state.urlHashFilter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.urlHashFilter, paylod);
        },
        updateNewsFilter: function updateNewsFilter(state, payload) {
            var filterKey = payload.taxonomy == "categories" ? "category" : payload.taxonomy;

            if (filterKey == "year") {
                state.newsYear = payload.selected;
            } else {
                state.newsTaxFilter[filterKey] = typeof payload.selected === "string" ? [] : [payload.selected];
            }
        },
        updateMemberFilter: function updateMemberFilter(state, payload) {
            if (payload.taxonomy == "alphabet") {
                state.selectedLetter = payload.selected;
            } else {
                state.memberFilter[payload.taxonomy] = payload.selected;
            }
        },
        resetMemberFilter: function resetMemberFilter(state) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.memberFilter).forEach(function (key) {
                state.memberFilter[key] = null;
            });

            __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$emit("form-reset");
        },
        updateMembersPaginationFlag: function updateMembersPaginationFlag(state, value) {
            state.membersPaginated = value;
        },
        resetNewsFilter: function resetNewsFilter(state) {
            state.newsYear = null;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.newsTaxFilter).forEach(function (key) {
                state.newsTaxFilter[key] = [];
            });

            __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$emit("form-reset");
        },
        setTotalFound: function setTotalFound(state, total) {
            state.totalItemsFound = total;
        },
        setMembers: function setMembers(state, payload) {
            state.members = payload;
        },
        updateMemberSearch: function updateMemberSearch(state, keyword) {
            state.memberFilter.search = keyword;
        }
    },
    getters: {
        topTenMarkets: function topTenMarkets(state) {
            if (state.market_data.length == 0) return [];

            var topTen = [];
            for (var i = 0; i < state.market_data.length; i++) {
                var market = state.market_data[i];
                if (market[state.top_exports_selected] && market[state.top_exports_selected]["current_market_year_quantity"] != null) {
                    topTen.push(state.market_data[i]);

                    if (topTen.length == 10) break;
                }
            }
            return topTen;
        },
        getCommodityProperty: function getCommodityProperty(state) {
            return function (payload) {
                if (!payload || !payload.key || !payload.property) return;
                for (var index = 0; index < state.commodities.length; index++) {
                    var commodity = state.commodities[index];
                    if (commodity.value == payload.key) {
                        return commodity[payload.property];
                    }
                }
            };
        },
        isCommodity: function isCommodity(state) {
            return function (key) {
                for (var index = 0; index < state.commodities.length; index++) {
                    var commodity = state.commodities[index];
                    if (commodity.value == key) {
                        return true;
                    }
                }
                return false;
            };
        },
        sortedData: function sortedData(state) {
            return function (obj) {
                var ordered = {};
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).sort().forEach(function (key) {
                    ordered[key] = obj[key];
                });

                return ordered;
            };
        }
    },
    actions: {
        handleFilters: function handleFilters(_ref, payload) {
            var commit = _ref.commit,
                state = _ref.state;

            if (payload.type == "member-filter") {
                commit("updateMemberFilter", payload);
            } else {
                commit("updateNewsFilter", payload);
            }
        },
        santizeCountryNames: function santizeCountryNames(_ref2, markets) {
            var state = _ref2.state;

            markets.forEach(function (item) {
                item.market_name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utilities_sanitize_country_name__["a" /* default */])(item.market_name);
            });
        },
        handleActiveUnit: function handleActiveUnit(_ref3) {
            var commit = _ref3.commit,
                state = _ref3.state;

            if (state.showQty && state.marketDataMode == "USDA-data" && state.activeCommodities.length == 1 && state.activeCommodities[0] == "ethanol-(non-bev.)") {
                commit("setActiveUnit", "GAL");
            } else {
                if (state.top_exports_selected == "ethanol-(non-bev.)") {
                    commit("setActiveUnit", "GAL");
                } else {
                    commit("setActiveUnit", "MT");
                }
            }
        },
        activateSinglePartner: function activateSinglePartner(_ref4, key) {
            var commit = _ref4.commit,
                state = _ref4.state;

            commit("deactivateAllPartners");
            commit("addActivePartner", key);
        },
        activateSingleCommodity: function activateSingleCommodity(_ref5, key) {
            var commit = _ref5.commit,
                state = _ref5.state;

            commit("deactivateAllCommodities");
            commit("addActiveCommodity", key);
        },
        activateAllCommodities: function activateAllCommodities(_ref6) {
            var commit = _ref6.commit,
                state = _ref6.state;

            state.commodities.forEach(function (commodity) {
                if (state.activeCommodities.indexOf(commodity.value) == -1) {
                    commit("addActiveCommodity", commodity.value);
                }
            });
        },
        selectMarket: function selectMarket(_ref7) {
            var commit = _ref7.commit,
                state = _ref7.state;

            if (state.selectedMarket == "World Total") {
                commit("setMarket", state.export_totals);
            } else {
                for (var index = 0; index < state.market_data.length; index++) {
                    var element = state.market_data[index];
                    if (element.market_name == state.selectedMarket) {
                        commit("setMarket", element);
                        break;
                    }
                }
            }
        },
        getExportTotals: function getExportTotals(_ref8) {
            var commit = _ref8.commit,
                state = _ref8.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
                $.ajax({
                    url: mgApi + "export-totals"
                }).then(function (response) {
                    commit("setExportTotals", response);

                    resolve();
                }, function (error) {
                    console.log("There was a problem retrieving Export Totals");
                    reject();
                }).always(function () {
                    __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
                });
            });
        },
        getExportTotalsFeedGrain: function getExportTotalsFeedGrain(_ref9) {
            var commit = _ref9.commit,
                state = _ref9.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
                $.ajax({
                    url: mgApi + "export-totals-feed-grain"
                }).then(function (response) {
                    commit("setExportTotals", response);

                    resolve();
                }, function (error) {
                    console.log("There was a problem retrieving Export Totals");
                    reject();
                }).always(function () {
                    __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
                });
            });
        },
        getMarketDataSettings: function getMarketDataSettings(_ref10) {
            var commit = _ref10.commit,
                state = _ref10.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
                commit("setMarketDataIsLoading", true);
                $.ajax({
                    url: mgApi + "market-data-settings"
                }).then(function (response) {
                    commit("setMarketDataSettings", response);
                    resolve();
                }, function (error) {
                    console.log("There was a problem retrieving Market Data Settings");
                    reject();
                }).always(function () {
                    __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
                    commit("setMarketDataIsLoading", false);
                });
            });
        },
        getMarketData: function getMarketData(_ref11) {
            var dispatch = _ref11.dispatch,
                commit = _ref11.commit,
                state = _ref11.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
                commit("setMarketDataIsLoading", true);
                $.ajax({
                    url: mgApi + "market-data"
                }).then(function (response) {
                    dispatch("santizeCountryNames", response);

                    commit("setMarkets", response);
                    commit("setMarketData", response);

                    resolve();
                }, function (error) {
                    console.log("There was a problem retrieving Market Data");
                    reject();
                }).always(function () {
                    __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
                    commit("setMarketDataIsLoading", false);
                });
            });
        },
        getMarketDataFeedGrain: function getMarketDataFeedGrain(_ref12) {
            var dispatch = _ref12.dispatch,
                commit = _ref12.commit,
                state = _ref12.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
                commit("setMarketDataIsLoading", true);
                $.ajax({
                    url: mgApi + "market-data-feed-grain"
                }).then(function (response) {
                    dispatch("santizeCountryNames", response);

                    commit("setMarkets", response);
                    commit("setMarketData", response);

                    resolve();
                }, function (error) {
                    console.log("There was a problem retrieving Market Data converted to Feed Grain");
                    reject();
                }).always(function () {
                    __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
                    commit("setMarketDataIsLoading", false);
                });
            });
        },
        getTaxonomy: function getTaxonomy(_ref13, taxonomy) {
            var commit = _ref13.commit,
                state = _ref13.state;

            if (!taxonomy) return;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
                $.ajax({
                    url: "" + wpApi + taxonomy,
                    data: {
                        per_page: 100
                    }
                }).then(function (response) {
                    if (taxonomy == "commodity") {
                        commit("setTaxCommodities", response);
                    } else if (taxonomy == "region") {
                        commit("setRegions", response);
                    } else if (taxonomy == "topic") {
                        commit("setTopics", response);
                    } else if (taxonomy == "country") {
                        commit("setTaxCountries", response);
                    } else if (taxonomy == "categories") {
                        commit("setCategories", response);
                    } else if (taxonomy == "member_type") {
                        commit("setMemberTypes", response);
                    } else if (taxonomy == "member_area_of_business") {
                        commit("setMemberAreaOfBusiness", response);
                    }

                    resolve();
                }, function (error) {
                    console.log("There was an error trying to retrieve the " + taxonomy + " taxonomy");

                    reject();
                }).always(function () {
                    __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
                });
            });
        },
        getNewsroomFeed: function getNewsroomFeed(_ref14, loadMore) {
            var commit = _ref14.commit,
                state = _ref14.state;

            if (loadMore) {
                commit("incrementCurrentPage");
            } else {
                commit("setCurrentPage", 1);
            }

            __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
            $.ajax({
                url: mgApi + "newsroom",
                data: {
                    page: state.current_page,
                    taxonomies: state.newsTaxFilter,
                    year: state.newsYear,
                    postType: state.postType
                }
            }).then(function (response) {
                var payload = {
                    posts: response.posts,
                    loadMore: loadMore
                };
                commit("setNewsItems", payload);
                commit("setTotalFound", response.number_of_posts);

                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].nextTick(function () {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utilities_grid_utilities__["b" /* checkGridAfterImagesLoaded */])();
                });
            }, function (error) {
                console.log("There was an error getting the newsroom feed");
            }).always(function () {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
            });
        },
        getMembers: function getMembers(_ref15) {
            var commit = _ref15.commit,
                state = _ref15.state;
            var resetPagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (resetPagination) {
                commit("setCurrentPage", 1);
            }

            var params = {
                page: state.current_page,
                per_page: state.per_page
            };

            if (!state.membersPaginated) {
                params.all = 1;
            }

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.memberFilter).map(function (key, index) {
                var filterParam = state.memberFilter[key];

                if (filterParam) {
                    params[key] = filterParam;
                }
            });

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.start();
                $.ajax({
                    url: mgApi + "member",
                    data: params
                }).then(function (response) {
                    response.posts.forEach(function (item) {
                        if (item.member_type_info) {
                            var memberTypes = [];
                            item.member_type_info.forEach(function (type) {
                                memberTypes.push(type.name);
                            });
                            item.member_type_display = memberTypes.join(",");
                        }

                        if (item.member_area_of_business_info) {
                            var areasOfBusiness = [];
                            item.member_area_of_business_info.forEach(function (type) {
                                areasOfBusiness.push(type.name);
                            });
                            item.member_area_of_business_display = areasOfBusiness.join(", ");
                        }
                    });

                    commit("setMembers", response.posts);
                    commit("setTotalFound", response.number_of_posts);

                    resolve();
                }, function (error) {
                    console.log("There was an error getting members");

                    reject();
                }).always(function () {
                    __WEBPACK_IMPORTED_MODULE_6_nprogress___default.a.done();
                });
            });
        }
    }
}));

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Get country code used by the `flag-icon-css` framework
 * http://flag-icon-css.lip.is/
 *
 * @param {*} countryCode | string
 * @return string
 */

/* harmony default export */ __webpack_exports__["a"] = (function (countryCode) {
    if (!countryCode) return;

    countryCode = countryCode.toLowerCase();

    if (countryCode == "ks") {
        countryCode = "kr";
    } else if (countryCode == "rp") {
        countryCode = "ph";
    } else if (countryCode == "ja") {
        countryCode = "jp";
    } else if (countryCode == "cs") {
        countryCode = "cr";
    } else if (countryCode == "ho") {
        countryCode = "hn";
    } else if (countryCode == "es") {
        countryCode = "sv";
    } else if (countryCode == "is") {
        countryCode = "il";
    } else if (countryCode == "tu") {
        countryCode = "tr";
    } else if (countryCode == "mo") {
        countryCode = "ma";
    } else if (countryCode == "as") {
        countryCode = "au";
    } else if (countryCode == "td") {
        countryCode = "tt";
    } else if (countryCode == "sn") {
        countryCode = "sg";
    } else if (countryCode == "pm") {
        countryCode = "pa";
    } else if (countryCode == "ch") {
        countryCode = "cn";
    } else if (countryCode == "gg") {
        countryCode = "ge";
    } else if (countryCode == "dr") {
        countryCode = "do";
    } else if (countryCode == "vm") {
        countryCode = "vn";
    } else if (countryCode == "sf") {
        countryCode = "za";
    } else if (countryCode == "ci") {
        countryCode = "cl";
    }

    return countryCode;
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Sort an array of objects by a property value
 *
 * @param {*} array | array of objects
 * @param {*} string | object property name
 */
/* harmony default export */ __webpack_exports__["a"] = (function (array, property) {
    return array.sort(function (a, b) {
        if (a[property] < b[property]) return -1;
        if (a[property] > b[property]) return 1;
        return 0;
    });
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/**
 * Sort an array of objects by a sub property (with integer value)
 *
 * @param {*} array | array of objects
 * @param {*} options | object (property, sub_property, order)
 */
/* harmony default export */ __webpack_exports__["a"] = (function (array) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!array && !options.property && !options.sub_property) return;

    // make a copy and return new array
    // keep original in tact
    var sortMe = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(array));

    return sortMe.sort(function (a, b) {
        if (a[options.property] == undefined) {
            a[options.property] = {};
            a[options.property][options.sub_property] = null;
        }
        if (b[options.property] == undefined) {
            b[options.property] = {};
            b[options.property][options.sub_property] = null;
        }

        if (options.order && options.order == "asc") {
            return a[options.property][options.sub_property] - b[options.property][options.sub_property];
        } else {
            return b[options.property][options.sub_property] - a[options.property][options.sub_property];
        }
    });
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_index__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sass_style_scss__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sass_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sass_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sass_print_scss__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sass_print_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sass_print_scss__);





/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(206), __esModule: true };

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(207), __esModule: true };

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(210), __esModule: true };

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(211), __esModule: true };

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(200);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(203);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(202);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(234);
module.exports = __webpack_require__(6).Array.from;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(236);
module.exports = __webpack_require__(6).Object.assign;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237);
module.exports = __webpack_require__(6).Object.keys;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124);
__webpack_require__(64);
__webpack_require__(125);
__webpack_require__(238);
__webpack_require__(240);
__webpack_require__(241);
module.exports = __webpack_require__(6).Promise;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
__webpack_require__(124);
__webpack_require__(242);
__webpack_require__(243);
module.exports = __webpack_require__(6).Symbol;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(125);
module.exports = __webpack_require__(63).f('iterator');


/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(22);
var toLength = __webpack_require__(60);
var toAbsoluteIndex = __webpack_require__(233);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(10);
var createDesc = __webpack_require__(30);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(39);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(27);
var call = __webpack_require__(112);
var isArrayIter = __webpack_require__(111);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(60);
var getIterFn = __webpack_require__(123);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(26);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(115);
var descriptor = __webpack_require__(30);
var setToStringTag = __webpack_require__(40);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(15)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(42)('meta');
var isObject = __webpack_require__(16);
var has = __webpack_require__(14);
var setDesc = __webpack_require__(10).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(21)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var macrotask = __webpack_require__(122).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(26)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(39);
var toObject = __webpack_require__(41);
var IObject = __webpack_require__(110);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(21)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(10);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(29);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(39);
var createDesc = __webpack_require__(30);
var toIObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(61);
var has = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(109);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(22);
var gOPN = __webpack_require__(116).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(14);
var toObject = __webpack_require__(41);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(9);
var core = __webpack_require__(6);
var fails = __webpack_require__(21);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(15);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var core = __webpack_require__(6);
var dP = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(13);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(59);
var defined = __webpack_require__(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(59);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(27);
var $export = __webpack_require__(9);
var toObject = __webpack_require__(41);
var call = __webpack_require__(112);
var isArrayIter = __webpack_require__(111);
var toLength = __webpack_require__(60);
var createProperty = __webpack_require__(215);
var getIterFn = __webpack_require__(123);

$export($export.S + $export.F * !__webpack_require__(114)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(212);
var step = __webpack_require__(221);
var Iterators = __webpack_require__(28);
var toIObject = __webpack_require__(22);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(113)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(9);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(224) });


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(41);
var $keys = __webpack_require__(29);

__webpack_require__(229)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(38);
var global = __webpack_require__(4);
var ctx = __webpack_require__(27);
var classof = __webpack_require__(107);
var $export = __webpack_require__(9);
var isObject = __webpack_require__(16);
var aFunction = __webpack_require__(37);
var anInstance = __webpack_require__(213);
var forOf = __webpack_require__(217);
var speciesConstructor = __webpack_require__(121);
var task = __webpack_require__(122).set;
var microtask = __webpack_require__(223)();
var newPromiseCapabilityModule = __webpack_require__(55);
var perform = __webpack_require__(118);
var promiseResolve = __webpack_require__(119);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(230)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(40)($Promise, PROMISE);
__webpack_require__(231)(PROMISE);
Wrapper = __webpack_require__(6)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(114)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(4);
var has = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(13);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(120);
var META = __webpack_require__(222).KEY;
var $fails = __webpack_require__(21);
var shared = __webpack_require__(58);
var setToStringTag = __webpack_require__(40);
var uid = __webpack_require__(42);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(63);
var wksDefine = __webpack_require__(62);
var enumKeys = __webpack_require__(216);
var isArray = __webpack_require__(219);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(16);
var toIObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(61);
var createDesc = __webpack_require__(30);
var _create = __webpack_require__(115);
var gOPNExt = __webpack_require__(227);
var $GOPD = __webpack_require__(226);
var $DP = __webpack_require__(10);
var $keys = __webpack_require__(29);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(116).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(39).f = $propertyIsEnumerable;
  __webpack_require__(56).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(38)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(15)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(9);
var core = __webpack_require__(6);
var global = __webpack_require__(4);
var speciesConstructor = __webpack_require__(121);
var promiseResolve = __webpack_require__(119);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(55);
var perform = __webpack_require__(118);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62)('asyncIterator');


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62)('observable');


/***/ }),
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(126)();
// imports


// module
exports.push([module.i, "canvas[data-v-274332af]{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}", ""]);

// exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(126)();
// imports


// module
exports.push([module.i, "canvas[data-v-4b13e41c]{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}", ""]);

// exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(19)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__(142)
var parse = __webpack_require__(0)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(47)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(45)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var differenceInCalendarISOYears = __webpack_require__(133)
var compareAsc = __webpack_require__(33)
var subISOYears = __webpack_require__(161)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(45)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(67)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__(136)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var differenceInCalendarYears = __webpack_require__(135)
var compareAsc = __webpack_require__(33)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(66)
var parse = __webpack_require__(0)
var differenceInSeconds = __webpack_require__(68)
var enLocale = __webpack_require__(74)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__(137)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__(139)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(17)
var startOfISOWeek = __webpack_require__(19)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__(69)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),
/* 269 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),
/* 271 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(140)
var getISOWeek = __webpack_require__(71)
var getISOYear = __webpack_require__(17)
var parse = __webpack_require__(0)
var isValid = __webpack_require__(152)
var enLocale = __webpack_require__(74)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__(143)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(34)
var addWeeks = __webpack_require__(65)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var endOfDay = __webpack_require__(69)
var endOfMonth = __webpack_require__(138)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(18)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__(144)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(145)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(146)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__(147)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(148)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(149)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__(150)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(73)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(151)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(18)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(18)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(18)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(153)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(17)
var startOfISOWeek = __webpack_require__(19)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),
/* 319 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 320 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(319)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var addDays = __webpack_require__(31)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var addDays = __webpack_require__(31)
var getISODay = __webpack_require__(141)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var getISOWeek = __webpack_require__(71)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)
var setMonth = __webpack_require__(155)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(0)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(18)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(31)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__(127)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(32)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__(129)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(43)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__(130)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__(131)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(65)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(132)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Lazy */
/* unused harmony export LazyComponent */
/* unused harmony export LazyContainer */
/* unused harmony export LazyImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return index; });
/*!
 * Vue-Lazyload.js v1.3.5
 * (c) 2023 Awe <hilongjw@gmail.com>
 * Released under the MIT License.
 */

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assignSymbols$1 = createCommonjsModule(function (module) {

  var toString = Object.prototype.toString;
  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var getSymbols = Object.getOwnPropertySymbols;

  module.exports = function (target) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!isObject(target)) {
      throw new TypeError('expected the first argument to be an object');
    }

    if (args.length === 0 || typeof Symbol !== 'function' || typeof getSymbols !== 'function') {
      return target;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var arg = _step.value;

        var names = getSymbols(arg);

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = names[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            if (isEnumerable.call(arg, key)) {
              target[key] = arg[key];
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return target;
  };

  function isObject(val) {
    return typeof val === 'function' || toString.call(val) === '[object Object]' || Array.isArray(val);
  }
});

var assignSymbols$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': assignSymbols$1,
	__moduleExports: assignSymbols$1
});

var assignSymbols = ( assignSymbols$2 && assignSymbols$1 ) || assignSymbols$2;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var assignDeep = createCommonjsModule(function (module) {

  var toString = Object.prototype.toString;

  var isValidKey = function isValidKey(key) {
    return key !== '__proto__' && key !== 'constructor' && key !== 'prototype';
  };

  var assign = module.exports = function (target) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var i = 0;
    if (isPrimitive(target)) target = args[i++];
    if (!target) target = {};
    for (; i < args.length; i++) {
      if (isObject(args[i])) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.keys(args[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (isValidKey(key)) {
              if (isObject(target[key]) && isObject(args[i][key])) {
                assign(target[key], args[i][key]);
              } else {
                target[key] = args[i][key];
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        assignSymbols(target, args[i]);
      }
    }
    return target;
  };

  function isObject(val) {
    return typeof val === 'function' || toString.call(val) === '[object Object]';
  }

  function isPrimitive(val) {
    return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' ? val === null : typeof val !== 'function';
  }
});

var inBrowser = typeof window !== 'undefined' && window !== null;

var hasIntersectionObserver = checkIntersectionObserver();

function checkIntersectionObserver() {
  if (inBrowser && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return true;
  }
  return false;
}

var modeType = {
  event: 'event',
  observer: 'observer'

  // CustomEvent polyfill for IE
};var CustomEvent = function () {
  if (!inBrowser) return;
  // not IE
  if (typeof window.CustomEvent === 'function') return window.CustomEvent;
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  CustomEvent.prototype = window.Event.prototype;
  return CustomEvent;
}();

function remove(arr, item) {
  if (!arr.length) return;
  var index = arr.indexOf(item);
  if (index > -1) return arr.splice(index, 1);
}

function some(arr, fn) {
  var has = false;
  for (var i = 0, len = arr.length; i < len; i++) {
    if (fn(arr[i])) {
      has = true;
      break;
    }
  }
  return has;
}

function getBestSelectionFromSrcset(el, scale) {
  if (el.tagName !== 'IMG' || !el.getAttribute('data-srcset')) return;

  var options = el.getAttribute('data-srcset');
  var result = [];
  var container = el.parentNode;
  var containerWidth = container.offsetWidth * scale;

  var spaceIndex = void 0;
  var tmpSrc = void 0;
  var tmpWidth = void 0;

  options = options.trim().split(',');

  options.map(function (item) {
    item = item.trim();
    spaceIndex = item.lastIndexOf(' ');
    if (spaceIndex === -1) {
      tmpSrc = item;
      tmpWidth = 999998;
    } else {
      tmpSrc = item.substr(0, spaceIndex);
      tmpWidth = parseInt(item.substr(spaceIndex + 1, item.length - spaceIndex - 2), 10);
    }
    result.push([tmpWidth, tmpSrc]);
  });

  result.sort(function (a, b) {
    if (a[0] < b[0]) {
      return 1;
    }
    if (a[0] > b[0]) {
      return -1;
    }
    if (a[0] === b[0]) {
      if (b[1].indexOf('.webp', b[1].length - 5) !== -1) {
        return 1;
      }
      if (a[1].indexOf('.webp', a[1].length - 5) !== -1) {
        return -1;
      }
    }
    return 0;
  });
  var bestSelectedSrc = '';
  var tmpOption = void 0;

  for (var i = 0; i < result.length; i++) {
    tmpOption = result[i];
    bestSelectedSrc = tmpOption[1];
    var next = result[i + 1];
    if (next && next[0] < containerWidth) {
      bestSelectedSrc = tmpOption[1];
      break;
    } else if (!next) {
      bestSelectedSrc = tmpOption[1];
      break;
    }
  }

  return bestSelectedSrc;
}

function find(arr, fn) {
  var item = void 0;
  for (var i = 0, len = arr.length; i < len; i++) {
    if (fn(arr[i])) {
      item = arr[i];
      break;
    }
  }
  return item;
}

var getDPR = function getDPR() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return inBrowser ? window.devicePixelRatio || scale : scale;
};

function supportWebp() {
  if (!inBrowser) return false;

  var support = true;

  try {
    var elem = document.createElement('canvas');

    if (elem.getContext && elem.getContext('2d')) {
      support = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
  } catch (err) {
    support = false;
  }

  return support;
}

function throttle(action, delay) {
  var timeout = null;
  var movement = null;
  var lastRun = 0;
  var needRun = false;
  return function () {
    needRun = true;
    if (timeout) {
      return;
    }
    var elapsed = Date.now() - lastRun;
    var context = this;
    var args = arguments;
    var runCallback = function runCallback() {
      lastRun = Date.now();
      timeout = false;
      action.apply(context, args);
    };
    if (elapsed >= delay) {
      runCallback();
    } else {
      timeout = setTimeout(runCallback, delay);
    }
    if (needRun) {
      clearTimeout(movement);
      movement = setTimeout(runCallback, 2 * delay);
    }
  };
}

function testSupportsPassive() {
  if (!inBrowser) return;
  var support = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        support = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
  return support;
}

var supportsPassive = testSupportsPassive();

var _ = {
  on: function on(el, type, func) {
    var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (supportsPassive) {
      el.addEventListener(type, func, {
        capture: capture,
        passive: true
      });
    } else {
      el.addEventListener(type, func, capture);
    }
  },
  off: function off(el, type, func) {
    var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    el.removeEventListener(type, func, capture);
  }
};

var loadImageAsync = function loadImageAsync(item, resolve, reject) {
  var image = new Image();
  if (!item || !item.src) {
    var err = new Error('image src is required');
    return reject(err);
  }

  image.src = item.src;
  if (item.cors) {
    image.crossOrigin = item.cors;
  }

  image.onload = function () {
    resolve({
      naturalHeight: image.naturalHeight,
      naturalWidth: image.naturalWidth,
      src: image.src
    });
  };

  image.onerror = function (e) {
    reject(e);
  };
};

var style = function style(el, prop) {
  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(el, null).getPropertyValue(prop) : el.style[prop];
};

var overflow = function overflow(el) {
  return style(el, 'overflow') + style(el, 'overflow-y') + style(el, 'overflow-x');
};

var scrollParent = function scrollParent(el) {
  if (!inBrowser) return;
  if (!(el instanceof HTMLElement)) {
    return window;
  }

  var parent = el;

  while (parent) {
    if (parent === document.body || parent === document.documentElement) {
      break;
    }

    if (!parent.parentNode) {
      break;
    }

    if (/(scroll|auto)/.test(overflow(parent))) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return window;
};

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function ObjectKeys(obj) {
  if (!(obj instanceof Object)) return [];
  if (Object.keys) {
    return Object.keys(obj);
  } else {
    var keys = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        keys.push(key);
      }
    }
    return keys;
  }
}

function ArrayFrom(arrLike) {
  var len = arrLike.length;
  var list = [];
  for (var i = 0; i < len; i++) {
    list.push(arrLike[i]);
  }
  return list;
}

function noop() {}

var ImageCache = function () {
  function ImageCache(_ref) {
    var max = _ref.max;
    classCallCheck(this, ImageCache);

    this.options = {
      max: max || 100
    };
    this._caches = [];
  }

  createClass(ImageCache, [{
    key: 'has',
    value: function has(key) {
      return this._caches.indexOf(key) > -1;
    }
  }, {
    key: 'add',
    value: function add(key) {
      if (this.has(key)) return;
      this._caches.push(key);
      if (this._caches.length > this.options.max) {
        this.free();
      }
    }
  }, {
    key: 'free',
    value: function free() {
      this._caches.shift();
    }
  }]);
  return ImageCache;
}();

// el: {
//     state,
//     src,
//     error,
//     loading
// }

var ReactiveListener = function () {
  function ReactiveListener(_ref) {
    var el = _ref.el,
        src = _ref.src,
        error = _ref.error,
        loading = _ref.loading,
        bindType = _ref.bindType,
        $parent = _ref.$parent,
        options = _ref.options,
        cors = _ref.cors,
        elRenderer = _ref.elRenderer,
        imageCache = _ref.imageCache;
    classCallCheck(this, ReactiveListener);

    this.el = el;
    this.src = src;
    this.error = error;
    this.loading = loading;
    this.bindType = bindType;
    this.attempt = 0;
    this.cors = cors;

    this.naturalHeight = 0;
    this.naturalWidth = 0;

    this.options = options;

    this.rect = null;

    this.$parent = $parent;
    this.elRenderer = elRenderer;
    this._imageCache = imageCache;
    this.performanceData = {
      init: Date.now(),
      loadStart: 0,
      loadEnd: 0
    };

    this.filter();
    this.initState();
    this.render('loading', false);
  }

  /*
   * init listener state
   * @return
   */


  createClass(ReactiveListener, [{
    key: 'initState',
    value: function initState() {
      if ('dataset' in this.el) {
        this.el.dataset.src = this.src;
      } else {
        this.el.setAttribute('data-src', this.src);
      }

      this.state = {
        loading: false,
        error: false,
        loaded: false,
        rendered: false
      };
    }

    /*
     * record performance
     * @return
     */

  }, {
    key: 'record',
    value: function record(event) {
      this.performanceData[event] = Date.now();
    }

    /*
     * update image listener data
     * @param  {String} image uri
     * @param  {String} loading image uri
     * @param  {String} error image uri
     * @return
     */

  }, {
    key: 'update',
    value: function update(_ref2) {
      var src = _ref2.src,
          loading = _ref2.loading,
          error = _ref2.error;

      var oldSrc = this.src;
      this.src = src;
      this.loading = loading;
      this.error = error;
      this.filter();
      if (oldSrc !== this.src) {
        this.attempt = 0;
        this.initState();
      }
    }

    /*
     * get el node rect
     * @return
     */

  }, {
    key: 'getRect',
    value: function getRect() {
      this.rect = this.el.getBoundingClientRect();
    }

    /*
     *  check el is in view
     * @return {Boolean} el is in view
     */

  }, {
    key: 'checkInView',
    value: function checkInView() {
      this.getRect();
      return this.rect.top < window.innerHeight * this.options.preLoad && this.rect.bottom > this.options.preLoadTop && this.rect.left < window.innerWidth * this.options.preLoad && this.rect.right > 0;
    }

    /*
     * listener filter
     */

  }, {
    key: 'filter',
    value: function filter() {
      var _this = this;

      ObjectKeys(this.options.filter).map(function (key) {
        _this.options.filter[key](_this, _this.options);
      });
    }

    /*
     * render loading first
     * @params cb:Function
     * @return
     */

  }, {
    key: 'renderLoading',
    value: function renderLoading(cb) {
      var _this2 = this;

      this.state.loading = true;
      loadImageAsync({
        src: this.loading,
        cors: this.cors
      }, function (data) {
        _this2.render('loading', false);
        _this2.state.loading = false;
        cb();
      }, function () {
        // handler `loading image` load failed
        cb();
        _this2.state.loading = false;
        if (!_this2.options.silent) console.warn('VueLazyload log: load failed with loading image(' + _this2.loading + ')');
      });
    }

    /*
     * try load image and  render it
     * @return
     */

  }, {
    key: 'load',
    value: function load() {
      var _this3 = this;

      var onFinish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

      if (this.attempt > this.options.attempt - 1 && this.state.error) {
        if (!this.options.silent) console.log('VueLazyload log: ' + this.src + ' tried too more than ' + this.options.attempt + ' times');
        onFinish();
        return;
      }
      if (this.state.rendered && this.state.loaded) return;
      if (this._imageCache.has(this.src)) {
        this.state.loaded = true;
        this.render('loaded', true);
        this.state.rendered = true;
        return onFinish();
      }

      this.renderLoading(function () {
        _this3.attempt++;

        _this3.options.adapter['beforeLoad'] && _this3.options.adapter['beforeLoad'](_this3, _this3.options);
        _this3.record('loadStart');

        loadImageAsync({
          src: _this3.src,
          cors: _this3.cors
        }, function (data) {
          _this3.naturalHeight = data.naturalHeight;
          _this3.naturalWidth = data.naturalWidth;
          _this3.state.loaded = true;
          _this3.state.error = false;
          _this3.record('loadEnd');
          _this3.render('loaded', false);
          _this3.state.rendered = true;
          _this3._imageCache.add(_this3.src);
          onFinish();
        }, function (err) {
          !_this3.options.silent && console.error(err);
          _this3.state.error = true;
          _this3.state.loaded = false;
          _this3.render('error', false);
        });
      });
    }

    /*
     * render image
     * @param  {String} state to render // ['loading', 'src', 'error']
     * @param  {String} is form cache
     * @return
     */

  }, {
    key: 'render',
    value: function render(state, cache) {
      this.elRenderer(this, state, cache);
    }

    /*
     * output performance data
     * @return {Object} performance data
     */

  }, {
    key: 'performance',
    value: function performance() {
      var state = 'loading';
      var time = 0;

      if (this.state.loaded) {
        state = 'loaded';
        time = (this.performanceData.loadEnd - this.performanceData.loadStart) / 1000;
      }

      if (this.state.error) state = 'error';

      return {
        src: this.src,
        state: state,
        time: time
      };
    }

    /*
     * $destroy
     * @return
     */

  }, {
    key: '$destroy',
    value: function $destroy() {
      this.el = null;
      this.src = null;
      this.error = null;
      this.loading = null;
      this.bindType = null;
      this.attempt = 0;
    }
  }]);
  return ReactiveListener;
}();

var DEFAULT_URL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var DEFAULT_EVENTS = ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'];
var DEFAULT_OBSERVER_OPTIONS = {
  rootMargin: '0px',
  threshold: 0
};

function Lazy(Vue) {
  return function () {
    function Lazy(_ref) {
      var preLoad = _ref.preLoad,
          error = _ref.error,
          throttleWait = _ref.throttleWait,
          preLoadTop = _ref.preLoadTop,
          dispatchEvent = _ref.dispatchEvent,
          loading = _ref.loading,
          attempt = _ref.attempt,
          _ref$silent = _ref.silent,
          silent = _ref$silent === undefined ? true : _ref$silent,
          scale = _ref.scale,
          listenEvents = _ref.listenEvents;
          _ref.hasbind;
          var filter = _ref.filter,
          adapter = _ref.adapter,
          observer = _ref.observer,
          observerOptions = _ref.observerOptions;
      classCallCheck(this, Lazy);

      this.version = '"1.3.5"';
      this.mode = modeType.event;
      this.ListenerQueue = [];
      this.TargetIndex = 0;
      this.TargetQueue = [];
      this.options = {
        silent: silent,
        dispatchEvent: !!dispatchEvent,
        throttleWait: throttleWait || 200,
        preLoad: preLoad || 1.3,
        preLoadTop: preLoadTop || 0,
        error: error || DEFAULT_URL,
        loading: loading || DEFAULT_URL,
        attempt: attempt || 3,
        scale: scale || getDPR(scale),
        ListenEvents: listenEvents || DEFAULT_EVENTS,
        hasbind: false,
        supportWebp: supportWebp(),
        filter: filter || {},
        adapter: adapter || {},
        observer: !!observer,
        observerOptions: observerOptions || DEFAULT_OBSERVER_OPTIONS
      };
      this._initEvent();
      this._imageCache = new ImageCache({ max: 200 });
      this.lazyLoadHandler = throttle(this._lazyLoadHandler.bind(this), this.options.throttleWait);

      this.setMode(this.options.observer ? modeType.observer : modeType.event);
    }

    /**
     * update config
     * @param  {Object} config params
     * @return
     */


    createClass(Lazy, [{
      key: 'config',
      value: function config() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        assignDeep(this.options, options);
      }

      /**
       * output listener's load performance
       * @return {Array}
       */

    }, {
      key: 'performance',
      value: function performance() {
        var list = [];

        this.ListenerQueue.map(function (item) {
          list.push(item.performance());
        });

        return list;
      }

      /*
       * add lazy component to queue
       * @param  {Vue} vm lazy component instance
       * @return
       */

    }, {
      key: 'addLazyBox',
      value: function addLazyBox(vm) {
        this.ListenerQueue.push(vm);
        if (inBrowser) {
          this._addListenerTarget(window);
          this._observer && this._observer.observe(vm.el);
          if (vm.$el && vm.$el.parentNode) {
            this._addListenerTarget(vm.$el.parentNode);
          }
        }
      }

      /*
       * add image listener to queue
       * @param  {DOM} el
       * @param  {object} binding vue directive binding
       * @param  {vnode} vnode vue directive vnode
       * @return
       */

    }, {
      key: 'add',
      value: function add(el, binding, vnode) {
        var _this = this;

        if (some(this.ListenerQueue, function (item) {
          return item.el === el;
        })) {
          this.update(el, binding);
          return Vue.nextTick(this.lazyLoadHandler);
        }

        var _valueFormatter2 = this._valueFormatter(binding.value),
            src = _valueFormatter2.src,
            loading = _valueFormatter2.loading,
            error = _valueFormatter2.error,
            cors = _valueFormatter2.cors;

        Vue.nextTick(function () {
          src = getBestSelectionFromSrcset(el, _this.options.scale) || src;
          _this._observer && _this._observer.observe(el);

          var container = Object.keys(binding.modifiers)[0];
          var $parent = void 0;

          if (container) {
            $parent = vnode.context.$refs[container];
            // if there is container passed in, try ref first, then fallback to getElementById to support the original usage
            $parent = $parent ? $parent.$el || $parent : document.getElementById(container);
          }

          if (!$parent) {
            $parent = scrollParent(el);
          }

          var newListener = new ReactiveListener({
            bindType: binding.arg,
            $parent: $parent,
            el: el,
            loading: loading,
            error: error,
            src: src,
            cors: cors,
            elRenderer: _this._elRenderer.bind(_this),
            options: _this.options,
            imageCache: _this._imageCache
          });

          _this.ListenerQueue.push(newListener);

          if (inBrowser) {
            _this._addListenerTarget(window);
            _this._addListenerTarget($parent);
          }

          _this.lazyLoadHandler();
          Vue.nextTick(function () {
            return _this.lazyLoadHandler();
          });
        });
      }

      /**
      * update image src
      * @param  {DOM} el
      * @param  {object} vue directive binding
      * @return
      */

    }, {
      key: 'update',
      value: function update(el, binding, vnode) {
        var _this2 = this;

        var _valueFormatter3 = this._valueFormatter(binding.value),
            src = _valueFormatter3.src,
            loading = _valueFormatter3.loading,
            error = _valueFormatter3.error;

        src = getBestSelectionFromSrcset(el, this.options.scale) || src;

        var exist = find(this.ListenerQueue, function (item) {
          return item.el === el;
        });
        if (!exist) {
          this.add(el, binding, vnode);
        } else {
          exist.update({
            src: src,
            loading: loading,
            error: error
          });
        }
        if (this._observer) {
          this._observer.unobserve(el);
          this._observer.observe(el);
        }
        this.lazyLoadHandler();
        Vue.nextTick(function () {
          return _this2.lazyLoadHandler();
        });
      }

      /**
      * remove listener form list
      * @param  {DOM} el
      * @return
      */

    }, {
      key: 'remove',
      value: function remove$1(el) {
        if (!el) return;
        this._observer && this._observer.unobserve(el);
        var existItem = find(this.ListenerQueue, function (item) {
          return item.el === el;
        });
        if (existItem) {
          this._removeListenerTarget(existItem.$parent);
          this._removeListenerTarget(window);
          remove(this.ListenerQueue, existItem);
          existItem.$destroy();
        }
      }

      /*
       * remove lazy components form list
       * @param  {Vue} vm Vue instance
       * @return
       */

    }, {
      key: 'removeComponent',
      value: function removeComponent(vm) {
        if (!vm) return;
        remove(this.ListenerQueue, vm);
        this._observer && this._observer.unobserve(vm.el);
        if (vm.$parent && vm.$el.parentNode) {
          this._removeListenerTarget(vm.$el.parentNode);
        }
        this._removeListenerTarget(window);
      }
    }, {
      key: 'setMode',
      value: function setMode(mode) {
        var _this3 = this;

        if (!hasIntersectionObserver && mode === modeType.observer) {
          mode = modeType.event;
        }

        this.mode = mode; // event or observer

        if (mode === modeType.event) {
          if (this._observer) {
            this.ListenerQueue.forEach(function (listener) {
              _this3._observer.unobserve(listener.el);
            });
            this._observer = null;
          }

          this.TargetQueue.forEach(function (target) {
            _this3._initListen(target.el, true);
          });
        } else {
          this.TargetQueue.forEach(function (target) {
            _this3._initListen(target.el, false);
          });
          this._initIntersectionObserver();
        }
      }

      /*
      *** Private functions ***
      */

      /*
       * add listener target
       * @param  {DOM} el listener target
       * @return
       */

    }, {
      key: '_addListenerTarget',
      value: function _addListenerTarget(el) {
        if (!el) return;
        var target = find(this.TargetQueue, function (target) {
          return target.el === el;
        });
        if (!target) {
          target = {
            el: el,
            id: ++this.TargetIndex,
            childrenCount: 1,
            listened: true
          };
          this.mode === modeType.event && this._initListen(target.el, true);
          this.TargetQueue.push(target);
        } else {
          target.childrenCount++;
        }
        return this.TargetIndex;
      }

      /*
       * remove listener target or reduce target childrenCount
       * @param  {DOM} el or window
       * @return
       */

    }, {
      key: '_removeListenerTarget',
      value: function _removeListenerTarget(el) {
        var _this4 = this;

        this.TargetQueue.forEach(function (target, index) {
          if (target.el === el) {
            target.childrenCount--;
            if (!target.childrenCount) {
              _this4._initListen(target.el, false);
              _this4.TargetQueue.splice(index, 1);
              target = null;
            }
          }
        });
      }

      /*
       * add or remove eventlistener
       * @param  {DOM} el DOM or Window
       * @param  {boolean} start flag
       * @return
       */

    }, {
      key: '_initListen',
      value: function _initListen(el, start) {
        var _this5 = this;

        this.options.ListenEvents.forEach(function (evt) {
          return _[start ? 'on' : 'off'](el, evt, _this5.lazyLoadHandler);
        });
      }
    }, {
      key: '_initEvent',
      value: function _initEvent() {
        var _this6 = this;

        this.Event = {
          listeners: {
            loading: [],
            loaded: [],
            error: []
          }
        };

        this.$on = function (event, func) {
          if (!_this6.Event.listeners[event]) _this6.Event.listeners[event] = [];
          _this6.Event.listeners[event].push(func);
        };

        this.$once = function (event, func) {
          var vm = _this6;
          function on() {
            vm.$off(event, on);
            func.apply(vm, arguments);
          }
          _this6.$on(event, on);
        };

        this.$off = function (event, func) {
          if (!func) {
            if (!_this6.Event.listeners[event]) return;
            _this6.Event.listeners[event].length = 0;
            return;
          }
          remove(_this6.Event.listeners[event], func);
        };

        this.$emit = function (event, context, inCache) {
          if (!_this6.Event.listeners[event]) return;
          _this6.Event.listeners[event].forEach(function (func) {
            return func(context, inCache);
          });
        };
      }

      /**
       * find nodes which in viewport and trigger load
       * @return
       */

    }, {
      key: '_lazyLoadHandler',
      value: function _lazyLoadHandler() {
        var _this7 = this;

        var freeList = [];
        this.ListenerQueue.forEach(function (listener, index) {
          if (!listener.el || !listener.el.parentNode) {
            freeList.push(listener);
          }
          var catIn = listener.checkInView();
          if (!catIn) return;
          listener.load();
        });
        freeList.forEach(function (item) {
          remove(_this7.ListenerQueue, item);
          item.$destroy();
        });
      }
      /**
      * init IntersectionObserver
      * set mode to observer
      * @return
      */

    }, {
      key: '_initIntersectionObserver',
      value: function _initIntersectionObserver() {
        var _this8 = this;

        if (!hasIntersectionObserver) return;
        this._observer = new IntersectionObserver(this._observerHandler.bind(this), this.options.observerOptions);
        if (this.ListenerQueue.length) {
          this.ListenerQueue.forEach(function (listener) {
            _this8._observer.observe(listener.el);
          });
        }
      }

      /**
      * init IntersectionObserver
      * @return
      */

    }, {
      key: '_observerHandler',
      value: function _observerHandler(entries, observer) {
        var _this9 = this;

        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this9.ListenerQueue.forEach(function (listener) {
              if (listener.el === entry.target) {
                if (listener.state.loaded) return _this9._observer.unobserve(listener.el);
                listener.load();
              }
            });
          }
        });
      }

      /**
      * set element attribute with image'url and state
      * @param  {object} lazyload listener object
      * @param  {string} state will be rendered
      * @param  {bool} inCache  is rendered from cache
      * @return
      */

    }, {
      key: '_elRenderer',
      value: function _elRenderer(listener, state, cache) {
        if (!listener.el) return;
        var el = listener.el,
            bindType = listener.bindType;


        var src = void 0;
        switch (state) {
          case 'loading':
            src = listener.loading;
            break;
          case 'error':
            src = listener.error;
            break;
          default:
            src = listener.src;
            break;
        }

        if (bindType) {
          el.style[bindType] = 'url("' + src + '")';
        } else if (el.getAttribute('src') !== src) {
          el.setAttribute('src', src);
        }

        el.setAttribute('lazy', state);

        this.$emit(state, listener, cache);
        this.options.adapter[state] && this.options.adapter[state](listener, this.options);

        if (this.options.dispatchEvent) {
          var event = new CustomEvent(state, {
            detail: listener
          });
          el.dispatchEvent(event);
        }
      }

      /**
      * generate loading loaded error image url
      * @param {string} image's src
      * @return {object} image's loading, loaded, error url
      */

    }, {
      key: '_valueFormatter',
      value: function _valueFormatter(value) {
        var src = value;
        var loading = this.options.loading;
        var error = this.options.error;

        // value is object
        if (isObject(value)) {
          if (!value.src && !this.options.silent) console.error('Vue Lazyload warning: miss src with ' + value);
          src = value.src;
          loading = value.loading || this.options.loading;
          error = value.error || this.options.error;
        }
        return {
          src: src,
          loading: loading,
          error: error
        };
      }
    }]);
    return Lazy;
  }();
}

Lazy.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var LazyClass = Lazy(Vue);
  var lazy = new LazyClass(options);

  var isVue2 = Vue.version.split('.')[0] === '2';
  if (isVue2) {
    Vue.directive('lazy', {
      bind: lazy.add.bind(lazy),
      update: lazy.update.bind(lazy),
      componentUpdated: lazy.lazyLoadHandler.bind(lazy),
      unbind: lazy.remove.bind(lazy)
    });
  } else {
    Vue.directive('lazy', {
      bind: lazy.lazyLoadHandler.bind(lazy),
      update: function update(newValue, oldValue) {
        assignDeep(this.vm.$refs, this.vm.$els);
        lazy.add(this.el, {
          modifiers: this.modifiers || {},
          arg: this.arg,
          value: newValue,
          oldValue: oldValue
        }, {
          context: this.vm
        });
      },
      unbind: function unbind() {
        lazy.remove(this.el);
      }
    });
  }
};

var LazyComponent = function LazyComponent(lazy) {
  return {
    props: {
      tag: {
        type: String,
        default: 'div'
      }
    },
    render: function render(h) {
      return h(this.tag, null, this.show ? this.$slots.default : null);
    },
    data: function data() {
      return {
        el: null,
        state: {
          loaded: false
        },
        rect: {},
        show: false
      };
    },
    mounted: function mounted() {
      this.el = this.$el;
      lazy.addLazyBox(this);
      lazy.lazyLoadHandler();
    },
    beforeDestroy: function beforeDestroy() {
      lazy.removeComponent(this);
    },

    methods: {
      getRect: function getRect() {
        this.rect = this.$el.getBoundingClientRect();
      },
      checkInView: function checkInView() {
        this.getRect();
        return inBrowser && this.rect.top < window.innerHeight * lazy.options.preLoad && this.rect.bottom > 0 && this.rect.left < window.innerWidth * lazy.options.preLoad && this.rect.right > 0;
      },
      load: function load() {
        this.show = true;
        this.state.loaded = true;
        this.$emit('show', this);
      },
      destroy: function destroy() {
        return this.$destroy;
      }
    }
  };
};

LazyComponent.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var LazyClass = Lazy(Vue);
  var lazy = new LazyClass(options);
  Vue.component('lazy-component', LazyComponent(lazy));
};

var LazyContainerMananger = function () {
  function LazyContainerMananger(_ref) {
    var lazy = _ref.lazy;
    classCallCheck(this, LazyContainerMananger);

    this.lazy = lazy;
    lazy.lazyContainerMananger = this;
    this._queue = [];
  }

  createClass(LazyContainerMananger, [{
    key: 'bind',
    value: function bind(el, binding, vnode) {
      var container = new LazyContainer({ el: el, binding: binding, vnode: vnode, lazy: this.lazy });
      this._queue.push(container);
    }
  }, {
    key: 'update',
    value: function update(el, binding, vnode) {
      var container = find(this._queue, function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.update({ el: el, binding: binding, vnode: vnode });
    }
  }, {
    key: 'unbind',
    value: function unbind(el, binding, vnode) {
      var container = find(this._queue, function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.clear();
      remove(this._queue, container);
    }
  }]);
  return LazyContainerMananger;
}();


var defaultOptions = {
  selector: 'img'
};

var LazyContainer = function () {
  function LazyContainer(_ref2) {
    var el = _ref2.el,
        binding = _ref2.binding,
        vnode = _ref2.vnode,
        lazy = _ref2.lazy;
    classCallCheck(this, LazyContainer);

    this.el = null;
    this.vnode = vnode;
    this.binding = binding;
    this.options = {};
    this.lazy = lazy;

    this._queue = [];
    this.update({ el: el, binding: binding });
  }

  createClass(LazyContainer, [{
    key: 'update',
    value: function update(_ref3) {
      var _this = this;

      var el = _ref3.el,
          binding = _ref3.binding;

      this.el = el;
      this.options = assignDeep({}, defaultOptions, binding.value);

      var imgs = this.getImgs();
      imgs.forEach(function (el) {
        _this.lazy.add(el, assignDeep({}, _this.binding, {
          value: {
            src: 'dataset' in el ? el.dataset.src : el.getAttribute('data-src'),
            error: ('dataset' in el ? el.dataset.error : el.getAttribute('data-error')) || _this.options.error,
            loading: ('dataset' in el ? el.dataset.loading : el.getAttribute('data-loading')) || _this.options.loading
          }
        }), _this.vnode);
      });
    }
  }, {
    key: 'getImgs',
    value: function getImgs() {
      return ArrayFrom(this.el.querySelectorAll(this.options.selector));
    }
  }, {
    key: 'clear',
    value: function clear() {
      var _this2 = this;

      var imgs = this.getImgs();
      imgs.forEach(function (el) {
        return _this2.lazy.remove(el);
      });

      this.vnode = null;
      this.binding = null;
      this.lazy = null;
    }
  }]);
  return LazyContainer;
}();

LazyContainer.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var LazyClass = Lazy(Vue);
  var lazy = new LazyClass(options);
  var lazyContainer = new LazyContainer({ lazy: lazy });

  var isVue2 = Vue.version.split('.')[0] === '2';
  if (isVue2) {
    Vue.directive('lazy-container', {
      bind: lazyContainer.bind.bind(lazyContainer),
      componentUpdated: lazyContainer.update.bind(lazyContainer),
      unbind: lazyContainer.unbind.bind(lazyContainer)
    });
  } else {
    Vue.directive('lazy-container', {
      update: function update(newValue, oldValue) {
        lazyContainer.update(this.el, {
          modifiers: this.modifiers || {},
          arg: this.arg,
          value: newValue,
          oldValue: oldValue
        }, {
          context: this.vm
        });
      },
      unbind: function unbind() {
        lazyContainer.unbind(this.el);
      }
    });
  }
};

var LazyImage = function LazyImage(lazyManager) {
  return {
    props: {
      src: [String, Object],
      tag: {
        type: String,
        default: 'img'
      }
    },
    render: function render(h) {
      return h(this.tag, {
        attrs: {
          src: this.renderSrc
        }
      }, this.$slots.default);
    },
    data: function data() {
      return {
        el: null,
        options: {
          src: '',
          error: '',
          loading: '',
          attempt: lazyManager.options.attempt
        },
        state: {
          loaded: false,
          error: false,
          attempt: 0
        },
        rect: {},
        renderSrc: ''
      };
    },

    watch: {
      src: function src() {
        this.init();
        lazyManager.addLazyBox(this);
        lazyManager.lazyLoadHandler();
      }
    },
    created: function created() {
      this.init();
      this.renderSrc = this.options.loading;
    },
    mounted: function mounted() {
      this.el = this.$el;
      lazyManager.addLazyBox(this);
      lazyManager.lazyLoadHandler();
    },
    beforeDestroy: function beforeDestroy() {
      lazyManager.removeComponent(this);
    },

    methods: {
      init: function init() {
        var _lazyManager$_valueFo = lazyManager._valueFormatter(this.src),
            src = _lazyManager$_valueFo.src,
            loading = _lazyManager$_valueFo.loading,
            error = _lazyManager$_valueFo.error;

        this.state.loaded = false;
        this.options.src = src;
        this.options.error = error;
        this.options.loading = loading;
        this.renderSrc = this.options.loading;
      },
      getRect: function getRect() {
        this.rect = this.$el.getBoundingClientRect();
      },
      checkInView: function checkInView() {
        this.getRect();
        return inBrowser && this.rect.top < window.innerHeight * lazyManager.options.preLoad && this.rect.bottom > 0 && this.rect.left < window.innerWidth * lazyManager.options.preLoad && this.rect.right > 0;
      },
      load: function load() {
        var _this = this;

        var onFinish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

        if (this.state.attempt > this.options.attempt - 1 && this.state.error) {
          if (!lazyManager.options.silent) console.log('VueLazyload log: ' + this.options.src + ' tried too more than ' + this.options.attempt + ' times');
          onFinish();
          return;
        }
        var src = this.options.src;
        loadImageAsync({ src: src }, function (_ref) {
          var src = _ref.src;

          _this.renderSrc = src;
          _this.state.loaded = true;
        }, function (e) {
          _this.state.attempt++;
          _this.renderSrc = _this.options.error;
          _this.state.error = true;
        });
      }
    }
  };
};

LazyImage.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var LazyClass = Lazy(Vue);
  var lazy = new LazyClass(options);
  Vue.component('lazy-image', LazyImage(lazy));
};

var index = {
  /*
  * install function
  * @param  {Vue} Vue
  * @param  {object} options  lazyload options
  */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var LazyClass = Lazy(Vue);
    var lazy = new LazyClass(options);
    var lazyContainer = new LazyContainerMananger({ lazy: lazy });

    var isVue2 = Vue.version.split('.')[0] === '2';

    Vue.prototype.$Lazyload = lazy;

    if (options.lazyComponent) {
      Vue.component('lazy-component', LazyComponent(lazy));
    }

    if (options.lazyImage) {
      Vue.component('lazy-image', LazyImage(lazy));
    }

    if (isVue2) {
      Vue.directive('lazy', {
        bind: lazy.add.bind(lazy),
        update: lazy.update.bind(lazy),
        componentUpdated: lazy.lazyLoadHandler.bind(lazy),
        unbind: lazy.remove.bind(lazy)
      });
      Vue.directive('lazy-container', {
        bind: lazyContainer.bind.bind(lazyContainer),
        componentUpdated: lazyContainer.update.bind(lazyContainer),
        unbind: lazyContainer.unbind.bind(lazyContainer)
      });
    } else {
      Vue.directive('lazy', {
        bind: lazy.lazyLoadHandler.bind(lazy),
        update: function update(newValue, oldValue) {
          assignDeep(this.vm.$refs, this.vm.$els);
          lazy.add(this.el, {
            modifiers: this.modifiers || {},
            arg: this.arg,
            value: newValue,
            oldValue: oldValue
          }, {
            context: this.vm
          });
        },
        unbind: function unbind() {
          lazy.remove(this.el);
        }
      });

      Vue.directive('lazy-container', {
        update: function update(newValue, oldValue) {
          lazyContainer.update(this.el, {
            modifiers: this.modifiers || {},
            arg: this.arg,
            value: newValue,
            oldValue: oldValue
          }, {
            context: this.vm
          });
        },
        unbind: function unbind() {
          lazyContainer.unbind(this.el);
        }
      });
    }
  }
};




/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(81);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["default"],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_feed_reset_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0ff583_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_feed_reset_vue__ = __webpack_require__(386);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_feed_reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0ff583_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_feed_reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_feed_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a369816_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_feed_vue__ = __webpack_require__(399);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_feed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a369816_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d94564a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__(395);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d94564a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_data_download_button_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff0258a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_data_download_button_vue__ = __webpack_require__(387);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_data_download_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff0258a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_data_download_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fob_price_comparison_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_274332af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fob_price_comparison_vue__ = __webpack_require__(388);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-274332af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fob_price_comparison_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_274332af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fob_price_comparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_chart_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b13e41c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_chart_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b13e41c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b13e41c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_commodities_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ec80e99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_commodities_vue__ = __webpack_require__(392);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_commodities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ec80e99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_commodities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_partners_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ecd91c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_partners_vue__ = __webpack_require__(393);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_partners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ecd91c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_partners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_select_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fcb122d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_select_vue__ = __webpack_require__(397);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fcb122d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_tabs_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61c50a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_tabs_vue__ = __webpack_require__(404);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61c50a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_worldwide_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ce8a748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_worldwide_vue__ = __webpack_require__(401);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_market_data_worldwide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ce8a748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_data_worldwide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_filter_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f845f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_filter_vue__ = __webpack_require__(384);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f845f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_list_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5781052_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_list_vue__ = __webpack_require__(403);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5781052_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ml_card_feed_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b05468_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ml_card_feed_vue__ = __webpack_require__(389);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ml_card_feed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b05468_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ml_card_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ml_card_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a868ddc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ml_card_vue__ = __webpack_require__(396);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ml_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a868ddc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ml_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ml_news_item_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1622b40f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ml_news_item_vue__ = __webpack_require__(385);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ml_news_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1622b40f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ml_news_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766777b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__ = __webpack_require__(398);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766777b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_photo_gallery_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b974ed78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_photo_gallery_vue__ = __webpack_require__(402);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_photo_gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b974ed78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_photo_gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slick_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d65eb1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slick_vue__ = __webpack_require__(400);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slick_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d65eb1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slick_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57584aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tooltip_vue__ = __webpack_require__(394);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57584aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"mb-12"},[_c('strong',{staticClass:"mb-4 block uppercase text-base"},[_vm._v("Search by")]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('label',{staticClass:"heading-font text-sm uppercase font-normal mg-color-secondary-lighter",attrs:{"for":"Keyword"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"mg-form-control",attrs:{"type":"text"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('taxonomy-select',{attrs:{"label":"Commodity","taxonomy":"commodity"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('taxonomy-select',{attrs:{"label":"Type","taxonomy":"member_type"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-8"},[_c('taxonomy-select',{attrs:{"label":"Area of business","taxonomy":"member_area_of_business"}})],1),_vm._v(" "),_c('button',{staticClass:"mg-button--tertiary",attrs:{"type":"reset"},on:{"click":function($event){$event.preventDefault();_vm.reset($event)}}},[_vm._v("Reset")]),_vm._v(" "),_c('button',{on:{"click":function($event){$event.preventDefault();_vm.getMembers(true)}}},[_vm._v("Search")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"leading-tighter"},[_c('span',{staticClass:"heading-font text-sm uppercase font-normal mg-color-secondary-lighter"},[_vm._v(_vm._s(_vm.display_date))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.post.link}},[_c('span',{staticClass:"text-lg leading-tight"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"plain-button md:absolute md:mr-6 md:mt-6 mb-6 pin-t pin-r mg-color-accent-2 hover:mg-color-accent-2-light",on:{"click":function($event){$event.preventDefault();_vm.reset($event)}}},[_c('svg',{staticClass:"mg-icon mg-icon--medium"},[_c('use',{attrs:{"href":"#icon-reset","xlink:href":"#icon-reset"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{staticClass:"mg-button mg-button--large mg-button--accent md-chart-wrapper__download no-print",attrs:{"href":_vm.url,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n    Download Data\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-8 ui-has-state",class:{'ui-has-state--is-loading': _vm.isLoading}},[_c('h2',[_vm._v("FOB Price Comparison")]),_vm._v(" "),_c('div',{staticClass:"md:flex items-center mb-4 -mx-4 flex-wrap"},[_c('div',{staticClass:"ml-4 mb-2 lg:mx-4 lg:mb-4 text-sm w-full lg:w-auto"},[_vm._v("Select Comparison:")]),_vm._v(" "),_c('div',{staticClass:"mx-4 mt-0 mb-8 md:mb-4"},[_c('label',{staticClass:"visuallyhidden"},[_vm._v("Range")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.yearOption),expression:"yearOption"}],staticClass:"mg-form-control mg-select w-full rounded-lg",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.yearOption=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.chartDataSetup]}},_vm._l((_vm.rangeOptions),function(item,index){return _c('option',{key:index,domProps:{"value":item.value}},[_vm._v(_vm._s(item.text))])})),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-2 mg-color-accent-2"},[_c('svg',{staticClass:"fill-current h-8 w-8"},[_c('use',{attrs:{"href":"#icon-angle-down","xlink:href":"#icon-angle-down"}})])])])]),_vm._v(" "),_c('div',{staticClass:"mx-4 mt-0 mb-8 md:mb-4"},[_c('label',{staticClass:"visuallyhidden"},[_vm._v("Compare options")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.comparison),expression:"comparison"}],staticClass:"mg-form-control mg-select w-full rounded-lg",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.comparison=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateDatasets]}},_vm._l((_vm.compareOptions),function(item,index){return _c('option',{key:index,domProps:{"value":item.value}},[_vm._v(_vm._s(item.text))])})),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-2 mg-color-accent-2"},[_c('svg',{staticClass:"fill-current h-8 w-8"},[_c('use',{attrs:{"href":"#icon-angle-down","xlink:href":"#icon-angle-down"}})])])])])]),_vm._v(" "),_c('canvas',{attrs:{"id":"fob-price-compare-chart"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newsItems.length)?_c('div',{staticClass:"news-wrapper"},[(_vm.feedType == 'plain')?_c('div',_vm._l((_vm.newsItems),function(item){return _c('news-item',{key:item.ID,attrs:{"post":item}})})):_c('transition-group',{staticClass:"news-list-local",attrs:{"name":"feed-transition","tag":"div","enter-active-class":"animated fadeInUp","leave-active-class":"animated fadeOut"}},_vm._l((_vm.newsItems),function(item,index){return _c('card',{key:index,attrs:{"post":item}})})),_vm._v(" "),(_vm.moreToLoad && _vm.feedType != 'plain')?_c('div',{staticClass:"p-4 py-10 text-center antialiased"},[_c('button',{staticClass:"mg-button mg-button--accent px-6 uppercase",on:{"click":_vm.loadMoreArticles}},[_vm._v(_vm._s(_vm.loadMoreText))])]):_vm._e()],1):_c('div',{staticClass:"mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-center"},[(_vm.totalItemsFound == null)?_c('div',[_vm._v("\n            Loading news...\n        ")]):_c('div',[_vm._v("\n            Nothing found.\n        ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xl:flex print-break-avoid md-chart-wrapper__cols"},[_c('div',{staticClass:"xl:w-3/5 mb-6 xl:pr-8 mobile-order md-chart-wrapper__chart"},[_c('market-data-select',{attrs:{"type":_vm.type}}),_vm._v(" "),_c('h2',{staticClass:"pt-0 my-4"},[_vm._v("Marketing Year Total")]),_vm._v(" "),(_vm.type == 'commodities' && _vm.marketDataMode == 'USDA-data')?_c('div',{staticClass:"flex items-center text-xs md:text-sm my-8 no-print"},[_c('div',[_vm._v("Show Value (USD)")]),_vm._v(" "),_c('div',{staticClass:"mg-toggle mx-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qtyOption),expression:"qtyOption"}],attrs:{"id":"valueQtyToggle","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qtyOption)?_vm._i(_vm.qtyOption,null)>-1:(_vm.qtyOption)},on:{"change":function($event){var $$a=_vm.qtyOption,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qtyOption=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qtyOption=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qtyOption=$$c}}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',[_vm._v("Show Quantity ("+_vm._s(_vm.activeUnit)+")")])]):_vm._e(),_vm._v(" "),(_vm.type == 'top-export-partners')?_c('div',{staticClass:"hidden xl:flex items-center text-xs md:text-sm my-8 no-print"},[_c('div',[_vm._v("Hide Dollar Values")]),_vm._v(" "),_c('div',{staticClass:"mg-toggle mx-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dollarsOption),expression:"dollarsOption"}],attrs:{"id":"dollarToggle","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.dollarsOption)?_vm._i(_vm.dollarsOption,null)>-1:(_vm.dollarsOption)},on:{"change":function($event){var $$a=_vm.dollarsOption,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.dollarsOption=$$a.concat([$$v]))}else{$$i>-1&&(_vm.dollarsOption=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.dollarsOption=$$c}}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',[_vm._v("Show Dollar Values")])]):_vm._e(),_vm._v(" "),_c('canvas',{staticClass:"mt-8 mb-4",attrs:{"id":"market-data-chart"}}),_vm._v(" "),((_vm.activeMarket || _vm.topTenMarkets.length) && _vm.export_totals)?_c('div',{staticClass:"hidden md:block mt-2 mb-8 text-xs ml-4 font-semibold md-chart-wrapper__legend"},[_vm._l((_vm.activeChartItems),function(item,index){return (_vm.type == 'commodities' && _vm.activeMarket[item])?_c('div',{key:index,staticClass:"flex -mr-4"},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"w-1/5"},[_c('div',{staticClass:"p-1 relative border",class:{'border-r-0': i != 5},style:({'border-color': _vm.legendItemColor(item)})},[_c('div',{staticClass:"pin absolute opacity-25",style:({'background-color': _vm.legendItemColor(item)})}),_vm._v(" "),_c('span',{staticClass:"no-print round w-2 h-2 inline-block mr-1",style:({'background-color': _vm.legendItemColor(item)})}),_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.activeMarket[item][("year_" + i + "_quantity")]))+"\n                        "),_c('br'),_vm._v(" "),_c('span',{staticClass:"no-print round w-2 h-2 inline-block mr-1",style:({'background-color': _vm.legendItemColor(item)})}),_vm._v("\n                        $"+_vm._s(_vm.formatNumber(_vm.activeMarket[item][("year_" + i + "_value")]))+"\n                    ")])])})):_vm._e()}),_vm._v(" "),(_vm.type == 'top-export-partners' && _vm.activeChartItems.indexOf('World Total') > -1)?_c('div',{staticClass:"flex -mr-4"},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"w-1/5"},[_c('div',{staticClass:"p-1 relative border",class:{'border-r-0': i != 5},style:({'border-color': _vm.legendItemColor('World Total')})},[_c('div',{staticClass:"pin absolute opacity-25",style:({'background-color': _vm.legendItemColor('World Total')})}),_vm._v(" "),_c('span',{staticClass:"no-print round w-2 h-2 inline-block mr-1",style:({'background-color': _vm.legendItemColor('World Total')})}),_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected][("year_" + i + "_quantity")]))+"\n                        "),_c('br'),_vm._v(" "),_c('span',{staticClass:"no-print round w-2 h-2 inline-block mr-1",style:({'background-color': _vm.legendItemColor('World Total')})}),_vm._v("\n                        $"+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected][("year_" + i + "_value")]))+"\n                    ")])])})):_vm._e(),_vm._v(" "),_vm._l((_vm.topTenMarkets),function(item,index){return (_vm.type == 'top-export-partners' && _vm.activeChartItems.indexOf(item.market_name) > -1)?_c('div',{key:index,staticClass:"flex -mr-4"},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"w-1/5"},[_c('div',{staticClass:"p-1 relative border",class:{'border-r-0': i != 5},style:({'border-color': _vm.legendItemColor(item.market_name)})},[_c('div',{staticClass:"pin absolute opacity-25",style:({'background-color': _vm.legendItemColor(item.market_name)})}),_vm._v(" "),_c('span',{staticClass:"no-print round w-2 h-2 inline-block mr-1",style:({'background-color': _vm.legendItemColor(item.market_name)})}),_vm._v("\n                        "+_vm._s(_vm.formatNumber(item[_vm.top_exports_selected][("year_" + i + "_quantity")]))+"\n                        "),_c('br'),_vm._v(" "),_c('span',{staticClass:"no-print round w-2 h-2 inline-block mr-1",style:({'background-color': _vm.legendItemColor(item.market_name)})}),_vm._v("\n                        $"+_vm._s(_vm.formatNumber(item[_vm.top_exports_selected][("year_" + i + "_value")]))+"\n                    ")])])})):_vm._e()})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"flex-1"},[(_vm.type == 'commodities')?_c('market-data-commodities',{attrs:{"data":_vm.activeMarket}}):_vm._e(),_vm._v(" "),(_vm.type == 'top-export-partners')?_c('market-data-partners'):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"valueQtyToggle"}},[_c('span',{staticClass:"invisible"},[_vm._v("Show export quantities?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"dollarToggle"}},[_c('span',{staticClass:"invisible"},[_vm._v("Show dollar values?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taxonomyItems.length)?_c('div',[_c('label',{staticClass:"heading-font text-sm uppercase font-normal mg-color-secondary-lighter",attrs:{"for":_vm.taxonomy}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"mg-form-control mg-select w-full rounded-lg",attrs:{"id":_vm.taxonomy},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.selectChange]}},[_c('option',{attrs:{"value":""}},[_vm._v("select")]),_vm._v(" "),_vm._l((_vm.taxonomyItems),function(item,index){return _c('option',{key:index,domProps:{"value":item.id}},[_c('span',{domProps:{"innerHTML":_vm._s(item.name)}})])})],2),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-2 mg-color-accent-2"},[_c('svg',{staticClass:"fill-current h-8 w-8"},[_c('use',{attrs:{"href":"#icon-angle-down","xlink:href":"#icon-angle-down"}})])])])]):_c('div',{staticClass:"mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-sm"},[_vm._v("\n    loading options...\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('table',{staticClass:"mg-table-market-data-interactive text-sm heading-font border-separate"},[_c('thead',[_c('tr',{staticClass:"uppercase antialiased text-sm text-white tracking-medium border-b-0"},[_c('th',{staticClass:"border-b-0 hidden xl:table-cell md-chart-wrapper__label-cell"}),_vm._v(" "),_c('th',{staticClass:"border-b-0 font-normal p-0 xl:w-36 mg-banded-primary-darker",attrs:{"scope":"col"}},[_c('span',{staticClass:"block px-4 py-2"},[_vm._v("Previous Market Year ("+_vm._s(_vm.marketDataSettings.previous_market_year_label)+")")])]),_vm._v(" "),_c('th',{staticClass:"border-b-0 font-normal p-0 xl:w-36 mg-banded-primary",attrs:{"scope":"col"}},[_c('span',{staticClass:"px-4 py-2 block"},[_vm._v("Current Market Year ("+_vm._s(_vm.marketDataSettings.current_market_year_label)+")")])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.sortedMarketInfo),function(val,key,index){return (_vm.isCommodity(key) && _vm.displayRow(key))?_c('tr',{key:index,staticClass:"border-0 tracking-medium text-sm md:text-base",class:[
        {'mg-table-market-data-interactive__all-row': index == 0}]},[_c('td',{staticClass:"p-0 hidden xl:table-cell relative button-cell md-chart-wrapper__label-cell",style:({'background-color': _vm.getCommodityProperty({key: key, property: 'color'})})},[_c('div',{staticClass:"cell-inner-wrap"},[_c('button',{staticClass:"plain-button rounded-none antialiased text-left cell-inner p-2 absolute pin flex items-center button-cell__button",class:[{active: _vm.activeCommodities.indexOf(key) > -1}],on:{"click":function($event){_vm.trigger(key)}}},[_c('svg',{staticClass:"mg-icon mg-icon--medium button-cell__mg-icon absolute",class:[{'filter-shadow-sm': _vm.activeCommodities.indexOf(key) > -1}, {'mg-color-accent-2': _vm.activeCommodities.indexOf(key) == -1}]},[_c('use',{attrs:{"href":"#" + _vm.getCommodityProperty({key: key, property: "icon"}),"xlink:href":"#" + _vm.getCommodityProperty({key: key, property: "icon"})}})]),_vm._v(" "),_c('span',{staticClass:"text-base leading-none font-bold",class:[{'text-shadow-sm': _vm.activeCommodities.indexOf(key) > -1}],domProps:{"innerHTML":_vm._s(_vm.getCommodityProperty({key: key, property: 'text'}))}})])])]),_vm._v(" "),_c('td',{staticClass:"p-0 border-l-8 border-r-8 mg-border-primary-darker align-bottom"},[_c('div',{staticClass:"cell-inner p-2"},[(!_vm.isUsdaAllRow(key))?_c('div',[_vm._v("\n                        "+_vm._s(_vm.formatNumber(val.previous_market_year_quantity))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n                        $"+_vm._s(_vm.formatNumber(val.previous_market_year_value))+"\n                    ")])])]),_vm._v(" "),_c('td',{staticClass:"p-0 border-l-8 border-r-8 mg-border-primary"},[_c('div',{staticClass:"cell-inner p-2 relative"},[_c('div',{staticClass:"md-chart-wrapper__change-wrap",class:{'pr-8': !_vm.isUsdaAllRow(key), 'text-right': _vm.isUsdaAllRow(key)}},[_c('div',{staticClass:"pin-t pin-r mt-1 text-xs md-chart-wrapper__change-content",class:{'success-color': val.change > 0, 'error-color': val.change <= 0, 'absolute': !_vm.isUsdaAllRow(key), 'mr-1': !_vm.isUsdaAllRow(key)}},[(_vm.getPercent(val.change) != 'N/A')?_c('svg',{staticClass:"mg-icon"},[_c('use',{attrs:{"href":_vm.getArrowName(val.change),"xlink:href":_vm.getArrowName(val.change)}})]):_vm._e(),_vm._v(" "+_vm._s(_vm.getPercent(val.change))+"\n                        ")]),_vm._v(" "),(!_vm.isUsdaAllRow(key))?_c('div',[_vm._v(_vm._s(_vm.formatNumber(val.current_market_year_quantity)))]):_vm._e()]),_vm._v(" "),_c('div',[_vm._v("\n                        $"+_vm._s(_vm.formatNumber(val.current_market_year_value))+"\n                    ")])])])]):_vm._e()}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.topTenMarkets.length)?_c('table',{staticClass:"mg-table-market-data-interactive text-sm heading-font border-separate"},[_c('thead',[_c('tr',{staticClass:"uppercase antialiased text-sm text-white tracking-medium border-b-0"},[_c('th',{staticClass:"border-b-0 hidden xl:table-cell md-chart-wrapper__label-cell"}),_vm._v(" "),_c('th',{staticClass:"border-b-0 font-normal p-0 xl:w-36 mg-banded-primary-darker",attrs:{"scope":"col"}},[_c('span',{staticClass:"block px-4 py-2"},[_vm._v("Previous Market Year ("+_vm._s(_vm.marketDataSettings.previous_market_year_label)+")")])]),_vm._v(" "),_c('th',{staticClass:"border-b-0 font-normal p-0 xl:w-36 mg-banded-primary",attrs:{"scope":"col"}},[_c('span',{staticClass:"px-4 py-2 block"},[_vm._v("Current Market Year ("+_vm._s(_vm.marketDataSettings.current_market_year_label)+")")])])])]),_vm._v(" "),_c('tbody',[(_vm.export_totals && _vm.displayRow('World Total'))?_c('tr',{staticClass:"border-0 tracking-medium text-sm md:text-base mg-table-market-data-interactive__all-row"},[_c('td',{staticClass:"p-0 hidden xl:table-cell relative button-cell md-chart-wrapper__label-cell",style:({'background-color': _vm.colors[0]})},[_c('div',{staticClass:"cell-inner-wrap"},[_c('button',{staticClass:"plain-button rounded-none antialiased text-center cell-inner p-2 absolute pin",class:[{active: _vm.activePartners.indexOf('World Total') > -1}],on:{"click":function($event){_vm.trigger('World Total')}}},[_c('span',{staticClass:"text-base leading-none font-bold",class:[{'text-shadow-sm': _vm.activePartners.indexOf('World Total') > -1}]},[_vm._v("World Total")])])])]),_vm._v(" "),_c('td',{staticClass:"p-0 border-l-8 border-r-8 mg-border-primary-darker align-bottom"},[_c('div',{staticClass:"cell-inner p-2"},[_c('div',[_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['previous_market_year_quantity']))+"\n                    ")]),_vm._v(" "),_c('span',{class:{'visible': _vm.showDollars, 'invisible': !_vm.showDollars}},[_vm._v("$")]),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showDollars)?_c('span',[_vm._v(_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['previous_market_year_value'])))]):_vm._e()])],1)]),_vm._v(" "),_c('td',{staticClass:"p-0 border-l-8 border-r-8 mg-border-primary"},[_c('div',{staticClass:"cell-inner p-2 relative"},[_c('div',{staticClass:"pr-8"},[_c('div',{staticClass:"absolute pin-t pin-r mt-1 mr-1 text-xs md-chart-wrapper__change",class:{'success-color': _vm.export_totals[_vm.top_exports_selected]['change'] > 0, 'error-color': _vm.export_totals[_vm.top_exports_selected]['change'] <= 0}},[(_vm.getPercent(_vm.export_totals[_vm.top_exports_selected]['change']) != 'N/A')?_c('svg',{staticClass:"mg-icon"},[_c('use',{attrs:{"href":_vm.getArrowName(_vm.export_totals[_vm.top_exports_selected]['change']),"xlink:href":_vm.getArrowName(_vm.export_totals[_vm.top_exports_selected]['change'])}})]):_vm._e(),_vm._v(" "+_vm._s(_vm.getPercent(_vm.export_totals[_vm.top_exports_selected]['change']))+"\n                        ")]),_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['current_market_year_quantity']))+"\n                    ")]),_vm._v(" "),_c('span',{class:{'visible': _vm.showDollars, 'invisible': !_vm.showDollars}},[_vm._v("$")]),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showDollars)?_c('span',[_vm._v(_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['current_market_year_value'])))]):_vm._e()])],1)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.topTenMarkets),function(partner,index){return (partner[_vm.top_exports_selected] && _vm.displayRow(partner.market_name))?_c('tr',{key:index,staticClass:"border-0 tracking-medium text-sm md:text-base",class:[
        {'mg-table-market-data-interactive__all-row': index == 0}]},[_c('td',{staticClass:"p-0 hidden xl:table-cell relative button-cell md-chart-wrapper__label-cell",style:({'background-color': _vm.colors[index + 1]})},[_c('div',{staticClass:"cell-inner-wrap"},[_c('button',{staticClass:"plain-button rounded-none antialiased text-left cell-inner p-2 absolute pin flex items-center button-cell__button",class:[{active: _vm.activePartners.indexOf(partner.market_name) > -1}],on:{"click":function($event){_vm.trigger(partner.market_name)}}},[_c('span',{staticClass:"w-8 h-8 flag-icon button-cell__mg-icon absolute",class:("flag-icon-" + (_vm.handleCountryCode(partner.market_code)))}),_vm._v(" "),_c('span',{staticClass:"text-base leading-none font-bold",class:[{'text-shadow-sm': _vm.activePartners.indexOf(partner.market_name) > -1}]},[_vm._v(_vm._s(partner.market_name))])])])]),_vm._v(" "),_c('td',{staticClass:"p-0 border-l-8 border-r-8 mg-border-primary-darker align-bottom"},[_c('div',{staticClass:"cell-inner p-2"},[_c('div',[_vm._v("\n                        "+_vm._s(_vm.formatNumber(partner[_vm.top_exports_selected]['previous_market_year_quantity']))+"\n                    ")]),_vm._v(" "),_c('span',{class:{'visible': _vm.showDollars, 'invisible': !_vm.showDollars}},[_vm._v("$")]),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showDollars)?_c('span',[_vm._v(_vm._s(_vm.formatNumber(partner[_vm.top_exports_selected]['previous_market_year_value'])))]):_vm._e()])],1)]),_vm._v(" "),_c('td',{staticClass:"p-0 border-l-8 border-r-8 mg-border-primary"},[_c('div',{staticClass:"cell-inner p-2 relative"},[_c('div',{staticClass:"pr-8"},[_c('div',{staticClass:"absolute pin-t pin-r mt-1 mr-1 text-xs md-chart-wrapper__change",class:{'success-color': partner[_vm.top_exports_selected]['change'] > 0, 'error-color': partner[_vm.top_exports_selected]['change'] <= 0}},[(_vm.getPercent(partner[_vm.top_exports_selected]['change']) != 'N/A')?_c('svg',{staticClass:"mg-icon"},[_c('use',{attrs:{"href":_vm.getArrowName(partner[_vm.top_exports_selected]['change']),"xlink:href":_vm.getArrowName(partner[_vm.top_exports_selected]['change'])}})]):_vm._e(),_vm._v(" "+_vm._s(_vm.getPercent(partner[_vm.top_exports_selected]['change']))+"\n                        ")]),_vm._v("\n                        "+_vm._s(_vm.formatNumber(partner[_vm.top_exports_selected]['current_market_year_quantity']))+"\n                    ")]),_vm._v(" "),_c('span',{class:{'visible': _vm.showDollars, 'invisible': !_vm.showDollars}},[_vm._v("$")]),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showDollars)?_c('span',[_vm._v(_vm._s(_vm.formatNumber(partner[_vm.top_exports_selected]['current_market_year_value'])))]):_vm._e()])],1)])]):_vm._e()})],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',{staticClass:"relative",on:{"click":_vm.toggle}},[_c('svg',{staticClass:"mg-icon mg-color-primary-lighter ml-2"},[_c('use',{attrs:{"href":"#icon-info","xlink:href":"#icon-info"}})]),_vm._v(" "),_c('div',{staticClass:"tooltip animated fadeInUp shade-heavier--primary-darker text-white p-6 text-base absolute pin-r p-2 rounded-lg antialiased leading-tighter w-48 z-50 base-font",class:[{hidden: _vm.disabled}]},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mg-grid__item"},[_c('article',{staticClass:"mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg"},[(_vm.post.mg_main_image)?_c('a',{attrs:{"href":_vm.post.mg_permalink}},[_c('img',{staticClass:"mb-4 block",attrs:{"src":_vm.post.mg_main_image.sizes.large,"alt":_vm.post.mg_main_image.alt ? _vm.post.mg_main_image.alt : _vm.post.mg_main_image.title}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('h3',{staticClass:"text-lg tracking-medium leading-tight mb-6"},[_c('a',{staticClass:"plain-link",attrs:{"href":_vm.post.mg_permalink}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"entry-meta"},[_c('ul',{staticClass:"list-reset flex mb-4 heading-font text-sm font-medium"},[(_vm.news_type && (_vm.news_type !== 'Uncategorized'))?_c('li',{staticClass:"font-medium"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.news_type)}})]):_vm._e(),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.display_date))])])]),_vm._v(" "),_c('p',{staticClass:"text-grey-darker text-base"},[_vm._v("\n                "+_vm._s(_vm.summary)+"\n                "),_c('a',{staticClass:"uppercase text-sm",attrs:{"href":_vm.post.mg_permalink}},[_vm._v("Read more »")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-item"},[_c('article',{staticClass:"mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg"},[(_vm.post.acf.has_main_image)?_c('img',{staticClass:"card-image",attrs:{"src":_vm.post.acf.main_image.sizes.medium,"alt":_vm.post.acf.main_image.alt}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"my-2"},[_c('span',{staticClass:"my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter"},[_vm._v("\n                "+_vm._s(_vm.display_date)+"                    \n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"card-item__title",attrs:{"href":_vm.post.link}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-item__summary"},[_c('span',[_vm._v(_vm._s(_vm.summary))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.post.link}},[_vm._v("Read More» ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:flex"},[_c('form',{staticClass:"flex-1 mb-8 md:pr-4 xl:pr-0"},[_c('label',{staticClass:"heading-font text-sm uppercase font-normal mg-color-secondary-lighter"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"relative"},[(_vm.options.length)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"mg-form-control mg-select w-full rounded-lg",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleActiveData]}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_c('span',{domProps:{"innerHTML":_vm._s(option.text)}})])})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-2 mg-color-accent-2"},[_c('svg',{staticClass:"fill-current h-8 w-8"},[_c('use',{attrs:{"href":"#icon-angle-down","xlink:href":"#icon-angle-down"}})])])])]),_vm._v(" "),(_vm.type == 'commodities' && _vm.activeMarket)?_c('form',{staticClass:"md:w-1/2 mb-8 xl:hidden md:pl-4"},[_c('label',{staticClass:"heading-font text-sm uppercase font-normal mg-color-secondary-lighter"},[_vm._v("Filter by commodity")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCommodity),expression:"selectedCommodity"}],staticClass:"mg-form-control mg-select w-full rounded-lg",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCommodity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.activateSingleCommodity(_vm.selectedCommodity)}]}},_vm._l((_vm.sortedMarketInfo),function(val,key,index){return (_vm.isCommodity(key))?_c('option',{key:index,domProps:{"value":key}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getCommodityProperty({key: key, property: 'text'}))}})]):_vm._e()})),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-2 mg-color-accent-2"},[_c('svg',{staticClass:"fill-current h-8 w-8"},[_c('use',{attrs:{"href":"#icon-angle-down","xlink:href":"#icon-angle-down"}})])])])]):_vm._e(),_vm._v(" "),(_vm.type == 'top-export-partners' && _vm.topTenMarkets.length)?_c('form',{staticClass:"md:w-1/2 mb-8 xl:hidden md:pl-4"},[_c('label',{staticClass:"heading-font text-sm uppercase font-normal mg-color-secondary-lighter"},[_vm._v("Filter by country")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPartner),expression:"selectedPartner"}],staticClass:"mg-form-control mg-select w-full rounded-lg",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedPartner=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.activateSinglePartner(_vm.selectedPartner)}]}},[_c('option',{attrs:{"value":"World Total"}},[_vm._v("World Total")]),_vm._v(" "),_vm._l((_vm.topTenMarkets),function(market,index){return _c('option',{key:index,domProps:{"value":market.market_name}},[_c('span',{domProps:{"innerHTML":_vm._s(market.market_name)}})])})],2),_vm._v(" "),_c('div',{staticClass:"pointer-events-none absolute pin-y pin-r flex items-center px-2 mg-color-accent-2"},[_c('svg',{staticClass:"fill-current h-8 w-8"},[_c('use',{attrs:{"href":"#icon-angle-down","xlink:href":"#icon-angle-down"}})])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination plain-links w-full p-0"},_vm._l((_vm.paginationNumbers),function(pageNumber,index){return _c('li',{key:index,class:{active: _vm.current_page === pageNumber}},[_c('a',{class:{last: (pageNumber == _vm.totalPages && Math.abs(pageNumber - _vm.current_page) > 3), first:(pageNumber == 1 && Math.abs(pageNumber - _vm.current_page) > 3)},attrs:{"href":"#"},on:{"click":function($event){_vm.paginationClick(pageNumber)}}},[_vm._v(_vm._s(pageNumber))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newsItems.length)?_c('div',[_c('transition-group',{staticClass:"mg-grid",attrs:{"name":"feed-transition","tag":"div","enter-active-class":"animated fadeInUp","leave-active-class":"animated fadeOut"}},_vm._l((_vm.newsItems),function(item,index){return _c('card',{key:index,attrs:{"post":item}})})),_vm._v(" "),(_vm.moreToLoad)?_c('div',{staticClass:"p-4 py-10 text-center antialiased"},[_c('button',{staticClass:"mg-button mg-button--accent px-6 uppercase",on:{"click":_vm.loadMoreArticles}},[_vm._v("Load More")])]):_vm._e()],1):_c('div',{staticClass:"mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-center"},[(_vm.totalItemsFound == null)?_c('div',[_vm._v("\n            Loading news...\n        ")]):_c('div',[_vm._v("\n            Nothing found.\n        ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mg-carousel"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"mb-0 block mg-button mg-button--larger text-center w-full",on:{"click":_vm.toggle}},[_c('span',{staticClass:"w-full flex items-center justify-center block"},[_c('span',{staticClass:"block",domProps:{"innerHTML":_vm._s(_vm.buttonIcon)}}),_vm._v(" "),_c('span',{staticClass:"block"},[_vm._v(_vm._s(_vm.buttonVerb)+" Worldwide Data")]),_vm._v(" "),_c('span',{staticClass:"block",domProps:{"innerHTML":_vm._s(_vm.buttonIcon)}})])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.enabled)?_c('div',{staticClass:"flex xl:hidden items-center text-xs md:text-sm my-8 no-print"},[_c('div',[_vm._v("Hide Dollar Values")]),_vm._v(" "),_c('div',{staticClass:"mg-toggle mx-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dollarsOption),expression:"dollarsOption"}],attrs:{"id":"dollarToggle2","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.dollarsOption)?_vm._i(_vm.dollarsOption,null)>-1:(_vm.dollarsOption)},on:{"change":function($event){var $$a=_vm.dollarsOption,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.dollarsOption=$$a.concat([$$v]))}else{$$i>-1&&(_vm.dollarsOption=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.dollarsOption=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"dollarToggle2"}},[_c('span',{staticClass:"invisible"},[_vm._v("Show dollar values?")])])]),_vm._v(" "),_c('div',[_vm._v("Show Dollar Values")])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('div',{staticClass:"table-market-data-worldwide-wrap overflow-x-scroll -mt-2"},[(_vm.enabled)?_c('table',{staticClass:"mb-0 text-sm heading-font striped border-separate border-b table-market-data-worldwide"},[_c('thead',[_c('tr',{staticClass:"uppercase antialiased text-sm text-white tracking-medium border-b-0"},[_c('th',{staticClass:"border-b-0 border-r mg-border-screen-lightest font-normal w-36 px-0 pt-4 pb-1 text-right mg-banded-accent-2",attrs:{"scope":"col"}},[_c('span',{staticClass:"px-6 block"},[_vm._v("U.S. Export PARTNERS IN ("+_vm._s(_vm.units)+")")])]),_vm._v(" "),_c('th',{staticClass:"border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2",attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.marketYear - 6)+"/"+_vm._s(_vm.marketYear - 5))]),_vm._v(" "),_c('th',{staticClass:"border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2",attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.marketYear - 5)+"/"+_vm._s(_vm.marketYear - 4))]),_vm._v(" "),_c('th',{staticClass:"border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2",attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.marketYear - 4)+"/"+_vm._s(_vm.marketYear - 3))]),_vm._v(" "),_c('th',{staticClass:"border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2",attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.marketYear - 3)+"/"+_vm._s(_vm.marketYear - 2))]),_vm._v(" "),_c('th',{staticClass:"border-b-0 border-r mg-border-screen-lightest font-normal px-6 pt-4 pb-1 text-center mg-banded-accent-2",attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.marketYear - 2)+"/"+_vm._s(_vm.marketYear - 1))]),_vm._v(" "),_c('th',{staticClass:"border-b-0 font-normal px-4 pt-4 pb-2 w-36 mg-banded-primary-darker",attrs:{"scope":"col"}},[_vm._v("Previous Market Year ("+_vm._s(_vm.marketDataSettings.previous_market_year_label)+")")]),_vm._v(" "),_c('th',{staticClass:"border-b-0 font-normal p-0 w-36 mg-banded-primary",attrs:{"scope":"col"}},[_c('span',{staticClass:"px-4 pt-4 pb-2 block"},[_vm._v("Current Market Year ("+_vm._s(_vm.marketDataSettings.current_market_year_label)+")")])])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.market_data),function(market,index){return (market[_vm.top_exports_selected] && market[_vm.top_exports_selected]['current_market_year_quantity'] != null)?_c('tr',{key:index,staticClass:"border-0 tracking-medium text-base"},[_c('th',{staticClass:"mg-banded-secondary-lighter text-white heading-font uppercase text-right font-normal mg-border-secondary border-b antialiased",attrs:{"scope":"row"}},[_c('span',{staticClass:"px-2"},[_vm._v(_vm._s(market['market_name']))])]),_vm._v(" "),_vm._l((5),function(i){return _c('td',{key:i,staticClass:"py-2 px-4"},[_c('div',[_vm._v(_vm._s(_vm.formatNumber(market[_vm.top_exports_selected][("year_" + i + "_quantity")])))]),_vm._v(" "),(_vm.showDollars)?_c('div',[_vm._v("$"+_vm._s(_vm.formatNumber(market[_vm.top_exports_selected][("year_" + i + "_value")])))]):_vm._e()])}),_vm._v(" "),_c('td',{staticClass:"py-2 px-4 border-l-8 border-r-8 mg-border-primary-darker align-bottom"},[_c('div',[_vm._v("\n                                    "+_vm._s(_vm.formatNumber(market[_vm.top_exports_selected]['previous_market_year_quantity']))+"\n                                ")]),_vm._v(" "),(_vm.showDollars)?_c('div',[_vm._v("\n                                    $"+_vm._s(_vm.formatNumber(market[_vm.top_exports_selected]['previous_market_year_value']))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"py-2 px-4 border-l-8 border-r-8 mg-border-primary"},[_c('div',{staticClass:"pr-8 relative"},[_c('div',{staticClass:"absolute pin-t pin-r -mt-1 mr-1 text-xs",class:{'success-color': market[_vm.top_exports_selected]['change'] > 0, 'error-color': market[_vm.top_exports_selected]['change'] <= 0}},[(_vm.getPercent(market[_vm.top_exports_selected]['change']) != 'N/A')?_c('svg',{staticClass:"mg-icon"},[_c('use',{attrs:{"href":_vm.getArrowName(market[_vm.top_exports_selected]['change']),"xlink:href":_vm.getArrowName(market[_vm.top_exports_selected]['change'])}})]):_vm._e(),_vm._v(" "+_vm._s(_vm.getPercent(market[_vm.top_exports_selected]['change']))+"\n                                    ")]),_vm._v("\n\n                                    "+_vm._s(_vm.formatNumber(market[_vm.top_exports_selected]['current_market_year_quantity']))+"\n                                ")]),_vm._v(" "),(_vm.showDollars)?_c('div',[_vm._v("\n                                    $"+_vm._s(_vm.formatNumber(market[_vm.top_exports_selected]['current_market_year_value']))+"\n                                ")]):_vm._e()])],2):_vm._e()}),_vm._v(" "),(_vm.export_totals)?_c('tr',{staticClass:"border-0 tracking-medium text-base"},[_c('th',{staticClass:"mg-banded-secondary text-white heading-font uppercase text-right font-medium antialiased",attrs:{"scope":"row"}},[_c('span',{staticClass:"px-2"},[_vm._v("World Total")])]),_vm._v(" "),_vm._l((5),function(i){return _c('td',{key:i,staticClass:"py-2 px-4"},[_c('div',[_vm._v(_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected][("year_" + i + "_quantity")])))]),_vm._v(" "),(_vm.showDollars)?_c('div',[_vm._v("$"+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected][("year_" + i + "_value")])))]):_vm._e()])}),_vm._v(" "),_c('td',{staticClass:"py-2 px-4 border-l-8 border-r-8 border-b-8 mg-border-primary-darker"},[_c('div',[_vm._v("\n                                    "+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['previous_market_year_quantity']))+"\n                                ")]),_vm._v(" "),(_vm.showDollars)?_c('div',[_vm._v("\n                                    $"+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['previous_market_year_value']))+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"py-2 px-4 border-l-8 border-r-8 border-b-8 mg-border-primary"},[_c('div',[_vm._v("\n                                    "+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['current_market_year_quantity']))+"\n                                ")]),_vm._v(" "),(_vm.showDollars)?_c('div',[_vm._v("\n                                    $"+_vm._s(_vm.formatNumber(_vm.export_totals[_vm.top_exports_selected]['current_market_year_value']))+"\n                                ")]):_vm._e()])],2):_vm._e()],2)]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mg-carousel mg-carousel--single",attrs:{"aria-hidden":"true"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.members.length)?_c('div',[_c('transition-group',{attrs:{"name":"feed-transition","tag":"div","enter-active-class":"animated fadeInUp","leave-active-class":"animated fadeOutDown"}},_vm._l((_vm.members),function(item,index){return _c('div',{key:index,staticClass:"md:flex mb-12"},[_c('div',{staticClass:"md:w-32"},[(item.logo)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.logo.sizes.medium),expression:"item.logo.sizes.medium"}],staticClass:"mb-2 p-4 border bg-white",attrs:{"alt":item.logo.alt}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex-1 md:pl-6 text-base"},[_c('h2',{staticClass:"mb-2",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.address))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.address_line_2))]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_vm._v(_vm._s(item.city)+", "+_vm._s(item.state)+" "+_vm._s(item.zip_code))]),_vm._v(" "),(item.website || item.phone)?_c('div',{staticClass:"mb-4"},[(item.website)?_c('div',[_c('a',{attrs:{"href":_vm.checkSiteValue(item.website)}},[_vm._v(_vm._s(item.website))])]):_vm._e(),_vm._v(" "),(item.phone)?_c('div',[_vm._v("p: "+_vm._s(item.phone))]):_vm._e()]):_vm._e(),_vm._v(" "),(item.member_type_display)?_c('div',[_c('strong',[_vm._v("Member Type:")]),_vm._v(" "+_vm._s(item.member_type_display)+"\n                    ")]):_vm._e(),_vm._v(" "),(item.member_area_of_business_display)?_c('div',[_c('strong',[_vm._v("Area of business:")]),_vm._v(" "+_vm._s(item.member_area_of_business_display)+"\n                    ")]):_vm._e(),_vm._v(" "),(item.business_contact)?_c('div',{staticClass:"mt-4"},[_c('strong',[_vm._v("Business Contact")]),_vm._v(" "),_c('div',{staticClass:"remove-p-margins mt-4",domProps:{"innerHTML":_vm._s(item.business_contact)}})]):_vm._e()])])}))],1):_c('div',{staticClass:"mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-center"},[(_vm.totalItemsFound == null)?_c('div',[_vm._v("\n            Loading members...\n        ")]):_c('div',[_vm._v("\n            Nothing found.\n        ")])]),_vm._v(" "),(_vm.membersPaginated)?_c('pagination'):_vm._e(),_vm._v(" "),(_vm.membersPaginated)?_c('button',{staticClass:"my-8",on:{"click":function($event){$event.preventDefault();_vm.paginationToggle($event)}}},[_vm._v("View all")]):_vm._e(),_vm._v(" "),(!_vm.membersPaginated)?_c('button',{staticClass:"my-8",on:{"click":function($event){$event.preventDefault();_vm.paginationToggle($event)}}},[_vm._v("Paginate")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mg-tabs flex list-reset bg-white ui-has-state",class:[{'ui-has-state--is-loading': _vm.marketDataIsLoading}]},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,staticClass:"w-1/2 z-20",on:{"click":function($event){_vm.tabClick(index)}}},[_c('button',{staticClass:"h-full hover:bg-white block rounded-none w-full border-t-8 mg-border-accent-2 heading-font text-lg md:text-2xl plain-button p-4 md:p-6 mg-color-secondary opacity-75 text-left sm:text-center",class:[
                {'bg-white': _vm.selected == index}, 
                {'opacity-100': _vm.selected == index},
                {'mg-banded-secondary-lightest': _vm.selected != index}
            ]},[_vm._v(_vm._s(tab.label)),(tab.info)?_c('tooltip',{attrs:{"text":tab.info}}):_vm._e()],1)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(245);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(173)("6b24c376", content, true);

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(246);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(173)("44e514f9", content, true);

/***/ }),
/* 407 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
],[199]);


// WEBPACK FOOTER //
// site.js